(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-coroutines-core.js', './kotlinx-serialization-kotlinx-serialization-json-js-ir.js', './projects-core-koin-core.js', './kotlinx-serialization-kotlinx-serialization-core.js', './Kotlin-DateTime-library-kotlinx-datetime.js', './ktor-ktor-http.js', './ktor-ktor-client-core.js', './ktor-ktor-utils.js', './kotlinx-html.js', './Napier-napier-js-ir.js', './ktor-ktor-client-content-negotiation.js', './ktor-ktor-client-logging.js', './ktor-ktor-serialization-kotlinx-json.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-coroutines-core.js'), require('./kotlinx-serialization-kotlinx-serialization-json-js-ir.js'), require('./projects-core-koin-core.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./Kotlin-DateTime-library-kotlinx-datetime.js'), require('./ktor-ktor-http.js'), require('./ktor-ktor-client-core.js'), require('./ktor-ktor-utils.js'), require('./kotlinx-html.js'), require('./Napier-napier-js-ir.js'), require('./ktor-ktor-client-content-negotiation.js'), require('./ktor-ktor-client-logging.js'), require('./ktor-ktor-serialization-kotlinx-json.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'kmp-mentions:shared'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'kmp-mentions:shared'.");
    }
    if (typeof this['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'kmp-mentions:shared'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'kmp-mentions:shared'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-json-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'kmp-mentions:shared'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json-js-ir' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json-js-ir' is loaded prior to 'kmp-mentions:shared'.");
    }
    if (typeof this['projects-core-koin-core'] === 'undefined') {
      throw new Error("Error loading module 'kmp-mentions:shared'. Its dependency 'projects-core-koin-core' was not found. Please, check whether 'projects-core-koin-core' is loaded prior to 'kmp-mentions:shared'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'kmp-mentions:shared'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'kmp-mentions:shared'.");
    }
    if (typeof this['Kotlin-DateTime-library-kotlinx-datetime'] === 'undefined') {
      throw new Error("Error loading module 'kmp-mentions:shared'. Its dependency 'Kotlin-DateTime-library-kotlinx-datetime' was not found. Please, check whether 'Kotlin-DateTime-library-kotlinx-datetime' is loaded prior to 'kmp-mentions:shared'.");
    }
    if (typeof this['ktor-ktor-http'] === 'undefined') {
      throw new Error("Error loading module 'kmp-mentions:shared'. Its dependency 'ktor-ktor-http' was not found. Please, check whether 'ktor-ktor-http' is loaded prior to 'kmp-mentions:shared'.");
    }
    if (typeof this['ktor-ktor-client-core'] === 'undefined') {
      throw new Error("Error loading module 'kmp-mentions:shared'. Its dependency 'ktor-ktor-client-core' was not found. Please, check whether 'ktor-ktor-client-core' is loaded prior to 'kmp-mentions:shared'.");
    }
    if (typeof this['ktor-ktor-utils'] === 'undefined') {
      throw new Error("Error loading module 'kmp-mentions:shared'. Its dependency 'ktor-ktor-utils' was not found. Please, check whether 'ktor-ktor-utils' is loaded prior to 'kmp-mentions:shared'.");
    }
    if (typeof this['kotlinx-html'] === 'undefined') {
      throw new Error("Error loading module 'kmp-mentions:shared'. Its dependency 'kotlinx-html' was not found. Please, check whether 'kotlinx-html' is loaded prior to 'kmp-mentions:shared'.");
    }
    if (typeof this['Napier-napier-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'kmp-mentions:shared'. Its dependency 'Napier-napier-js-ir' was not found. Please, check whether 'Napier-napier-js-ir' is loaded prior to 'kmp-mentions:shared'.");
    }
    if (typeof this['ktor-ktor-client-content-negotiation'] === 'undefined') {
      throw new Error("Error loading module 'kmp-mentions:shared'. Its dependency 'ktor-ktor-client-content-negotiation' was not found. Please, check whether 'ktor-ktor-client-content-negotiation' is loaded prior to 'kmp-mentions:shared'.");
    }
    if (typeof this['ktor-ktor-client-logging'] === 'undefined') {
      throw new Error("Error loading module 'kmp-mentions:shared'. Its dependency 'ktor-ktor-client-logging' was not found. Please, check whether 'ktor-ktor-client-logging' is loaded prior to 'kmp-mentions:shared'.");
    }
    if (typeof this['ktor-ktor-serialization-kotlinx-json'] === 'undefined') {
      throw new Error("Error loading module 'kmp-mentions:shared'. Its dependency 'ktor-ktor-serialization-kotlinx-json' was not found. Please, check whether 'ktor-ktor-serialization-kotlinx-json' is loaded prior to 'kmp-mentions:shared'.");
    }
    root['kmp-mentions:shared'] = factory(typeof this['kmp-mentions:shared'] === 'undefined' ? {} : this['kmp-mentions:shared'], this['kotlin-kotlin-stdlib'], this['kotlinx-coroutines-core'], this['kotlinx-serialization-kotlinx-serialization-json-js-ir'], this['projects-core-koin-core'], this['kotlinx-serialization-kotlinx-serialization-core'], this['Kotlin-DateTime-library-kotlinx-datetime'], this['ktor-ktor-http'], this['ktor-ktor-client-core'], this['ktor-ktor-utils'], this['kotlinx-html'], this['Napier-napier-js-ir'], this['ktor-ktor-client-content-negotiation'], this['ktor-ktor-client-logging'], this['ktor-ktor-serialization-kotlinx-json']);
  }
}(globalThis, function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_io_insert_koin_koin_core, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_org_jetbrains_kotlinx_kotlinx_datetime, kotlin_io_ktor_ktor_http, kotlin_io_ktor_ktor_client_core, kotlin_io_ktor_ktor_utils, kotlin_org_jetbrains_kotlinx_kotlinx_html, kotlin_io_github_aakira_napier, kotlin_io_ktor_ktor_client_content_negotiation, kotlin_io_ktor_ktor_client_logging, kotlin_io_ktor_ktor_serialization_kotlinx_json) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var toString = kotlin_kotlin.$_$.lb;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.u1;
  var protoOf = kotlin_kotlin.$_$.hb;
  var initMetadataForObject = kotlin_kotlin.$_$.ma;
  var Dispatchers_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.j;
  var VOID = kotlin_kotlin.$_$.g;
  var initMetadataForClass = kotlin_kotlin.$_$.ha;
  var CoroutineImpl = kotlin_kotlin.$_$.j9;
  var Unit_instance = kotlin_kotlin.$_$.d5;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.v8;
  var Result = kotlin_kotlin.$_$.me;
  var THROW_CCE = kotlin_kotlin.$_$.oe;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y;
  var isInterface = kotlin_kotlin.$_$.va;
  var Companion_instance = kotlin_kotlin.$_$.y4;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.u2;
  var createFailure = kotlin_kotlin.$_$.df;
  var initMetadataForLambda = kotlin_kotlin.$_$.la;
  var withContext = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.d;
  var Json = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
  var Long = kotlin_kotlin.$_$.je;
  var startKoin = kotlin_io_insert_koin_koin_core.$_$.g;
  var Companion_getInstance = kotlin_io_insert_koin_koin_core.$_$.b;
  var Kind_Singleton_getInstance = kotlin_io_insert_koin_koin_core.$_$.a;
  var emptyList = kotlin_kotlin.$_$.s6;
  var Json_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.b;
  var getKClass = kotlin_kotlin.$_$.f;
  var BeanDefinition = kotlin_io_insert_koin_koin_core.$_$.h;
  var SingleInstanceFactory = kotlin_io_insert_koin_koin_core.$_$.j;
  var KoinDefinition = kotlin_io_insert_koin_koin_core.$_$.i;
  var copyToArray = kotlin_kotlin.$_$.o6;
  var arrayConcat = kotlin_kotlin.$_$.a;
  var module_0 = kotlin_io_insert_koin_koin_core.$_$.l;
  var Enum = kotlin_kotlin.$_$.ee;
  var hashCode = kotlin_kotlin.$_$.ga;
  var equals = kotlin_kotlin.$_$.z9;
  var getBooleanHashCode = kotlin_kotlin.$_$.ca;
  var getStringHashCode = kotlin_kotlin.$_$.fa;
  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o1;
  var initMetadataForCompanion = kotlin_kotlin.$_$.ia;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var IntSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r1;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.y1;
  var objectCreate = kotlin_kotlin.$_$.gb;
  var toString_0 = kotlin_kotlin.$_$.pf;
  var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n;
  var BooleanSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k;
  var createAnnotatedEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w1;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.i;
  var lazy = kotlin_kotlin.$_$.jf;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var Companion_instance_0 = kotlin_org_jetbrains_kotlinx_kotlinx_datetime.$_$.a;
  var Url = kotlin_io_ktor_ktor_http.$_$.x;
  var Companion_getInstance_0 = kotlin_org_jetbrains_kotlinx_kotlinx_datetime.$_$.b;
  var format = kotlin_org_jetbrains_kotlinx_kotlinx_datetime.$_$.d;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.lf;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.m2;
  var char = kotlin_org_jetbrains_kotlinx_kotlinx_datetime.$_$.c;
  var named = kotlin_io_insert_koin_koin_core.$_$.k;
  var HttpClient = kotlin_io_ktor_ktor_client_core.$_$.u;
  var initMetadataForInterface = kotlin_kotlin.$_$.ka;
  var throwOnFailure = kotlin_kotlin.$_$.nf;
  var _Result___get_value__impl__bjfvqg = kotlin_kotlin.$_$.y2;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.l;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.ja;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.a6;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.k;
  var Unit = kotlin_kotlin.$_$.ye;
  var HttpRequestBuilder = kotlin_io_ktor_ktor_client_core.$_$.m;
  var url = kotlin_io_ktor_ktor_client_core.$_$.p;
  var Companion_getInstance_1 = kotlin_io_ktor_ktor_http.$_$.f;
  var HttpStatement = kotlin_io_ktor_ktor_client_core.$_$.s;
  var JsType_instance = kotlin_io_ktor_ktor_utils.$_$.b;
  var arrayOf = kotlin_kotlin.$_$.bf;
  var createKType = kotlin_kotlin.$_$.c;
  var typeInfoImpl = kotlin_io_ktor_ktor_utils.$_$.l;
  var replace = kotlin_kotlin.$_$.zc;
  var isBlank = kotlin_kotlin.$_$.mc;
  var KtList = kotlin_kotlin.$_$.m5;
  var first = kotlin_kotlin.$_$.z6;
  var _Result___get_isSuccess__impl__sndoy8 = kotlin_kotlin.$_$.x2;
  var toSet = kotlin_kotlin.$_$.q8;
  var contains = kotlin_kotlin.$_$.b6;
  var Result__exceptionOrNull_impl_p6xea9 = kotlin_kotlin.$_$.v2;
  var _Result___get_isFailure__impl__jpiriv = kotlin_kotlin.$_$.w2;
  var MutableStateFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p;
  var combine = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.r;
  var Job = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.z;
  var CoroutineScope_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.x;
  var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.i1;
  var createInvariantKTypeProjection = kotlin_kotlin.$_$.b;
  var extendThrowable = kotlin_kotlin.$_$.aa;
  var captureStack = kotlin_kotlin.$_$.r9;
  var HttpRequest = kotlin_io_ktor_ktor_client_core.$_$.n;
  var ResponseException = kotlin_io_ktor_ktor_client_core.$_$.k;
  var Exception = kotlin_kotlin.$_$.ge;
  var enumEntries = kotlin_kotlin.$_$.l9;
  var get_create = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.b;
  var attributesMapOf = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.i;
  var DIV = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.f;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.q1;
  var enumEncode = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.a;
  var attributesMapOf_0 = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.h;
  var SCRIPT = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.g;
  var BUTTON = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.e;
  var setOf = kotlin_kotlin.$_$.c8;
  var set_classes = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.j;
  var set_onClickFunction = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.c;
  var A = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.d;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m2;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var ensureNotNull = kotlin_kotlin.$_$.ef;
  var KoinScopeComponent = kotlin_io_insert_koin_koin_core.$_$.f;
  var Napier_getInstance = kotlin_io_github_aakira_napier.$_$.a;
  var KoinPlatformTools_instance = kotlin_io_insert_koin_koin_core.$_$.c;
  var SupervisorJob = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.b1;
  var getKoin = kotlin_io_insert_koin_koin_core.$_$.d;
  var KoinComponent = kotlin_io_insert_koin_koin_core.$_$.e;
  var toLong = kotlin_kotlin.$_$.od;
  var KProperty1 = kotlin_kotlin.$_$.zb;
  var getPropertyCallableRef = kotlin_kotlin.$_$.ea;
  var split = kotlin_kotlin.$_$.dd;
  var isCharSequence = kotlin_kotlin.$_$.ra;
  var trim = kotlin_kotlin.$_$.xd;
  var to = kotlin_kotlin.$_$.qf;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.u;
  var toMap = kotlin_kotlin.$_$.n8;
  var DebugAntilog = kotlin_io_github_aakira_napier.$_$.b;
  var Js_instance = kotlin_io_ktor_ktor_client_core.$_$.a;
  var HttpClient_0 = kotlin_io_ktor_ktor_client_core.$_$.t;
  var defaultRequest = kotlin_io_ktor_ktor_client_core.$_$.l;
  var Plugin_getInstance = kotlin_io_ktor_ktor_client_content_negotiation.$_$.a;
  var HttpResponseValidator = kotlin_io_ktor_ktor_client_core.$_$.j;
  var Companion_getInstance_2 = kotlin_io_ktor_ktor_client_logging.$_$.b;
  var appendIfNameAbsent = kotlin_io_ktor_ktor_utils.$_$.v;
  var json = kotlin_io_ktor_ktor_serialization_kotlinx_json.$_$.a;
  var LogLevel_NONE_getInstance = kotlin_io_ktor_ktor_client_logging.$_$.a;
  //endregion
  //region block: pre-declaration
  initMetadataForObject(SharedModule, 'SharedModule');
  initMetadataForObject(WebConfiguration, 'WebConfiguration');
  initMetadataForClass(UseCase, 'UseCase', VOID, VOID, VOID, [1]);
  initMetadataForClass(NoResult, 'NoResult', VOID, UseCase, VOID, [0, 1]);
  initMetadataForLambda(UseCase$NoParam$invoke$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(NoParam, 'NoParam', VOID, UseCase, VOID, [0, 1]);
  initMetadataForClass(NoResult_0, 'NoResult', VOID, UseCase, VOID, [1]);
  initMetadataForClass(SourceChannel, 'SourceChannel', VOID, Enum);
  initMetadataForClass(FeedPage, 'FeedPage');
  initMetadataForClass(FeedItem, 'FeedItem');
  initMetadataForClass(WebItem, 'WebItem', VOID, FeedItem);
  initMetadataForClass(TlgItem, 'TlgItem', VOID, FeedItem);
  initMetadataForCompanion(Companion);
  initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(MentionFeedResponse, 'MentionFeedResponse', MentionFeedResponse, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
  initMetadataForCompanion(Companion_0);
  initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(MentionDto, 'MentionDto', MentionDto, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
  initMetadataForCompanion(Companion_1);
  initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(FeedArticleDto, 'FeedArticleDto', FeedArticleDto, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
  initMetadataForCompanion(Companion_2);
  initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TelegramPostDto, 'TelegramPostDto', TelegramPostDto, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
  initMetadataForCompanion(Companion_3);
  initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(Channel, 'Channel', Channel, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
  initMetadataForCompanion(Companion_4);
  initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ForwardedFromChannelDto, 'ForwardedFromChannelDto', ForwardedFromChannelDto, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
  initMetadataForCompanion(Companion_5, VOID, [SerializerFactory]);
  initMetadataForClass(TgMediaType, 'TgMediaType', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_9});
  initMetadataForCompanion(Companion_6);
  initMetadataForObject($serializer_5, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TgMediaDto, 'TgMediaDto', TgMediaDto, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
  initMetadataForCompanion(Companion_7);
  initMetadataForObject($serializer_6, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TgMedia, 'TgMedia', TgMedia, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
  initMetadataForInterface(FavouriteRepository, 'FavouriteRepository', VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($getFavouritesFeedCOROUTINE$0, CoroutineImpl);
  initMetadataForClass(FavouriteRepositoryImpl, 'FavouriteRepositoryImpl', VOID, VOID, [FavouriteRepository], [1]);
  initMetadataForClass(AddToFavouriteUseCase, 'AddToFavouriteUseCase', VOID, NoResult_0, VOID, [1]);
  initMetadataForClass(DeleteFromFavouriteUseCase, 'DeleteFromFavouriteUseCase', VOID, NoResult_0, VOID, [1]);
  initMetadataForCoroutine($executeCOROUTINE$3, CoroutineImpl);
  initMetadataForClass(GetFavouriteTlgUseCase, 'GetFavouriteTlgUseCase', VOID, NoParam, VOID, [1, 0]);
  initMetadataForClass(GetFeedsUseCase, 'GetFeedsUseCase', VOID, UseCase, VOID, [1]);
  initMetadataForInterface(FavoritesApi, 'FavoritesApi', VOID, VOID, VOID, [3, 0, 1]);
  initMetadataForCompanion(Companion_8);
  initMetadataForCoroutine($getFavoritesDataCOROUTINE$5, CoroutineImpl);
  initMetadataForClass(FavoritesApiImpl, 'FavoritesApiImpl', VOID, VOID, [FavoritesApi], [3, 0, 1]);
  initMetadataForCompanion(Companion_9);
  initMetadataForObject($serializer_7, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TlgPost, 'TlgPost', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
  initMetadataForInterface(TlgFeedRepository, 'TlgFeedRepository', VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($getTlgLinksCOROUTINE$9, CoroutineImpl);
  initMetadataForClass(TlgFeedRepositoryImpl, 'TlgFeedRepositoryImpl', VOID, VOID, [TlgFeedRepository], [1]);
  initMetadataForCompanion(Companion_10, VOID, [SerializerFactory]);
  initMetadataForClass(FeedSource, 'FeedSource', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_14});
  initMetadataForInterface(FeedbackManager, 'FeedbackManager', VOID, VOID, VOID, [1]);
  initMetadataForClass(FeedbackManagerImpl, 'FeedbackManagerImpl', VOID, VOID, [FeedbackManager], [1]);
  initMetadataForInterface(FeedbackApi, 'FeedbackApi', VOID, VOID, VOID, [1]);
  initMetadataForCompanion(Companion_11);
  initMetadataForClass(FeedbackApiImpl, 'FeedbackApiImpl', VOID, VOID, [FeedbackApi], [1]);
  initMetadataForInterface(MonitorRepository, 'MonitorRepository', VOID, VOID, VOID, [0, 3, 1, 2]);
  initMetadataForLambda(MonitorRepositoryImpl$subjectState$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(MonitorRepositoryImpl$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($updateCOROUTINE$12, CoroutineImpl);
  initMetadataForCoroutine($getSubjectsCOROUTINE$19, CoroutineImpl);
  initMetadataForClass(MonitorRepositoryImpl, 'MonitorRepositoryImpl', VOID, VOID, [MonitorRepository], [0, 3, 1, 2]);
  initMetadataForClass(MonitorSubject, 'MonitorSubject');
  initMetadataForClass(KeyWord, 'KeyWord', VOID, MonitorSubject);
  initMetadataForClass(NutcallPerson, 'NutcallPerson', VOID, MonitorSubject);
  initMetadataForClass(NutcallCompany, 'NutcallCompany', VOID, MonitorSubject);
  initMetadataForObject(Unknown, 'Unknown', VOID, MonitorSubject);
  initMetadataForCompanion(Companion_12);
  initMetadataForClass(SubjectsState, 'SubjectsState');
  initMetadataForClass(AddNewSubjectUseCase, 'AddNewSubjectUseCase', VOID, NoResult_0, VOID, [1]);
  initMetadataForClass(ChangeActiveSubjectUseCase, 'ChangeActiveSubjectUseCase', VOID, NoResult_0, VOID, [1]);
  initMetadataForClass(RemoveSubjectUseCase, 'RemoveSubjectUseCase', VOID, NoResult_0, VOID, [1]);
  initMetadataForClass(SubscribeToActiveSubjectUseCase, 'SubscribeToActiveSubjectUseCase');
  initMetadataForClass(SubscribeToSubjectsUseCase, 'SubscribeToSubjectsUseCase');
  initMetadataForClass(UpdateSubjectsUseCase, 'UpdateSubjectsUseCase', VOID, NoResult, VOID, [1, 0]);
  function getMonitorFeed$default(subjectId, limit, fromId, noRead, source, $completion, $super) {
    fromId = fromId === VOID ? null : fromId;
    noRead = noRead === VOID ? false : noRead;
    return $super === VOID ? this.p5v(subjectId, limit, fromId, noRead, source, $completion) : $super.p5v.call(this, subjectId, limit, fromId, noRead, source, $completion);
  }
  initMetadataForInterface(MonitorApi, 'MonitorApi', VOID, VOID, VOID, [0, 1, 5]);
  initMetadataForCompanion(Companion_13);
  initMetadataForCoroutine($getMonitorSubjectsCOROUTINE$24, CoroutineImpl);
  initMetadataForCoroutine($getMonitorFeedCOROUTINE$31, CoroutineImpl);
  initMetadataForClass(MonitorApiImpl, 'MonitorApiImpl', VOID, VOID, [MonitorApi], [0, 1, 5]);
  initMetadataForInterface(NutcallSearchApi, 'NutcallSearchApi', VOID, VOID, VOID, [3]);
  initMetadataForCompanion(Companion_14);
  initMetadataForClass(NutcallSearchApiImpl, 'NutcallSearchApiImpl', VOID, VOID, [NutcallSearchApi], [3]);
  initMetadataForCompanion(Companion_15, VOID, [SerializerFactory]);
  initMetadataForClass(FeedSource_0, 'FeedSource', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_19});
  initMetadataForCompanion(Companion_16);
  initMetadataForObject($serializer_8, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SubjectsDto, 'SubjectsDto', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
  initMetadataForCompanion(Companion_17);
  initMetadataForObject($serializer_9, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PhraseDto, 'PhraseDto', PhraseDto, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
  initMetadataForCompanion(Companion_18);
  initMetadataForObject($serializer_10, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(NutcallPersonDto, 'NutcallPersonDto', NutcallPersonDto, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_10});
  initMetadataForCompanion(Companion_19);
  initMetadataForObject($serializer_11, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(NutcallCompanyDto, 'NutcallCompanyDto', NutcallCompanyDto, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_11});
  initMetadataForInterface(UserRepository, 'UserRepository', VOID, VOID, VOID, [0, 1]);
  initMetadataForInterface(AuthManager, 'AuthManager', VOID, VOID, VOID, [1, 2, 0]);
  initMetadataForClass(DeleteUserUseCase, 'DeleteUserUseCase', VOID, NoResult, VOID, [1, 0]);
  initMetadataForInterface(AuthApi, 'AuthApi', VOID, VOID, VOID, [1, 0]);
  initMetadataForCompanion(Companion_20);
  initMetadataForClass(AuthApiImpl, 'AuthApiImpl', VOID, VOID, [AuthApi], [1, 0]);
  initMetadataForCompanion(Companion_21);
  initMetadataForObject($serializer_12, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ApiError, 'ApiError', VOID, Error, VOID, VOID, VOID, {0: $serializer_getInstance_12});
  initMetadataForLambda(validate$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForInterface(MonitoringStorage, 'MonitoringStorage', VOID, VOID, VOID, [1]);
  initMetadataForClass(WebApp, 'WebApp', VOID, Enum);
  initMetadataForClass(MentionWebApp, 'MentionWebApp');
  initMetadataForLambda(TlgFeedApplication$start$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(TlgFeedApplication$start$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(TlgFeedApplication, 'TlgFeedApplication', VOID, MentionWebApp, [CoroutineScope, KoinComponent, MentionWebApp]);
  initMetadataForLambda(TlgFavApplication$start$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(TlgFavApplication$start$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(TlgFavApplication, 'TlgFavApplication', TlgFavApplication, MentionWebApp, [CoroutineScope, KoinComponent, MentionWebApp]);
  initMetadataForCompanion(Companion_22);
  initMetadataForClass(QueryParser, 'QueryParser', QueryParser);
  initMetadataForClass(JsKtorLogger, 'JsKtorLogger', JsKtorLogger);
  //endregion
  function SharedModule() {
    this.o5i_1 = null;
  }
  protoOf(SharedModule).p5i = function () {
    var tmp0_safe_receiver = this.o5i_1;
    var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q5i_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'Base url was not provided';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(SharedModule).t5i = function () {
    var tmp2_safe_receiver = this.o5i_1;
    var tmp0_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.r5i_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'Client id not found';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  var SharedModule_instance;
  function SharedModule_getInstance() {
    return SharedModule_instance;
  }
  function WebConfiguration() {
    this.u5i_1 = null;
  }
  var WebConfiguration_instance;
  function WebConfiguration_getInstance() {
    return WebConfiguration_instance;
  }
  function NoResult(dispatcher) {
    dispatcher = dispatcher === VOID ? Dispatchers_getInstance().nv_1 : dispatcher;
    UseCase.call(this, dispatcher);
  }
  function UseCase$NoParam$invoke$slambda(this$0, resultContinuation) {
    this.d5j_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(UseCase$NoParam$invoke$slambda).j5j = function ($this$withContext, $completion) {
    var tmp = this.m17($this$withContext, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    var tmp_0 = tmp.r8();
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      return tmp_0;
    return tmp_0;
  };
  protoOf(UseCase$NoParam$invoke$slambda).m9 = function (p1, $completion) {
    return this.j5j((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(UseCase$NoParam$invoke$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 3;
            var tmp_0 = this;
            tmp_0.f5j_1 = this.e5j_1;
            this.k8_1 = 2;
            var tmp_1 = this;
            tmp_1.h5j_1 = Companion_instance;
            var tmp_2 = this;
            tmp_2.i5j_1 = this.f5j_1;
            this.j8_1 = 1;
            suspendResult = this.d5j_1.l5j(Unit_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var value = suspendResult;
            this.g5j_1 = _Result___init__impl__xyqfz8(value);
            this.k8_1 = 3;
            this.j8_1 = 4;
            continue $sm;
          case 2:
            this.k8_1 = 3;
            var tmp_3 = this.m8_1;
            if (tmp_3 instanceof Error) {
              var e = this.m8_1;
              var tmp_4 = this;
              tmp_4.g5j_1 = _Result___init__impl__xyqfz8(createFailure(e));
              this.j8_1 = 4;
              continue $sm;
            } else {
              throw this.m8_1;
            }

          case 3:
            throw this.m8_1;
          case 4:
            this.k8_1 = 3;
            return new Result(this.g5j_1);
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.k8_1 === 3) {
          throw e_0;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(UseCase$NoParam$invoke$slambda).m17 = function ($this$withContext, completion) {
    var i = new UseCase$NoParam$invoke$slambda(this.d5j_1, completion);
    i.e5j_1 = $this$withContext;
    return i;
  };
  function UseCase$NoParam$invoke$slambda_0(this$0, resultContinuation) {
    var i = new UseCase$NoParam$invoke$slambda(this$0, resultContinuation);
    var l = function ($this$withContext, $completion) {
      return i.j5j($this$withContext, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function NoParam(dispatcher) {
    dispatcher = dispatcher === VOID ? Dispatchers_getInstance().nv_1 : dispatcher;
    UseCase.call(this, dispatcher);
  }
  protoOf(NoParam).n5j = function ($completion) {
    var tmp = withContext(this.k5j_1, UseCase$NoParam$invoke$slambda_0(this, null), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      return tmp;
    return tmp;
  };
  function NoResult_0(dispatcher) {
    dispatcher = dispatcher === VOID ? Dispatchers_getInstance().nv_1 : dispatcher;
    UseCase.call(this, dispatcher);
  }
  function UseCase(dispatcher) {
    dispatcher = dispatcher === VOID ? Dispatchers_getInstance().nv_1 : dispatcher;
    this.k5j_1 = dispatcher;
  }
  function get_kJson() {
    _init_properties_Json_kt__5095e0();
    return kJson;
  }
  var kJson;
  function kJson$lambda($this$Json) {
    _init_properties_Json_kt__5095e0();
    $this$Json.i58_1 = true;
    return Unit_instance;
  }
  var properties_initialized_Json_kt_iojru2;
  function _init_properties_Json_kt__5095e0() {
    if (!properties_initialized_Json_kt_iojru2) {
      properties_initialized_Json_kt_iojru2 = true;
      kJson = Json(VOID, kJson$lambda);
    }
  }
  function orNotId(_this__u8e3s4) {
    return _this__u8e3s4 == null ? new Long(-1, -1) : _this__u8e3s4;
  }
  function get_appModule() {
    _init_properties_Koin_kt__rpz8t3();
    return appModule;
  }
  var appModule;
  function initializeKoin(extraModules) {
    _init_properties_Koin_kt__rpz8t3();
    startKoin(initializeKoin$lambda(extraModules));
  }
  function appModule$lambda($this$module) {
    _init_properties_Koin_kt__rpz8t3();
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition = appModule$lambda$lambda;
    var scopeQualifier = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind = Kind_Singleton_getInstance();
    var secondaryTypes = emptyList();
    var def = new BeanDefinition(scopeQualifier, getKClass(Json_0), null, definition, kind, secondaryTypes);
    var factory = new SingleInstanceFactory(def);
    $this$module.g2h(factory);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory);
    }
    new KoinDefinition($this$module, factory);
    return Unit_instance;
  }
  function appModule$lambda$lambda($this$single, it) {
    _init_properties_Koin_kt__rpz8t3();
    return get_kJson();
  }
  function initializeKoin$lambda($extraModules) {
    return function ($this$startKoin) {
      var tmp = [get_appModule(), get_favouriteModule(), get_monitorFeedModule(), get_feedbackModule(), get_authModule(), get_monitorModule(), get_platformModule()];
      // Inline function 'kotlin.collections.toTypedArray' call
      var this_0 = $extraModules;
      var tmp$ret$0 = copyToArray(this_0);
      $this$startKoin.k2f(arrayConcat([tmp, tmp$ret$0]));
      return Unit_instance;
    };
  }
  var properties_initialized_Koin_kt_5zmqqz;
  function _init_properties_Koin_kt__rpz8t3() {
    if (!properties_initialized_Koin_kt_5zmqqz) {
      properties_initialized_Koin_kt_5zmqqz = true;
      appModule = module_0(VOID, appModule$lambda);
    }
  }
  var SourceChannel_TELEGRAM_instance;
  var SourceChannel_MEDIA_instance;
  var SourceChannel_entriesInitialized;
  function SourceChannel_initEntries() {
    if (SourceChannel_entriesInitialized)
      return Unit_instance;
    SourceChannel_entriesInitialized = true;
    SourceChannel_TELEGRAM_instance = new SourceChannel('TELEGRAM', 0, 'telegram');
    SourceChannel_MEDIA_instance = new SourceChannel('MEDIA', 1, 'website');
  }
  function SourceChannel(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.q5j_1 = value;
  }
  function SourceChannel_TELEGRAM_getInstance() {
    SourceChannel_initEntries();
    return SourceChannel_TELEGRAM_instance;
  }
  function FeedPage(subjectId, total, items) {
    this.r5j_1 = subjectId;
    this.s5j_1 = total;
    this.t5j_1 = items;
  }
  protoOf(FeedPage).toString = function () {
    return 'FeedPage(subjectId=' + this.r5j_1.toString() + ', total=' + this.s5j_1 + ', items=' + toString(this.t5j_1) + ')';
  };
  protoOf(FeedPage).hashCode = function () {
    var result = this.r5j_1.hashCode();
    result = imul(result, 31) + this.s5j_1 | 0;
    result = imul(result, 31) + hashCode(this.t5j_1) | 0;
    return result;
  };
  protoOf(FeedPage).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FeedPage))
      return false;
    var tmp0_other_with_cast = other instanceof FeedPage ? other : THROW_CCE();
    if (!this.r5j_1.equals(tmp0_other_with_cast.r5j_1))
      return false;
    if (!(this.s5j_1 === tmp0_other_with_cast.s5j_1))
      return false;
    if (!equals(this.t5j_1, tmp0_other_with_cast.t5j_1))
      return false;
    return true;
  };
  function WebItem(id, isFavourite, imageUrl, title, source, articleTitle, content, link, dateTime) {
    FeedItem.call(this, id, isFavourite, link);
    this.x5j_1 = id;
    this.y5j_1 = isFavourite;
    this.z5j_1 = imageUrl;
    this.a5k_1 = title;
    this.b5k_1 = source;
    this.c5k_1 = articleTitle;
    this.d5k_1 = content;
    this.e5k_1 = link;
    this.f5k_1 = dateTime;
  }
  protoOf(WebItem).g5k = function () {
    return this.x5j_1;
  };
  protoOf(WebItem).h5k = function () {
    return this.y5j_1;
  };
  protoOf(WebItem).toString = function () {
    return 'WebItem(id=' + this.x5j_1.toString() + ', isFavourite=' + this.y5j_1 + ', imageUrl=' + this.z5j_1 + ', title=' + this.a5k_1 + ', source=' + this.b5k_1 + ', articleTitle=' + this.c5k_1 + ', content=' + this.d5k_1 + ', link=' + this.e5k_1 + ', dateTime=' + this.f5k_1 + ')';
  };
  protoOf(WebItem).hashCode = function () {
    var result = this.x5j_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.y5j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z5j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a5k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b5k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c5k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d5k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e5k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f5k_1) | 0;
    return result;
  };
  protoOf(WebItem).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WebItem))
      return false;
    var tmp0_other_with_cast = other instanceof WebItem ? other : THROW_CCE();
    if (!this.x5j_1.equals(tmp0_other_with_cast.x5j_1))
      return false;
    if (!(this.y5j_1 === tmp0_other_with_cast.y5j_1))
      return false;
    if (!(this.z5j_1 === tmp0_other_with_cast.z5j_1))
      return false;
    if (!(this.a5k_1 === tmp0_other_with_cast.a5k_1))
      return false;
    if (!(this.b5k_1 === tmp0_other_with_cast.b5k_1))
      return false;
    if (!(this.c5k_1 === tmp0_other_with_cast.c5k_1))
      return false;
    if (!(this.d5k_1 === tmp0_other_with_cast.d5k_1))
      return false;
    if (!(this.e5k_1 === tmp0_other_with_cast.e5k_1))
      return false;
    if (!(this.f5k_1 === tmp0_other_with_cast.f5k_1))
      return false;
    return true;
  };
  function TlgItem(id, isFavourite, channelImageUrl, channelName, isVerified, content, link, image, numberOfView, dateTime, reposts) {
    FeedItem.call(this, id, isFavourite, link);
    this.o5k_1 = id;
    this.p5k_1 = isFavourite;
    this.q5k_1 = channelImageUrl;
    this.r5k_1 = channelName;
    this.s5k_1 = isVerified;
    this.t5k_1 = content;
    this.u5k_1 = link;
    this.v5k_1 = image;
    this.w5k_1 = numberOfView;
    this.x5k_1 = dateTime;
    this.y5k_1 = reposts;
  }
  protoOf(TlgItem).g5k = function () {
    return this.o5k_1;
  };
  protoOf(TlgItem).h5k = function () {
    return this.p5k_1;
  };
  protoOf(TlgItem).toString = function () {
    return 'TlgItem(id=' + this.o5k_1.toString() + ', isFavourite=' + this.p5k_1 + ', channelImageUrl=' + this.q5k_1 + ', channelName=' + this.r5k_1 + ', isVerified=' + this.s5k_1 + ', content=' + this.t5k_1 + ', link=' + this.u5k_1 + ', image=' + this.v5k_1 + ', numberOfView=' + this.w5k_1 + ', dateTime=' + this.x5k_1 + ', reposts=' + this.y5k_1 + ')';
  };
  protoOf(TlgItem).hashCode = function () {
    var result = this.o5k_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.p5k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q5k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r5k_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.s5k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t5k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u5k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v5k_1) | 0;
    result = imul(result, 31) + this.w5k_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.x5k_1) | 0;
    result = imul(result, 31) + this.y5k_1 | 0;
    return result;
  };
  protoOf(TlgItem).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TlgItem))
      return false;
    var tmp0_other_with_cast = other instanceof TlgItem ? other : THROW_CCE();
    if (!this.o5k_1.equals(tmp0_other_with_cast.o5k_1))
      return false;
    if (!(this.p5k_1 === tmp0_other_with_cast.p5k_1))
      return false;
    if (!(this.q5k_1 === tmp0_other_with_cast.q5k_1))
      return false;
    if (!(this.r5k_1 === tmp0_other_with_cast.r5k_1))
      return false;
    if (!(this.s5k_1 === tmp0_other_with_cast.s5k_1))
      return false;
    if (!(this.t5k_1 === tmp0_other_with_cast.t5k_1))
      return false;
    if (!(this.u5k_1 === tmp0_other_with_cast.u5k_1))
      return false;
    if (!(this.v5k_1 === tmp0_other_with_cast.v5k_1))
      return false;
    if (!(this.w5k_1 === tmp0_other_with_cast.w5k_1))
      return false;
    if (!(this.x5k_1 === tmp0_other_with_cast.x5k_1))
      return false;
    if (!(this.y5k_1 === tmp0_other_with_cast.y5k_1))
      return false;
    return true;
  };
  function FeedItem(id, isFavourite, url) {
    this.i5k_1 = id;
    this.j5k_1 = isFavourite;
    this.k5k_1 = url;
  }
  protoOf(FeedItem).g5k = function () {
    return this.i5k_1;
  };
  protoOf(FeedItem).h5k = function () {
    return this.j5k_1;
  };
  protoOf(FeedItem).m3w = function () {
    return this.k5k_1;
  };
  function Companion() {
    Companion_instance_1 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z5k_1 = [null, new ArrayListSerializer($serializer_getInstance_0())];
  }
  var Companion_instance_1;
  function Companion_getInstance_3() {
    if (Companion_instance_1 == null)
      new Companion();
    return Companion_instance_1;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.mentions.shared.feature.common.network.MentionFeedResponse', this, 2);
    tmp0_serialDesc.g1o('limit', true);
    tmp0_serialDesc.g1o('data', true);
    this.a5l_1 = tmp0_serialDesc;
  }
  protoOf($serializer).b5l = function (encoder, value) {
    var tmp0_desc = this.a5l_1;
    var tmp1_output = encoder.x1g(tmp0_desc);
    var tmp2_cached = Companion_getInstance_3().z5k_1;
    if (tmp1_output.t1i(tmp0_desc, 0) ? true : !(value.c5l_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 0, IntSerializer_getInstance(), value.c5l_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 1) ? true : !(value.d5l_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 1, tmp2_cached[1], value.d5l_1);
    }
    tmp1_output.y1g(tmp0_desc);
  };
  protoOf($serializer).u1d = function (encoder, value) {
    return this.b5l(encoder, value instanceof MentionFeedResponse ? value : THROW_CCE());
  };
  protoOf($serializer).v1d = function (decoder) {
    var tmp0_desc = this.a5l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.x1g(tmp0_desc);
    var tmp7_cached = Companion_getInstance_3().z5k_1;
    if (tmp6_input.m1h()) {
      tmp4_local0 = tmp6_input.l1h(tmp0_desc, 0, IntSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.l1h(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.n1h(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.l1h(tmp0_desc, 0, IntSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.l1h(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.y1g(tmp0_desc);
    return MentionFeedResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer).t1d = function () {
    return this.a5l_1;
  };
  protoOf($serializer).z1o = function () {
    var tmp0_cached = Companion_getInstance_3().z5k_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(IntSerializer_getInstance()), get_nullable(tmp0_cached[1])];
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function MentionFeedResponse_init_$Init$(seen0, limit, data, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance().a5l_1);
    }
    if (0 === (seen0 & 1))
      $this.c5l_1 = null;
    else
      $this.c5l_1 = limit;
    if (0 === (seen0 & 2))
      $this.d5l_1 = null;
    else
      $this.d5l_1 = data;
    return $this;
  }
  function MentionFeedResponse_init_$Create$(seen0, limit, data, serializationConstructorMarker) {
    return MentionFeedResponse_init_$Init$(seen0, limit, data, serializationConstructorMarker, objectCreate(protoOf(MentionFeedResponse)));
  }
  function MentionFeedResponse(limit, data) {
    Companion_getInstance_3();
    limit = limit === VOID ? null : limit;
    data = data === VOID ? null : data;
    this.c5l_1 = limit;
    this.d5l_1 = data;
  }
  protoOf(MentionFeedResponse).toString = function () {
    return 'MentionFeedResponse(limit=' + this.c5l_1 + ', data=' + toString_0(this.d5l_1) + ')';
  };
  protoOf(MentionFeedResponse).hashCode = function () {
    var result = this.c5l_1 == null ? 0 : this.c5l_1;
    result = imul(result, 31) + (this.d5l_1 == null ? 0 : hashCode(this.d5l_1)) | 0;
    return result;
  };
  protoOf(MentionFeedResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MentionFeedResponse))
      return false;
    var tmp0_other_with_cast = other instanceof MentionFeedResponse ? other : THROW_CCE();
    if (!(this.c5l_1 == tmp0_other_with_cast.c5l_1))
      return false;
    if (!equals(this.d5l_1, tmp0_other_with_cast.d5l_1))
      return false;
    return true;
  };
  function Companion_0() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f5l_1 = [null, null, null, Companion_getInstance_14().n59(), null, null, null, null, null, null, null, null];
  }
  var Companion_instance_2;
  function Companion_getInstance_4() {
    if (Companion_instance_2 == null)
      new Companion_0();
    return Companion_instance_2;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.mentions.shared.feature.common.network.MentionDto', this, 12);
    tmp0_serialDesc.g1o('id', true);
    tmp0_serialDesc.g1o('date', true);
    tmp0_serialDesc.g1o('uri', true);
    tmp0_serialDesc.g1o('source', true);
    tmp0_serialDesc.g1o('provider', true);
    tmp0_serialDesc.g1o('text', true);
    tmp0_serialDesc.g1o('snippet', true);
    tmp0_serialDesc.g1o('unread', true);
    tmp0_serialDesc.g1o('in_favorites', true);
    tmp0_serialDesc.g1o('telegram_post', true);
    tmp0_serialDesc.g1o('article', true);
    tmp0_serialDesc.g1o('provider_subscription_id', true);
    this.g5l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).h5l = function (encoder, value) {
    var tmp0_desc = this.g5l_1;
    var tmp1_output = encoder.x1g(tmp0_desc);
    var tmp2_cached = Companion_getInstance_4().f5l_1;
    if (tmp1_output.t1i(tmp0_desc, 0) ? true : !(value.i5l_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 0, LongSerializer_getInstance(), value.i5l_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 1) ? true : !(value.j5l_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 1, LongSerializer_getInstance(), value.j5l_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 2) ? true : !(value.k5l_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 2, StringSerializer_getInstance(), value.k5l_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 3) ? true : !(value.l5l_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 3, tmp2_cached[3], value.l5l_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 4) ? true : !(value.m5l_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 4, StringSerializer_getInstance(), value.m5l_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 5) ? true : !(value.n5l_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 5, StringSerializer_getInstance(), value.n5l_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 6) ? true : !(value.o5l_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 6, StringSerializer_getInstance(), value.o5l_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 7) ? true : !(value.p5l_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 7, BooleanSerializer_getInstance(), value.p5l_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 8) ? true : !(value.q5l_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 8, BooleanSerializer_getInstance(), value.q5l_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 9) ? true : !(value.r5l_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 9, $serializer_getInstance_2(), value.r5l_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 10) ? true : !(value.s5l_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 10, $serializer_getInstance_1(), value.s5l_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 11) ? true : !(value.t5l_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 11, StringSerializer_getInstance(), value.t5l_1);
    }
    tmp1_output.y1g(tmp0_desc);
  };
  protoOf($serializer_0).u1d = function (encoder, value) {
    return this.h5l(encoder, value instanceof MentionDto ? value : THROW_CCE());
  };
  protoOf($serializer_0).v1d = function (decoder) {
    var tmp0_desc = this.g5l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_input = decoder.x1g(tmp0_desc);
    var tmp17_cached = Companion_getInstance_4().f5l_1;
    if (tmp16_input.m1h()) {
      tmp4_local0 = tmp16_input.l1h(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp16_input.l1h(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp16_input.l1h(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp16_input.l1h(tmp0_desc, 3, tmp17_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp16_input.l1h(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp16_input.l1h(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp16_input.l1h(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp16_input.l1h(tmp0_desc, 7, BooleanSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp16_input.l1h(tmp0_desc, 8, BooleanSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp16_input.l1h(tmp0_desc, 9, $serializer_getInstance_2(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp16_input.l1h(tmp0_desc, 10, $serializer_getInstance_1(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp16_input.l1h(tmp0_desc, 11, StringSerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp16_input.n1h(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp16_input.l1h(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp16_input.l1h(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp16_input.l1h(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp16_input.l1h(tmp0_desc, 3, tmp17_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp16_input.l1h(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp16_input.l1h(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp16_input.l1h(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp16_input.l1h(tmp0_desc, 7, BooleanSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp16_input.l1h(tmp0_desc, 8, BooleanSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp16_input.l1h(tmp0_desc, 9, $serializer_getInstance_2(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp16_input.l1h(tmp0_desc, 10, $serializer_getInstance_1(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp16_input.l1h(tmp0_desc, 11, StringSerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp16_input.y1g(tmp0_desc);
    return MentionDto_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, null);
  };
  protoOf($serializer_0).t1d = function () {
    return this.g5l_1;
  };
  protoOf($serializer_0).z1o = function () {
    var tmp0_cached = Companion_getInstance_4().f5l_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[3]), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable($serializer_getInstance_2()), get_nullable($serializer_getInstance_1()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function MentionDto_init_$Init$(seen0, id, date, uri, source, provider, text, snippet, unread, inFavorites, telegramPost, article, providerSubscriptionId, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_0().g5l_1);
    }
    if (0 === (seen0 & 1))
      $this.i5l_1 = null;
    else
      $this.i5l_1 = id;
    if (0 === (seen0 & 2))
      $this.j5l_1 = null;
    else
      $this.j5l_1 = date;
    if (0 === (seen0 & 4))
      $this.k5l_1 = null;
    else
      $this.k5l_1 = uri;
    if (0 === (seen0 & 8))
      $this.l5l_1 = null;
    else
      $this.l5l_1 = source;
    if (0 === (seen0 & 16))
      $this.m5l_1 = null;
    else
      $this.m5l_1 = provider;
    if (0 === (seen0 & 32))
      $this.n5l_1 = null;
    else
      $this.n5l_1 = text;
    if (0 === (seen0 & 64))
      $this.o5l_1 = null;
    else
      $this.o5l_1 = snippet;
    if (0 === (seen0 & 128))
      $this.p5l_1 = null;
    else
      $this.p5l_1 = unread;
    if (0 === (seen0 & 256))
      $this.q5l_1 = null;
    else
      $this.q5l_1 = inFavorites;
    if (0 === (seen0 & 512))
      $this.r5l_1 = null;
    else
      $this.r5l_1 = telegramPost;
    if (0 === (seen0 & 1024))
      $this.s5l_1 = null;
    else
      $this.s5l_1 = article;
    if (0 === (seen0 & 2048))
      $this.t5l_1 = null;
    else
      $this.t5l_1 = providerSubscriptionId;
    return $this;
  }
  function MentionDto_init_$Create$(seen0, id, date, uri, source, provider, text, snippet, unread, inFavorites, telegramPost, article, providerSubscriptionId, serializationConstructorMarker) {
    return MentionDto_init_$Init$(seen0, id, date, uri, source, provider, text, snippet, unread, inFavorites, telegramPost, article, providerSubscriptionId, serializationConstructorMarker, objectCreate(protoOf(MentionDto)));
  }
  function MentionDto(id, date, uri, source, provider, text, snippet, unread, inFavorites, telegramPost, article, providerSubscriptionId) {
    Companion_getInstance_4();
    id = id === VOID ? null : id;
    date = date === VOID ? null : date;
    uri = uri === VOID ? null : uri;
    source = source === VOID ? null : source;
    provider = provider === VOID ? null : provider;
    text = text === VOID ? null : text;
    snippet = snippet === VOID ? null : snippet;
    unread = unread === VOID ? null : unread;
    inFavorites = inFavorites === VOID ? null : inFavorites;
    telegramPost = telegramPost === VOID ? null : telegramPost;
    article = article === VOID ? null : article;
    providerSubscriptionId = providerSubscriptionId === VOID ? null : providerSubscriptionId;
    this.i5l_1 = id;
    this.j5l_1 = date;
    this.k5l_1 = uri;
    this.l5l_1 = source;
    this.m5l_1 = provider;
    this.n5l_1 = text;
    this.o5l_1 = snippet;
    this.p5l_1 = unread;
    this.q5l_1 = inFavorites;
    this.r5l_1 = telegramPost;
    this.s5l_1 = article;
    this.t5l_1 = providerSubscriptionId;
  }
  protoOf(MentionDto).toString = function () {
    return 'MentionDto(id=' + toString_0(this.i5l_1) + ', date=' + toString_0(this.j5l_1) + ', uri=' + this.k5l_1 + ', source=' + toString_0(this.l5l_1) + ', provider=' + this.m5l_1 + ', text=' + this.n5l_1 + ', snippet=' + this.o5l_1 + ', unread=' + this.p5l_1 + ', inFavorites=' + this.q5l_1 + ', telegramPost=' + toString_0(this.r5l_1) + ', article=' + toString_0(this.s5l_1) + ', providerSubscriptionId=' + this.t5l_1 + ')';
  };
  protoOf(MentionDto).hashCode = function () {
    var result = this.i5l_1 == null ? 0 : this.i5l_1.hashCode();
    result = imul(result, 31) + (this.j5l_1 == null ? 0 : this.j5l_1.hashCode()) | 0;
    result = imul(result, 31) + (this.k5l_1 == null ? 0 : getStringHashCode(this.k5l_1)) | 0;
    result = imul(result, 31) + (this.l5l_1 == null ? 0 : this.l5l_1.hashCode()) | 0;
    result = imul(result, 31) + (this.m5l_1 == null ? 0 : getStringHashCode(this.m5l_1)) | 0;
    result = imul(result, 31) + (this.n5l_1 == null ? 0 : getStringHashCode(this.n5l_1)) | 0;
    result = imul(result, 31) + (this.o5l_1 == null ? 0 : getStringHashCode(this.o5l_1)) | 0;
    result = imul(result, 31) + (this.p5l_1 == null ? 0 : getBooleanHashCode(this.p5l_1)) | 0;
    result = imul(result, 31) + (this.q5l_1 == null ? 0 : getBooleanHashCode(this.q5l_1)) | 0;
    result = imul(result, 31) + (this.r5l_1 == null ? 0 : this.r5l_1.hashCode()) | 0;
    result = imul(result, 31) + (this.s5l_1 == null ? 0 : this.s5l_1.hashCode()) | 0;
    result = imul(result, 31) + (this.t5l_1 == null ? 0 : getStringHashCode(this.t5l_1)) | 0;
    return result;
  };
  protoOf(MentionDto).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MentionDto))
      return false;
    var tmp0_other_with_cast = other instanceof MentionDto ? other : THROW_CCE();
    if (!equals(this.i5l_1, tmp0_other_with_cast.i5l_1))
      return false;
    if (!equals(this.j5l_1, tmp0_other_with_cast.j5l_1))
      return false;
    if (!(this.k5l_1 == tmp0_other_with_cast.k5l_1))
      return false;
    if (!equals(this.l5l_1, tmp0_other_with_cast.l5l_1))
      return false;
    if (!(this.m5l_1 == tmp0_other_with_cast.m5l_1))
      return false;
    if (!(this.n5l_1 == tmp0_other_with_cast.n5l_1))
      return false;
    if (!(this.o5l_1 == tmp0_other_with_cast.o5l_1))
      return false;
    if (!(this.p5l_1 == tmp0_other_with_cast.p5l_1))
      return false;
    if (!(this.q5l_1 == tmp0_other_with_cast.q5l_1))
      return false;
    if (!equals(this.r5l_1, tmp0_other_with_cast.r5l_1))
      return false;
    if (!equals(this.s5l_1, tmp0_other_with_cast.s5l_1))
      return false;
    if (!(this.t5l_1 == tmp0_other_with_cast.t5l_1))
      return false;
    return true;
  };
  function Companion_1() {
  }
  var Companion_instance_3;
  function Companion_getInstance_5() {
    return Companion_instance_3;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.mentions.shared.feature.common.network.FeedArticleDto', this, 5);
    tmp0_serialDesc.g1o('date', true);
    tmp0_serialDesc.g1o('snippet', true);
    tmp0_serialDesc.g1o('text', true);
    tmp0_serialDesc.g1o('title', true);
    tmp0_serialDesc.g1o('url', true);
    this.u5l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).v5l = function (encoder, value) {
    var tmp0_desc = this.u5l_1;
    var tmp1_output = encoder.x1g(tmp0_desc);
    if (tmp1_output.t1i(tmp0_desc, 0) ? true : !(value.w5l_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 0, LongSerializer_getInstance(), value.w5l_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 1) ? true : !(value.x5l_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 1, StringSerializer_getInstance(), value.x5l_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 2) ? true : !(value.y5l_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 2, StringSerializer_getInstance(), value.y5l_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 3) ? true : !(value.z5l_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 3, StringSerializer_getInstance(), value.z5l_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 4) ? true : !(value.a5m_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 4, StringSerializer_getInstance(), value.a5m_1);
    }
    tmp1_output.y1g(tmp0_desc);
  };
  protoOf($serializer_1).u1d = function (encoder, value) {
    return this.v5l(encoder, value instanceof FeedArticleDto ? value : THROW_CCE());
  };
  protoOf($serializer_1).v1d = function (decoder) {
    var tmp0_desc = this.u5l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.x1g(tmp0_desc);
    if (tmp9_input.m1h()) {
      tmp4_local0 = tmp9_input.l1h(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.l1h(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.l1h(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.l1h(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.l1h(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.n1h(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.l1h(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.l1h(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.l1h(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.l1h(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.l1h(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.y1g(tmp0_desc);
    return FeedArticleDto_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_1).t1d = function () {
    return this.u5l_1;
  };
  protoOf($serializer_1).z1o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_1;
  function $serializer_getInstance_1() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function FeedArticleDto_init_$Init$(seen0, date, snippet, text, title, url, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_1().u5l_1);
    }
    if (0 === (seen0 & 1))
      $this.w5l_1 = null;
    else
      $this.w5l_1 = date;
    if (0 === (seen0 & 2))
      $this.x5l_1 = null;
    else
      $this.x5l_1 = snippet;
    if (0 === (seen0 & 4))
      $this.y5l_1 = null;
    else
      $this.y5l_1 = text;
    if (0 === (seen0 & 8))
      $this.z5l_1 = null;
    else
      $this.z5l_1 = title;
    if (0 === (seen0 & 16))
      $this.a5m_1 = null;
    else
      $this.a5m_1 = url;
    return $this;
  }
  function FeedArticleDto_init_$Create$(seen0, date, snippet, text, title, url, serializationConstructorMarker) {
    return FeedArticleDto_init_$Init$(seen0, date, snippet, text, title, url, serializationConstructorMarker, objectCreate(protoOf(FeedArticleDto)));
  }
  function FeedArticleDto(date, snippet, text, title, url) {
    date = date === VOID ? null : date;
    snippet = snippet === VOID ? null : snippet;
    text = text === VOID ? null : text;
    title = title === VOID ? null : title;
    url = url === VOID ? null : url;
    this.w5l_1 = date;
    this.x5l_1 = snippet;
    this.y5l_1 = text;
    this.z5l_1 = title;
    this.a5m_1 = url;
  }
  protoOf(FeedArticleDto).toString = function () {
    return 'FeedArticleDto(date=' + toString_0(this.w5l_1) + ', snippet=' + this.x5l_1 + ', text=' + this.y5l_1 + ', title=' + this.z5l_1 + ', url=' + this.a5m_1 + ')';
  };
  protoOf(FeedArticleDto).hashCode = function () {
    var result = this.w5l_1 == null ? 0 : this.w5l_1.hashCode();
    result = imul(result, 31) + (this.x5l_1 == null ? 0 : getStringHashCode(this.x5l_1)) | 0;
    result = imul(result, 31) + (this.y5l_1 == null ? 0 : getStringHashCode(this.y5l_1)) | 0;
    result = imul(result, 31) + (this.z5l_1 == null ? 0 : getStringHashCode(this.z5l_1)) | 0;
    result = imul(result, 31) + (this.a5m_1 == null ? 0 : getStringHashCode(this.a5m_1)) | 0;
    return result;
  };
  protoOf(FeedArticleDto).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FeedArticleDto))
      return false;
    var tmp0_other_with_cast = other instanceof FeedArticleDto ? other : THROW_CCE();
    if (!equals(this.w5l_1, tmp0_other_with_cast.w5l_1))
      return false;
    if (!(this.x5l_1 == tmp0_other_with_cast.x5l_1))
      return false;
    if (!(this.y5l_1 == tmp0_other_with_cast.y5l_1))
      return false;
    if (!(this.z5l_1 == tmp0_other_with_cast.z5l_1))
      return false;
    if (!(this.a5m_1 == tmp0_other_with_cast.a5m_1))
      return false;
    return true;
  };
  function Companion_2() {
  }
  var Companion_instance_4;
  function Companion_getInstance_6() {
    return Companion_instance_4;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.mentions.shared.feature.common.network.TelegramPostDto', this, 7);
    tmp0_serialDesc.g1o('channel', true);
    tmp0_serialDesc.g1o('date', true);
    tmp0_serialDesc.g1o('forwarded_from_channel', true);
    tmp0_serialDesc.g1o('link', true);
    tmp0_serialDesc.g1o('media', true);
    tmp0_serialDesc.g1o('snippet', true);
    tmp0_serialDesc.g1o('text', true);
    this.b5m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).c5m = function (encoder, value) {
    var tmp0_desc = this.b5m_1;
    var tmp1_output = encoder.x1g(tmp0_desc);
    if (tmp1_output.t1i(tmp0_desc, 0) ? true : !(value.d5m_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 0, $serializer_getInstance_3(), value.d5m_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 1) ? true : !(value.e5m_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 1, LongSerializer_getInstance(), value.e5m_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 2) ? true : !(value.f5m_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 2, $serializer_getInstance_4(), value.f5m_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 3) ? true : !(value.g5m_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 3, StringSerializer_getInstance(), value.g5m_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 4) ? true : !(value.h5m_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 4, $serializer_getInstance_5(), value.h5m_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 5) ? true : !(value.i5m_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 5, StringSerializer_getInstance(), value.i5m_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 6) ? true : !(value.j5m_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 6, StringSerializer_getInstance(), value.j5m_1);
    }
    tmp1_output.y1g(tmp0_desc);
  };
  protoOf($serializer_2).u1d = function (encoder, value) {
    return this.c5m(encoder, value instanceof TelegramPostDto ? value : THROW_CCE());
  };
  protoOf($serializer_2).v1d = function (decoder) {
    var tmp0_desc = this.b5m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.x1g(tmp0_desc);
    if (tmp11_input.m1h()) {
      tmp4_local0 = tmp11_input.l1h(tmp0_desc, 0, $serializer_getInstance_3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.l1h(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.l1h(tmp0_desc, 2, $serializer_getInstance_4(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.l1h(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.l1h(tmp0_desc, 4, $serializer_getInstance_5(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.l1h(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.l1h(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.n1h(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.l1h(tmp0_desc, 0, $serializer_getInstance_3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.l1h(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.l1h(tmp0_desc, 2, $serializer_getInstance_4(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.l1h(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.l1h(tmp0_desc, 4, $serializer_getInstance_5(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.l1h(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.l1h(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.y1g(tmp0_desc);
    return TelegramPostDto_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer_2).t1d = function () {
    return this.b5m_1;
  };
  protoOf($serializer_2).z1o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable($serializer_getInstance_3()), get_nullable(LongSerializer_getInstance()), get_nullable($serializer_getInstance_4()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_5()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_2;
  function $serializer_getInstance_2() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function TelegramPostDto_init_$Init$(seen0, channel, date, forwardedFromChannel, link, media, snippet, text, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_2().b5m_1);
    }
    if (0 === (seen0 & 1))
      $this.d5m_1 = null;
    else
      $this.d5m_1 = channel;
    if (0 === (seen0 & 2))
      $this.e5m_1 = null;
    else
      $this.e5m_1 = date;
    if (0 === (seen0 & 4))
      $this.f5m_1 = null;
    else
      $this.f5m_1 = forwardedFromChannel;
    if (0 === (seen0 & 8))
      $this.g5m_1 = null;
    else
      $this.g5m_1 = link;
    if (0 === (seen0 & 16))
      $this.h5m_1 = null;
    else
      $this.h5m_1 = media;
    if (0 === (seen0 & 32))
      $this.i5m_1 = null;
    else
      $this.i5m_1 = snippet;
    if (0 === (seen0 & 64))
      $this.j5m_1 = null;
    else
      $this.j5m_1 = text;
    return $this;
  }
  function TelegramPostDto_init_$Create$(seen0, channel, date, forwardedFromChannel, link, media, snippet, text, serializationConstructorMarker) {
    return TelegramPostDto_init_$Init$(seen0, channel, date, forwardedFromChannel, link, media, snippet, text, serializationConstructorMarker, objectCreate(protoOf(TelegramPostDto)));
  }
  function TelegramPostDto(channel, date, forwardedFromChannel, link, media, snippet, text) {
    channel = channel === VOID ? null : channel;
    date = date === VOID ? null : date;
    forwardedFromChannel = forwardedFromChannel === VOID ? null : forwardedFromChannel;
    link = link === VOID ? null : link;
    media = media === VOID ? null : media;
    snippet = snippet === VOID ? null : snippet;
    text = text === VOID ? null : text;
    this.d5m_1 = channel;
    this.e5m_1 = date;
    this.f5m_1 = forwardedFromChannel;
    this.g5m_1 = link;
    this.h5m_1 = media;
    this.i5m_1 = snippet;
    this.j5m_1 = text;
  }
  protoOf(TelegramPostDto).toString = function () {
    return 'TelegramPostDto(channel=' + toString_0(this.d5m_1) + ', date=' + toString_0(this.e5m_1) + ', forwardedFromChannel=' + toString_0(this.f5m_1) + ', link=' + this.g5m_1 + ', media=' + toString_0(this.h5m_1) + ', snippet=' + this.i5m_1 + ', text=' + this.j5m_1 + ')';
  };
  protoOf(TelegramPostDto).hashCode = function () {
    var result = this.d5m_1 == null ? 0 : this.d5m_1.hashCode();
    result = imul(result, 31) + (this.e5m_1 == null ? 0 : this.e5m_1.hashCode()) | 0;
    result = imul(result, 31) + (this.f5m_1 == null ? 0 : this.f5m_1.hashCode()) | 0;
    result = imul(result, 31) + (this.g5m_1 == null ? 0 : getStringHashCode(this.g5m_1)) | 0;
    result = imul(result, 31) + (this.h5m_1 == null ? 0 : this.h5m_1.hashCode()) | 0;
    result = imul(result, 31) + (this.i5m_1 == null ? 0 : getStringHashCode(this.i5m_1)) | 0;
    result = imul(result, 31) + (this.j5m_1 == null ? 0 : getStringHashCode(this.j5m_1)) | 0;
    return result;
  };
  protoOf(TelegramPostDto).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TelegramPostDto))
      return false;
    var tmp0_other_with_cast = other instanceof TelegramPostDto ? other : THROW_CCE();
    if (!equals(this.d5m_1, tmp0_other_with_cast.d5m_1))
      return false;
    if (!equals(this.e5m_1, tmp0_other_with_cast.e5m_1))
      return false;
    if (!equals(this.f5m_1, tmp0_other_with_cast.f5m_1))
      return false;
    if (!(this.g5m_1 == tmp0_other_with_cast.g5m_1))
      return false;
    if (!equals(this.h5m_1, tmp0_other_with_cast.h5m_1))
      return false;
    if (!(this.i5m_1 == tmp0_other_with_cast.i5m_1))
      return false;
    if (!(this.j5m_1 == tmp0_other_with_cast.j5m_1))
      return false;
    return true;
  };
  function Companion_3() {
  }
  var Companion_instance_5;
  function Companion_getInstance_7() {
    return Companion_instance_5;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.mentions.shared.feature.common.network.Channel', this, 6);
    tmp0_serialDesc.g1o('about', true);
    tmp0_serialDesc.g1o('image', true);
    tmp0_serialDesc.g1o('link', true);
    tmp0_serialDesc.g1o('subscribers_count', true);
    tmp0_serialDesc.g1o('title', true);
    tmp0_serialDesc.g1o('username', true);
    this.k5m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).l5m = function (encoder, value) {
    var tmp0_desc = this.k5m_1;
    var tmp1_output = encoder.x1g(tmp0_desc);
    if (tmp1_output.t1i(tmp0_desc, 0) ? true : !(value.m5m_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 0, StringSerializer_getInstance(), value.m5m_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 1) ? true : !(value.n5m_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 1, StringSerializer_getInstance(), value.n5m_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 2) ? true : !(value.o5m_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 2, StringSerializer_getInstance(), value.o5m_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 3) ? true : !(value.p5m_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 3, IntSerializer_getInstance(), value.p5m_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 4) ? true : !(value.q5m_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 4, StringSerializer_getInstance(), value.q5m_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 5) ? true : !(value.r5m_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 5, StringSerializer_getInstance(), value.r5m_1);
    }
    tmp1_output.y1g(tmp0_desc);
  };
  protoOf($serializer_3).u1d = function (encoder, value) {
    return this.l5m(encoder, value instanceof Channel ? value : THROW_CCE());
  };
  protoOf($serializer_3).v1d = function (decoder) {
    var tmp0_desc = this.k5m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.x1g(tmp0_desc);
    if (tmp10_input.m1h()) {
      tmp4_local0 = tmp10_input.l1h(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.l1h(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.l1h(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.l1h(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.l1h(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.l1h(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.n1h(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.l1h(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.l1h(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.l1h(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.l1h(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.l1h(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.l1h(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.y1g(tmp0_desc);
    return Channel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_3).t1d = function () {
    return this.k5m_1;
  };
  protoOf($serializer_3).z1o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_3;
  function $serializer_getInstance_3() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function Channel_init_$Init$(seen0, about, image, link, subscribersCount, title, username, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_3().k5m_1);
    }
    if (0 === (seen0 & 1))
      $this.m5m_1 = null;
    else
      $this.m5m_1 = about;
    if (0 === (seen0 & 2))
      $this.n5m_1 = null;
    else
      $this.n5m_1 = image;
    if (0 === (seen0 & 4))
      $this.o5m_1 = null;
    else
      $this.o5m_1 = link;
    if (0 === (seen0 & 8))
      $this.p5m_1 = null;
    else
      $this.p5m_1 = subscribersCount;
    if (0 === (seen0 & 16))
      $this.q5m_1 = null;
    else
      $this.q5m_1 = title;
    if (0 === (seen0 & 32))
      $this.r5m_1 = null;
    else
      $this.r5m_1 = username;
    return $this;
  }
  function Channel_init_$Create$(seen0, about, image, link, subscribersCount, title, username, serializationConstructorMarker) {
    return Channel_init_$Init$(seen0, about, image, link, subscribersCount, title, username, serializationConstructorMarker, objectCreate(protoOf(Channel)));
  }
  function Channel(about, image, link, subscribersCount, title, username) {
    about = about === VOID ? null : about;
    image = image === VOID ? null : image;
    link = link === VOID ? null : link;
    subscribersCount = subscribersCount === VOID ? null : subscribersCount;
    title = title === VOID ? null : title;
    username = username === VOID ? null : username;
    this.m5m_1 = about;
    this.n5m_1 = image;
    this.o5m_1 = link;
    this.p5m_1 = subscribersCount;
    this.q5m_1 = title;
    this.r5m_1 = username;
  }
  protoOf(Channel).toString = function () {
    return 'Channel(about=' + this.m5m_1 + ', image=' + this.n5m_1 + ', link=' + this.o5m_1 + ', subscribersCount=' + this.p5m_1 + ', title=' + this.q5m_1 + ', username=' + this.r5m_1 + ')';
  };
  protoOf(Channel).hashCode = function () {
    var result = this.m5m_1 == null ? 0 : getStringHashCode(this.m5m_1);
    result = imul(result, 31) + (this.n5m_1 == null ? 0 : getStringHashCode(this.n5m_1)) | 0;
    result = imul(result, 31) + (this.o5m_1 == null ? 0 : getStringHashCode(this.o5m_1)) | 0;
    result = imul(result, 31) + (this.p5m_1 == null ? 0 : this.p5m_1) | 0;
    result = imul(result, 31) + (this.q5m_1 == null ? 0 : getStringHashCode(this.q5m_1)) | 0;
    result = imul(result, 31) + (this.r5m_1 == null ? 0 : getStringHashCode(this.r5m_1)) | 0;
    return result;
  };
  protoOf(Channel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Channel))
      return false;
    var tmp0_other_with_cast = other instanceof Channel ? other : THROW_CCE();
    if (!(this.m5m_1 == tmp0_other_with_cast.m5m_1))
      return false;
    if (!(this.n5m_1 == tmp0_other_with_cast.n5m_1))
      return false;
    if (!(this.o5m_1 == tmp0_other_with_cast.o5m_1))
      return false;
    if (!(this.p5m_1 == tmp0_other_with_cast.p5m_1))
      return false;
    if (!(this.q5m_1 == tmp0_other_with_cast.q5m_1))
      return false;
    if (!(this.r5m_1 == tmp0_other_with_cast.r5m_1))
      return false;
    return true;
  };
  function Companion_4() {
  }
  var Companion_instance_6;
  function Companion_getInstance_8() {
    return Companion_instance_6;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.mentions.shared.feature.common.network.ForwardedFromChannelDto', this, 6);
    tmp0_serialDesc.g1o('about', true);
    tmp0_serialDesc.g1o('image', true);
    tmp0_serialDesc.g1o('link', true);
    tmp0_serialDesc.g1o('subscribers_count', true);
    tmp0_serialDesc.g1o('title', true);
    tmp0_serialDesc.g1o('username', true);
    this.s5m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).t5m = function (encoder, value) {
    var tmp0_desc = this.s5m_1;
    var tmp1_output = encoder.x1g(tmp0_desc);
    if (tmp1_output.t1i(tmp0_desc, 0) ? true : !(value.u5m_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 0, StringSerializer_getInstance(), value.u5m_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 1) ? true : !(value.v5m_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 1, StringSerializer_getInstance(), value.v5m_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 2) ? true : !(value.w5m_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 2, StringSerializer_getInstance(), value.w5m_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 3) ? true : !(value.x5m_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 3, IntSerializer_getInstance(), value.x5m_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 4) ? true : !(value.y5m_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 4, StringSerializer_getInstance(), value.y5m_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 5) ? true : !(value.z5m_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 5, StringSerializer_getInstance(), value.z5m_1);
    }
    tmp1_output.y1g(tmp0_desc);
  };
  protoOf($serializer_4).u1d = function (encoder, value) {
    return this.t5m(encoder, value instanceof ForwardedFromChannelDto ? value : THROW_CCE());
  };
  protoOf($serializer_4).v1d = function (decoder) {
    var tmp0_desc = this.s5m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.x1g(tmp0_desc);
    if (tmp10_input.m1h()) {
      tmp4_local0 = tmp10_input.l1h(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.l1h(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.l1h(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.l1h(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.l1h(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.l1h(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.n1h(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.l1h(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.l1h(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.l1h(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.l1h(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.l1h(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.l1h(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.y1g(tmp0_desc);
    return ForwardedFromChannelDto_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_4).t1d = function () {
    return this.s5m_1;
  };
  protoOf($serializer_4).z1o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_4;
  function $serializer_getInstance_4() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function ForwardedFromChannelDto_init_$Init$(seen0, about, image, link, subscribersCount, title, username, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_4().s5m_1);
    }
    if (0 === (seen0 & 1))
      $this.u5m_1 = null;
    else
      $this.u5m_1 = about;
    if (0 === (seen0 & 2))
      $this.v5m_1 = null;
    else
      $this.v5m_1 = image;
    if (0 === (seen0 & 4))
      $this.w5m_1 = null;
    else
      $this.w5m_1 = link;
    if (0 === (seen0 & 8))
      $this.x5m_1 = null;
    else
      $this.x5m_1 = subscribersCount;
    if (0 === (seen0 & 16))
      $this.y5m_1 = null;
    else
      $this.y5m_1 = title;
    if (0 === (seen0 & 32))
      $this.z5m_1 = null;
    else
      $this.z5m_1 = username;
    return $this;
  }
  function ForwardedFromChannelDto_init_$Create$(seen0, about, image, link, subscribersCount, title, username, serializationConstructorMarker) {
    return ForwardedFromChannelDto_init_$Init$(seen0, about, image, link, subscribersCount, title, username, serializationConstructorMarker, objectCreate(protoOf(ForwardedFromChannelDto)));
  }
  function ForwardedFromChannelDto(about, image, link, subscribersCount, title, username) {
    about = about === VOID ? null : about;
    image = image === VOID ? null : image;
    link = link === VOID ? null : link;
    subscribersCount = subscribersCount === VOID ? null : subscribersCount;
    title = title === VOID ? null : title;
    username = username === VOID ? null : username;
    this.u5m_1 = about;
    this.v5m_1 = image;
    this.w5m_1 = link;
    this.x5m_1 = subscribersCount;
    this.y5m_1 = title;
    this.z5m_1 = username;
  }
  protoOf(ForwardedFromChannelDto).toString = function () {
    return 'ForwardedFromChannelDto(about=' + this.u5m_1 + ', image=' + this.v5m_1 + ', link=' + this.w5m_1 + ', subscribersCount=' + this.x5m_1 + ', title=' + this.y5m_1 + ', username=' + this.z5m_1 + ')';
  };
  protoOf(ForwardedFromChannelDto).hashCode = function () {
    var result = this.u5m_1 == null ? 0 : getStringHashCode(this.u5m_1);
    result = imul(result, 31) + (this.v5m_1 == null ? 0 : getStringHashCode(this.v5m_1)) | 0;
    result = imul(result, 31) + (this.w5m_1 == null ? 0 : getStringHashCode(this.w5m_1)) | 0;
    result = imul(result, 31) + (this.x5m_1 == null ? 0 : this.x5m_1) | 0;
    result = imul(result, 31) + (this.y5m_1 == null ? 0 : getStringHashCode(this.y5m_1)) | 0;
    result = imul(result, 31) + (this.z5m_1 == null ? 0 : getStringHashCode(this.z5m_1)) | 0;
    return result;
  };
  protoOf(ForwardedFromChannelDto).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ForwardedFromChannelDto))
      return false;
    var tmp0_other_with_cast = other instanceof ForwardedFromChannelDto ? other : THROW_CCE();
    if (!(this.u5m_1 == tmp0_other_with_cast.u5m_1))
      return false;
    if (!(this.v5m_1 == tmp0_other_with_cast.v5m_1))
      return false;
    if (!(this.w5m_1 == tmp0_other_with_cast.w5m_1))
      return false;
    if (!(this.x5m_1 == tmp0_other_with_cast.x5m_1))
      return false;
    if (!(this.y5m_1 == tmp0_other_with_cast.y5m_1))
      return false;
    if (!(this.z5m_1 == tmp0_other_with_cast.z5m_1))
      return false;
    return true;
  };
  function _get_$cachedSerializer__te6jhj($this) {
    return $this.a5n_1.v();
  }
  function TgMediaType$Companion$_anonymous__kfvtok() {
    var tmp = values();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = ['mediadocument', 'mediawebpage', 'mediaphoto', 'mediageo', 'mediacontact', 'mediavenue', 'mediageolive', 'mediagame', 'mediainvoice', 'unknown'];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = [null, null, null, null, null, null, null, null, null, null];
    return createAnnotatedEnumSerializer('com.mentions.shared.feature.common.network.TgMediaType', tmp, tmp_0, tmp$ret$5, null);
  }
  var TgMediaType_MEDIA_DOCUMENT_instance;
  var TgMediaType_MEDIA_WEBPAGE_instance;
  var TgMediaType_MEDIA_PHOTO_instance;
  var TgMediaType_MEDIA_GEO_instance;
  var TgMediaType_MEDIA_CONTACT_instance;
  var TgMediaType_MEDIA_VENUE_instance;
  var TgMediaType_MEDIA_GEO_LIVE_instance;
  var TgMediaType_MEDIA_GAME_instance;
  var TgMediaType_MEDIA_INVOICE_instance;
  var TgMediaType_UNKNOWN_instance;
  function values() {
    return [TgMediaType_MEDIA_DOCUMENT_getInstance(), TgMediaType_MEDIA_WEBPAGE_getInstance(), TgMediaType_MEDIA_PHOTO_getInstance(), TgMediaType_MEDIA_GEO_getInstance(), TgMediaType_MEDIA_CONTACT_getInstance(), TgMediaType_MEDIA_VENUE_getInstance(), TgMediaType_MEDIA_GEO_LIVE_getInstance(), TgMediaType_MEDIA_GAME_getInstance(), TgMediaType_MEDIA_INVOICE_getInstance(), TgMediaType_UNKNOWN_getInstance()];
  }
  function Companion_5() {
    Companion_instance_7 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a5n_1 = lazy(tmp_0, TgMediaType$Companion$_anonymous__kfvtok);
  }
  protoOf(Companion_5).n59 = function () {
    return _get_$cachedSerializer__te6jhj(this);
  };
  protoOf(Companion_5).k1p = function (typeParamsSerializers) {
    return this.n59();
  };
  var Companion_instance_7;
  function Companion_getInstance_9() {
    TgMediaType_initEntries();
    if (Companion_instance_7 == null)
      new Companion_5();
    return Companion_instance_7;
  }
  var TgMediaType_entriesInitialized;
  function TgMediaType_initEntries() {
    if (TgMediaType_entriesInitialized)
      return Unit_instance;
    TgMediaType_entriesInitialized = true;
    TgMediaType_MEDIA_DOCUMENT_instance = new TgMediaType('MEDIA_DOCUMENT', 0, 'mediadocument');
    TgMediaType_MEDIA_WEBPAGE_instance = new TgMediaType('MEDIA_WEBPAGE', 1, 'mediawebpage');
    TgMediaType_MEDIA_PHOTO_instance = new TgMediaType('MEDIA_PHOTO', 2, 'mediaphoto');
    TgMediaType_MEDIA_GEO_instance = new TgMediaType('MEDIA_GEO', 3, 'mediageo');
    TgMediaType_MEDIA_CONTACT_instance = new TgMediaType('MEDIA_CONTACT', 4, 'mediacontact');
    TgMediaType_MEDIA_VENUE_instance = new TgMediaType('MEDIA_VENUE', 5, 'mediavenue');
    TgMediaType_MEDIA_GEO_LIVE_instance = new TgMediaType('MEDIA_GEO_LIVE', 6, 'mediageolive');
    TgMediaType_MEDIA_GAME_instance = new TgMediaType('MEDIA_GAME', 7, 'mediagame');
    TgMediaType_MEDIA_INVOICE_instance = new TgMediaType('MEDIA_INVOICE', 8, 'mediainvoice');
    TgMediaType_UNKNOWN_instance = new TgMediaType('UNKNOWN', 9, 'unknown');
    Companion_getInstance_9();
  }
  function TgMediaType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.d5n_1 = value;
  }
  function Companion_6() {
    Companion_instance_8 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e5n_1 = [Companion_getInstance_9().n59(), null];
  }
  var Companion_instance_8;
  function Companion_getInstance_10() {
    if (Companion_instance_8 == null)
      new Companion_6();
    return Companion_instance_8;
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.mentions.shared.feature.common.network.TgMediaDto', this, 2);
    tmp0_serialDesc.g1o('mediaType', true);
    tmp0_serialDesc.g1o('media', true);
    this.f5n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_5).g5n = function (encoder, value) {
    var tmp0_desc = this.f5n_1;
    var tmp1_output = encoder.x1g(tmp0_desc);
    var tmp2_cached = Companion_getInstance_10().e5n_1;
    if (tmp1_output.t1i(tmp0_desc, 0) ? true : !(value.h5n_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 0, tmp2_cached[0], value.h5n_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 1) ? true : !(value.i5n_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 1, $serializer_getInstance_6(), value.i5n_1);
    }
    tmp1_output.y1g(tmp0_desc);
  };
  protoOf($serializer_5).u1d = function (encoder, value) {
    return this.g5n(encoder, value instanceof TgMediaDto ? value : THROW_CCE());
  };
  protoOf($serializer_5).v1d = function (decoder) {
    var tmp0_desc = this.f5n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.x1g(tmp0_desc);
    var tmp7_cached = Companion_getInstance_10().e5n_1;
    if (tmp6_input.m1h()) {
      tmp4_local0 = tmp6_input.l1h(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.l1h(tmp0_desc, 1, $serializer_getInstance_6(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.n1h(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.l1h(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.l1h(tmp0_desc, 1, $serializer_getInstance_6(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.y1g(tmp0_desc);
    return TgMediaDto_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_5).t1d = function () {
    return this.f5n_1;
  };
  protoOf($serializer_5).z1o = function () {
    var tmp0_cached = Companion_getInstance_10().e5n_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(tmp0_cached[0]), get_nullable($serializer_getInstance_6())];
  };
  var $serializer_instance_5;
  function $serializer_getInstance_5() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function TgMediaDto_init_$Init$(seen0, mediaType, media, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_5().f5n_1);
    }
    if (0 === (seen0 & 1))
      $this.h5n_1 = null;
    else
      $this.h5n_1 = mediaType;
    if (0 === (seen0 & 2))
      $this.i5n_1 = null;
    else
      $this.i5n_1 = media;
    return $this;
  }
  function TgMediaDto_init_$Create$(seen0, mediaType, media, serializationConstructorMarker) {
    return TgMediaDto_init_$Init$(seen0, mediaType, media, serializationConstructorMarker, objectCreate(protoOf(TgMediaDto)));
  }
  function TgMediaDto(mediaType, media) {
    Companion_getInstance_10();
    mediaType = mediaType === VOID ? null : mediaType;
    media = media === VOID ? null : media;
    this.h5n_1 = mediaType;
    this.i5n_1 = media;
  }
  protoOf(TgMediaDto).toString = function () {
    return 'TgMediaDto(mediaType=' + toString_0(this.h5n_1) + ', media=' + toString_0(this.i5n_1) + ')';
  };
  protoOf(TgMediaDto).hashCode = function () {
    var result = this.h5n_1 == null ? 0 : this.h5n_1.hashCode();
    result = imul(result, 31) + (this.i5n_1 == null ? 0 : this.i5n_1.hashCode()) | 0;
    return result;
  };
  protoOf(TgMediaDto).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TgMediaDto))
      return false;
    var tmp0_other_with_cast = other instanceof TgMediaDto ? other : THROW_CCE();
    if (!equals(this.h5n_1, tmp0_other_with_cast.h5n_1))
      return false;
    if (!equals(this.i5n_1, tmp0_other_with_cast.i5n_1))
      return false;
    return true;
  };
  function Companion_7() {
  }
  var Companion_instance_9;
  function Companion_getInstance_11() {
    return Companion_instance_9;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.mentions.shared.feature.common.network.TgMedia', this, 5);
    tmp0_serialDesc.g1o('caption', true);
    tmp0_serialDesc.g1o('file_size', true);
    tmp0_serialDesc.g1o('file_thumbnail_url', true);
    tmp0_serialDesc.g1o('file_url', true);
    tmp0_serialDesc.g1o('media_type', true);
    this.j5n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_6).k5n = function (encoder, value) {
    var tmp0_desc = this.j5n_1;
    var tmp1_output = encoder.x1g(tmp0_desc);
    if (tmp1_output.t1i(tmp0_desc, 0) ? true : !(value.l5n_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 0, StringSerializer_getInstance(), value.l5n_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 1) ? true : !(value.m5n_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 1, IntSerializer_getInstance(), value.m5n_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 2) ? true : !(value.n5n_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 2, StringSerializer_getInstance(), value.n5n_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 3) ? true : !(value.o5n_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 3, StringSerializer_getInstance(), value.o5n_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 4) ? true : !(value.p5n_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 4, StringSerializer_getInstance(), value.p5n_1);
    }
    tmp1_output.y1g(tmp0_desc);
  };
  protoOf($serializer_6).u1d = function (encoder, value) {
    return this.k5n(encoder, value instanceof TgMedia ? value : THROW_CCE());
  };
  protoOf($serializer_6).v1d = function (decoder) {
    var tmp0_desc = this.j5n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.x1g(tmp0_desc);
    if (tmp9_input.m1h()) {
      tmp4_local0 = tmp9_input.l1h(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.l1h(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.l1h(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.l1h(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.l1h(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.n1h(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.l1h(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.l1h(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.l1h(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.l1h(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.l1h(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.y1g(tmp0_desc);
    return TgMedia_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_6).t1d = function () {
    return this.j5n_1;
  };
  protoOf($serializer_6).z1o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_6;
  function $serializer_getInstance_6() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function TgMedia_init_$Init$(seen0, caption, fileSize, fileThumbnailUrl, fileUrl, mediaType, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_6().j5n_1);
    }
    if (0 === (seen0 & 1))
      $this.l5n_1 = null;
    else
      $this.l5n_1 = caption;
    if (0 === (seen0 & 2))
      $this.m5n_1 = null;
    else
      $this.m5n_1 = fileSize;
    if (0 === (seen0 & 4))
      $this.n5n_1 = null;
    else
      $this.n5n_1 = fileThumbnailUrl;
    if (0 === (seen0 & 8))
      $this.o5n_1 = null;
    else
      $this.o5n_1 = fileUrl;
    if (0 === (seen0 & 16))
      $this.p5n_1 = null;
    else
      $this.p5n_1 = mediaType;
    return $this;
  }
  function TgMedia_init_$Create$(seen0, caption, fileSize, fileThumbnailUrl, fileUrl, mediaType, serializationConstructorMarker) {
    return TgMedia_init_$Init$(seen0, caption, fileSize, fileThumbnailUrl, fileUrl, mediaType, serializationConstructorMarker, objectCreate(protoOf(TgMedia)));
  }
  function TgMedia(caption, fileSize, fileThumbnailUrl, fileUrl, mediaType) {
    caption = caption === VOID ? null : caption;
    fileSize = fileSize === VOID ? null : fileSize;
    fileThumbnailUrl = fileThumbnailUrl === VOID ? null : fileThumbnailUrl;
    fileUrl = fileUrl === VOID ? null : fileUrl;
    mediaType = mediaType === VOID ? null : mediaType;
    this.l5n_1 = caption;
    this.m5n_1 = fileSize;
    this.n5n_1 = fileThumbnailUrl;
    this.o5n_1 = fileUrl;
    this.p5n_1 = mediaType;
  }
  protoOf(TgMedia).toString = function () {
    return 'TgMedia(caption=' + this.l5n_1 + ', fileSize=' + this.m5n_1 + ', fileThumbnailUrl=' + this.n5n_1 + ', fileUrl=' + this.o5n_1 + ', mediaType=' + this.p5n_1 + ')';
  };
  protoOf(TgMedia).hashCode = function () {
    var result = this.l5n_1 == null ? 0 : getStringHashCode(this.l5n_1);
    result = imul(result, 31) + (this.m5n_1 == null ? 0 : this.m5n_1) | 0;
    result = imul(result, 31) + (this.n5n_1 == null ? 0 : getStringHashCode(this.n5n_1)) | 0;
    result = imul(result, 31) + (this.o5n_1 == null ? 0 : getStringHashCode(this.o5n_1)) | 0;
    result = imul(result, 31) + (this.p5n_1 == null ? 0 : getStringHashCode(this.p5n_1)) | 0;
    return result;
  };
  protoOf(TgMedia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TgMedia))
      return false;
    var tmp0_other_with_cast = other instanceof TgMedia ? other : THROW_CCE();
    if (!(this.l5n_1 == tmp0_other_with_cast.l5n_1))
      return false;
    if (!(this.m5n_1 == tmp0_other_with_cast.m5n_1))
      return false;
    if (!(this.n5n_1 == tmp0_other_with_cast.n5n_1))
      return false;
    if (!(this.o5n_1 == tmp0_other_with_cast.o5n_1))
      return false;
    if (!(this.p5n_1 == tmp0_other_with_cast.p5n_1))
      return false;
    return true;
  };
  function toDomain(_this__u8e3s4) {
    var tmp = Companion_instance_0;
    var dateFormat = tmp.a21(toDomain$lambda);
    var tmp4_subject = _this__u8e3s4.l5l_1;
    var tmp_0;
    switch (tmp4_subject == null ? -1 : tmp4_subject.f2_1) {
      case 0:
        var tmp0_elvis_lhs = _this__u8e3s4.i5l_1;
        var tmp6_id = tmp0_elvis_lhs == null ? new Long(-1, -1) : tmp0_elvis_lhs;
        // Inline function 'kotlin.text.orEmpty' call

        var tmp5_safe_receiver = _this__u8e3s4.r5l_1;
        var tmp0_elvis_lhs_0 = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.g5m_1;
        var tmp7_link = tmp0_elvis_lhs_0 == null ? '' : tmp0_elvis_lhs_0;
        var tmp1_elvis_lhs = _this__u8e3s4.q5l_1;
        var tmp8_isFavourite = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
        tmp_0 = new TlgItem(tmp6_id, tmp8_isFavourite, '', '', false, '', tmp7_link, '', 0, '', 0);
        break;
      case 1:
        var tmp2_elvis_lhs = _this__u8e3s4.i5l_1;
        var tmp14_id = tmp2_elvis_lhs == null ? new Long(-1, -1) : tmp2_elvis_lhs;
        // Inline function 'kotlin.text.orEmpty' call

        var tmp0_elvis_lhs_1 = _this__u8e3s4.k5l_1;
        var tmp$ret$1 = tmp0_elvis_lhs_1 == null ? '' : tmp0_elvis_lhs_1;
        var tmp15_imageUrl = 'https://favicon.yandex.net/favicon/' + Url(tmp$ret$1).d3m_1 + '?size=32';
        // Inline function 'kotlin.text.orEmpty' call

        var tmp9_safe_receiver = _this__u8e3s4.s5l_1;
        var tmp0_elvis_lhs_2 = tmp9_safe_receiver == null ? null : tmp9_safe_receiver.z5l_1;
        var tmp16_title = tmp0_elvis_lhs_2 == null ? '' : tmp0_elvis_lhs_2;
        // Inline function 'kotlin.text.orEmpty' call

        var tmp0_elvis_lhs_3 = _this__u8e3s4.k5l_1;
        var tmp$ret$3 = tmp0_elvis_lhs_3 == null ? '' : tmp0_elvis_lhs_3;
        var tmp17_source = Url(tmp$ret$3).d3m_1;
        // Inline function 'kotlin.text.orEmpty' call

        var tmp10_safe_receiver = _this__u8e3s4.s5l_1;
        var tmp0_elvis_lhs_4 = tmp10_safe_receiver == null ? null : tmp10_safe_receiver.z5l_1;
        var tmp18_articleTitle = tmp0_elvis_lhs_4 == null ? '' : tmp0_elvis_lhs_4;
        // Inline function 'kotlin.text.orEmpty' call

        var tmp11_safe_receiver = _this__u8e3s4.s5l_1;
        var tmp0_elvis_lhs_5 = tmp11_safe_receiver == null ? null : tmp11_safe_receiver.x5l_1;
        var tmp19_content = tmp0_elvis_lhs_5 == null ? '' : tmp0_elvis_lhs_5;
        // Inline function 'kotlin.text.orEmpty' call

        var tmp12_safe_receiver = _this__u8e3s4.s5l_1;
        var tmp0_elvis_lhs_6 = tmp12_safe_receiver == null ? null : tmp12_safe_receiver.a5m_1;
        var tmp20_link = tmp0_elvis_lhs_6 == null ? '' : tmp0_elvis_lhs_6;
        var tmp_1 = Companion_getInstance_0();
        var tmp13_safe_receiver = _this__u8e3s4.s5l_1;
        var tmp3_elvis_lhs = tmp13_safe_receiver == null ? null : tmp13_safe_receiver.w5l_1;
        var tmp21_dateTime = format(tmp_1.q2d(tmp3_elvis_lhs == null ? new Long(0, 0) : tmp3_elvis_lhs), dateFormat);
        var tmp4_elvis_lhs = _this__u8e3s4.q5l_1;
        var tmp22_isFavourite = tmp4_elvis_lhs == null ? false : tmp4_elvis_lhs;
        tmp_0 = new WebItem(tmp14_id, tmp22_isFavourite, tmp15_imageUrl, tmp16_title, tmp17_source, tmp18_articleTitle, tmp19_content, tmp20_link, tmp21_dateTime);
        break;
      case -1:
        tmp_0 = null;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp_0;
  }
  function toDomain$lambda($this$Format) {
    $this$Format.s22();
    char($this$Format, _Char___init__impl__6a9atx(46));
    $this$Format.r22();
    char($this$Format, _Char___init__impl__6a9atx(32));
    $this$Format.k20();
    char($this$Format, _Char___init__impl__6a9atx(58));
    $this$Format.l20();
    return Unit_instance;
  }
  function TgMediaType_MEDIA_DOCUMENT_getInstance() {
    TgMediaType_initEntries();
    return TgMediaType_MEDIA_DOCUMENT_instance;
  }
  function TgMediaType_MEDIA_WEBPAGE_getInstance() {
    TgMediaType_initEntries();
    return TgMediaType_MEDIA_WEBPAGE_instance;
  }
  function TgMediaType_MEDIA_PHOTO_getInstance() {
    TgMediaType_initEntries();
    return TgMediaType_MEDIA_PHOTO_instance;
  }
  function TgMediaType_MEDIA_GEO_getInstance() {
    TgMediaType_initEntries();
    return TgMediaType_MEDIA_GEO_instance;
  }
  function TgMediaType_MEDIA_CONTACT_getInstance() {
    TgMediaType_initEntries();
    return TgMediaType_MEDIA_CONTACT_instance;
  }
  function TgMediaType_MEDIA_VENUE_getInstance() {
    TgMediaType_initEntries();
    return TgMediaType_MEDIA_VENUE_instance;
  }
  function TgMediaType_MEDIA_GEO_LIVE_getInstance() {
    TgMediaType_initEntries();
    return TgMediaType_MEDIA_GEO_LIVE_instance;
  }
  function TgMediaType_MEDIA_GAME_getInstance() {
    TgMediaType_initEntries();
    return TgMediaType_MEDIA_GAME_instance;
  }
  function TgMediaType_MEDIA_INVOICE_getInstance() {
    TgMediaType_initEntries();
    return TgMediaType_MEDIA_INVOICE_instance;
  }
  function TgMediaType_UNKNOWN_getInstance() {
    TgMediaType_initEntries();
    return TgMediaType_UNKNOWN_instance;
  }
  function get_favouriteModule() {
    _init_properties_FavModule_kt__n3q5f9();
    return favouriteModule;
  }
  var favouriteModule;
  function favouriteModule$lambda($this$module) {
    _init_properties_FavModule_kt__n3q5f9();
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition = favouriteModule$lambda$lambda;
    var scopeQualifier = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind = Kind_Singleton_getInstance();
    var secondaryTypes = emptyList();
    var def = new BeanDefinition(scopeQualifier, getKClass(FavoritesApi), null, definition, kind, secondaryTypes);
    var factory = new SingleInstanceFactory(def);
    $this$module.g2h(factory);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory);
    }
    new KoinDefinition($this$module, factory);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_0 = favouriteModule$lambda$lambda_0;
    var scopeQualifier_0 = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_0 = Kind_Singleton_getInstance();
    var secondaryTypes_0 = emptyList();
    var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(FavouriteRepository), null, definition_0, kind_0, secondaryTypes_0);
    var factory_0 = new SingleInstanceFactory(def_0);
    $this$module.g2h(factory_0);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory_0);
    }
    new KoinDefinition($this$module, factory_0);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_1 = favouriteModule$lambda$lambda_1;
    var scopeQualifier_1 = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_1 = Kind_Singleton_getInstance();
    var secondaryTypes_1 = emptyList();
    var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(AddToFavouriteUseCase), null, definition_1, kind_1, secondaryTypes_1);
    var factory_1 = new SingleInstanceFactory(def_1);
    $this$module.g2h(factory_1);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory_1);
    }
    new KoinDefinition($this$module, factory_1);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_2 = favouriteModule$lambda$lambda_2;
    var scopeQualifier_2 = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_2 = Kind_Singleton_getInstance();
    var secondaryTypes_2 = emptyList();
    var def_2 = new BeanDefinition(scopeQualifier_2, getKClass(DeleteFromFavouriteUseCase), null, definition_2, kind_2, secondaryTypes_2);
    var factory_2 = new SingleInstanceFactory(def_2);
    $this$module.g2h(factory_2);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory_2);
    }
    new KoinDefinition($this$module, factory_2);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_3 = favouriteModule$lambda$lambda_3;
    var scopeQualifier_3 = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_3 = Kind_Singleton_getInstance();
    var secondaryTypes_3 = emptyList();
    var def_3 = new BeanDefinition(scopeQualifier_3, getKClass(GetFavouriteTlgUseCase), null, definition_3, kind_3, secondaryTypes_3);
    var factory_3 = new SingleInstanceFactory(def_3);
    $this$module.g2h(factory_3);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory_3);
    }
    new KoinDefinition($this$module, factory_3);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_4 = favouriteModule$lambda$lambda_4;
    var scopeQualifier_4 = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_4 = Kind_Singleton_getInstance();
    var secondaryTypes_4 = emptyList();
    var def_4 = new BeanDefinition(scopeQualifier_4, getKClass(GetFeedsUseCase), null, definition_4, kind_4, secondaryTypes_4);
    var factory_4 = new SingleInstanceFactory(def_4);
    $this$module.g2h(factory_4);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory_4);
    }
    new KoinDefinition($this$module, factory_4);
    return Unit_instance;
  }
  function favouriteModule$lambda$lambda($this$single, it) {
    _init_properties_FavModule_kt__n3q5f9();
    // Inline function 'org.koin.core.scope.Scope.get' call
    var qualifier = named('SECURE_CLIENT');
    var tmp$ret$0 = $this$single.g2i(getKClass(HttpClient), qualifier, null);
    return new FavoritesApiImpl(tmp$ret$0);
  }
  function favouriteModule$lambda$lambda_0($this$single, it) {
    _init_properties_FavModule_kt__n3q5f9();
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$single.g2i(getKClass(FavoritesApi), null, null);
    return new FavouriteRepositoryImpl(tmp$ret$0);
  }
  function favouriteModule$lambda$lambda_1($this$single, it) {
    _init_properties_FavModule_kt__n3q5f9();
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$single.g2i(getKClass(FavouriteRepository), null, null);
    return new AddToFavouriteUseCase(tmp$ret$0);
  }
  function favouriteModule$lambda$lambda_2($this$single, it) {
    _init_properties_FavModule_kt__n3q5f9();
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$single.g2i(getKClass(FavouriteRepository), null, null);
    return new DeleteFromFavouriteUseCase(tmp$ret$0);
  }
  function favouriteModule$lambda$lambda_3($this$single, it) {
    _init_properties_FavModule_kt__n3q5f9();
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$single.g2i(getKClass(FavouriteRepository), null, null);
    return new GetFavouriteTlgUseCase(tmp$ret$0);
  }
  function favouriteModule$lambda$lambda_4($this$single, it) {
    _init_properties_FavModule_kt__n3q5f9();
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$single.g2i(getKClass(FavouriteRepository), null, null);
    return new GetFeedsUseCase(tmp$ret$0);
  }
  var properties_initialized_FavModule_kt_o1wm0n;
  function _init_properties_FavModule_kt__n3q5f9() {
    if (!properties_initialized_FavModule_kt_o1wm0n) {
      properties_initialized_FavModule_kt_o1wm0n = true;
      favouriteModule = module_0(VOID, favouriteModule$lambda);
    }
  }
  function FavouriteRepository() {
  }
  function $getFavouritesFeedCOROUTINE$0(_this__u8e3s4, source, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z5n_1 = _this__u8e3s4;
    this.a5o_1 = source;
  }
  protoOf($getFavouritesFeedCOROUTINE$0).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 4;
            var tmp_0 = this;
            tmp_0.b5o_1 = this.z5n_1;
            this.k8_1 = 3;
            var tmp_1 = this;
            tmp_1.d5o_1 = Companion_instance;
            var tmp_2 = this;
            tmp_2.e5o_1 = this.b5o_1;
            this.j8_1 = 1;
            suspendResult = this.e5o_1.f5o_1.g5o(0, 50, this.a5o_1.q5j_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            this.j8_1 = 2;
            continue $sm;
          case 1:
            var unboxed = suspendResult.ch_1;
            suspendResult = new Result(unboxed);
            this.j8_1 = 2;
            continue $sm;
          case 2:
            var this_0 = suspendResult.ch_1;
            throwOnFailure(this_0);
            var tmp_3 = _Result___get_value__impl__bjfvqg(this_0);
            var response = (tmp_3 == null ? true : !(tmp_3 == null)) ? tmp_3 : THROW_CCE();
            var tmp_4 = new Long(-1, -1);
            var tmp0_elvis_lhs = response.c5l_1;
            var tmp_5 = tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs;
            var tmp23_safe_receiver = response.d5l_1;
            var tmp_6;
            if (tmp23_safe_receiver == null) {
              tmp_6 = null;
            } else {
              var destination = ArrayList_init_$Create$();
              var tmp0_iterator = tmp23_safe_receiver.g();
              while (tmp0_iterator.h()) {
                var element = tmp0_iterator.i();
                var tmp0_safe_receiver = toDomain(element);
                if (tmp0_safe_receiver == null)
                  null;
                else {
                  destination.e(tmp0_safe_receiver);
                }
              }
              tmp_6 = destination;
            }

            var tmp1_elvis_lhs = tmp_6;
            var value = new FeedPage(tmp_4, tmp_5, tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs);
            this.c5o_1 = _Result___init__impl__xyqfz8(value);
            this.k8_1 = 4;
            this.j8_1 = 5;
            continue $sm;
          case 3:
            this.k8_1 = 4;
            var tmp_7 = this.m8_1;
            if (tmp_7 instanceof Error) {
              var e = this.m8_1;
              var tmp_8 = this;
              tmp_8.c5o_1 = _Result___init__impl__xyqfz8(createFailure(e));
              this.j8_1 = 5;
              continue $sm;
            } else {
              throw this.m8_1;
            }

          case 4:
            throw this.m8_1;
          case 5:
            this.k8_1 = 4;
            return new Result(this.c5o_1);
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.k8_1 === 4) {
          throw e_0;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e_0;
        }
      }
     while (true);
  };
  function FavouriteRepositoryImpl(api) {
    this.f5o_1 = api;
  }
  protoOf(FavouriteRepositoryImpl).q5n = function (source, $completion) {
    var tmp = new $getFavouritesFeedCOROUTINE$0(this, source, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    var tmp_0 = tmp.r8();
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      return tmp_0;
    return tmp_0;
  };
  function AddToFavouriteUseCase(favouriteRepository) {
    NoResult_0.call(this);
    this.i5o_1 = favouriteRepository;
  }
  function DeleteFromFavouriteUseCase(favouriteRepository) {
    NoResult_0.call(this);
    this.k5o_1 = favouriteRepository;
  }
  function toTlgPost(_this__u8e3s4, $this) {
    return new TlgPost(_this__u8e3s4.g5k(), 0, _this__u8e3s4.m3w(), _this__u8e3s4.h5k());
  }
  function $executeCOROUTINE$3(_this__u8e3s4, param, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t5o_1 = _this__u8e3s4;
    this.u5o_1 = param;
  }
  protoOf($executeCOROUTINE$3).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 3;
            this.j8_1 = 1;
            suspendResult = this.t5o_1.w5o_1.q5n(SourceChannel_TELEGRAM_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            this.j8_1 = 2;
            continue $sm;
          case 1:
            var unboxed = suspendResult.ch_1;
            suspendResult = new Result(unboxed);
            this.j8_1 = 2;
            continue $sm;
          case 2:
            var this_0 = suspendResult.ch_1;
            throwOnFailure(this_0);
            var tmp_0 = _Result___get_value__impl__bjfvqg(this_0);
            var response = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
            var this_1 = response.t5j_1;
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
            var tmp0_iterator = this_1.g();
            while (tmp0_iterator.h()) {
              var item = tmp0_iterator.i();
              destination.e(toTlgPost(item, this.t5o_1));
            }

            return destination;
          case 3:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 3) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function GetFavouriteTlgUseCase(repository) {
    NoParam.call(this);
    this.w5o_1 = repository;
  }
  protoOf(GetFavouriteTlgUseCase).x5o = function (param, $completion) {
    var tmp = new $executeCOROUTINE$3(this, param, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(GetFavouriteTlgUseCase).l5j = function (param, $completion) {
    return this.x5o(param instanceof Unit ? param : THROW_CCE(), $completion);
  };
  function GetFeedsUseCase(repository) {
    UseCase.call(this);
    this.z5o_1 = repository;
  }
  function FavoritesApi() {
  }
  function Companion_8() {
    Companion_instance_10 = this;
    this.a5p_1 = SharedModule_instance.p5i() + '/favorites';
  }
  var Companion_instance_10;
  function Companion_getInstance_12() {
    if (Companion_instance_10 == null)
      new Companion_8();
    return Companion_instance_10;
  }
  function FavoritesApiImpl$getFavoritesData$lambda($offset, $limit, $source) {
    return function ($this$url, it) {
      $this$url.z3l_1.x38('offset', $offset.toString());
      $this$url.z3l_1.x38('limit', $limit.toString());
      $this$url.z3l_1.x38('source', $source);
      return Unit_instance;
    };
  }
  function $getFavoritesDataCOROUTINE$5(_this__u8e3s4, offset, limit, source, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.j5p_1 = _this__u8e3s4;
    this.k5p_1 = offset;
    this.l5p_1 = limit;
    this.m5p_1 = source;
  }
  protoOf($getFavoritesDataCOROUTINE$5).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 4;
            var tmp_0 = this;
            tmp_0.n5p_1 = this.j5p_1;
            this.k8_1 = 3;
            var tmp_1 = this;
            tmp_1.p5p_1 = Companion_instance;
            var tmp_2 = this;
            tmp_2.q5p_1 = this.n5p_1;
            var tmp_3 = this;
            tmp_3.r5p_1 = this.q5p_1.z5p_1;
            var tmp_4 = this;
            tmp_4.s5p_1 = Companion_getInstance_12().a5p_1;
            var tmp_5 = this;
            tmp_5.t5p_1 = this.r5p_1;
            var tmp_6 = this;
            tmp_6.u5p_1 = this.t5p_1;
            var tmp_7 = this;
            var this_0 = new HttpRequestBuilder();
            url(this_0, this.s5p_1);
            this_0.d4j(FavoritesApiImpl$getFavoritesData$lambda(this.k5p_1, this.l5p_1, this.m5p_1));
            tmp_7.v5p_1 = this_0;
            this.v5p_1.b3u_1 = Companion_getInstance_1().q3i_1;
            var tmp_8 = this;
            tmp_8.w5p_1 = this.u5p_1;
            var tmp_9 = this;
            tmp_9.x5p_1 = this.v5p_1;
            this.j8_1 = 1;
            suspendResult = (new HttpStatement(this.x5p_1, this.w5p_1)).j4n(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.y5p_1 = suspendResult;
            this.j8_1 = 2;
            var tmp_10 = this.y5p_1.h3x();
            var tmp_11 = JsType_instance;
            var tmp_12 = getKClass(MentionFeedResponse);
            var tmp_13;
            try {
              tmp_13 = createKType(getKClass(MentionFeedResponse), arrayOf([]), false);
            } catch ($p) {
              var tmp_14;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_14 = null;
              } else {
                throw $p;
              }
              tmp_13 = tmp_14;
            }

            suspendResult = tmp_10.l3w(typeInfoImpl(tmp_11, tmp_12, tmp_13), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0_elvis_lhs = suspendResult instanceof MentionFeedResponse ? suspendResult : null;
            var tmp_15;
            if (tmp0_elvis_lhs == null) {
              throw new ApiError(-1, 'Empty body');
            } else {
              tmp_15 = tmp0_elvis_lhs;
            }

            var value = tmp_15;
            this.o5p_1 = _Result___init__impl__xyqfz8(value);
            this.k8_1 = 4;
            this.j8_1 = 5;
            continue $sm;
          case 3:
            this.k8_1 = 4;
            var tmp_16 = this.m8_1;
            if (tmp_16 instanceof Error) {
              var e = this.m8_1;
              var tmp_17 = this;
              tmp_17.o5p_1 = _Result___init__impl__xyqfz8(createFailure(e));
              this.j8_1 = 5;
              continue $sm;
            } else {
              throw this.m8_1;
            }

          case 4:
            throw this.m8_1;
          case 5:
            this.k8_1 = 4;
            return new Result(this.o5p_1);
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.k8_1 === 4) {
          throw e_0;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e_0;
        }
      }
     while (true);
  };
  function FavoritesApiImpl(secureClient) {
    Companion_getInstance_12();
    this.z5p_1 = secureClient;
  }
  protoOf(FavoritesApiImpl).g5o = function (offset, limit, source, $completion) {
    var tmp = new $getFavoritesDataCOROUTINE$5(this, offset, limit, source, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    var tmp_0 = tmp.r8();
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      return tmp_0;
    return tmp_0;
  };
  function Companion_9() {
  }
  var Companion_instance_11;
  function Companion_getInstance_13() {
    return Companion_instance_11;
  }
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.mentions.shared.feature.feed.TlgPost', this, 4);
    tmp0_serialDesc.g1o('id', false);
    tmp0_serialDesc.g1o('reposts', false);
    tmp0_serialDesc.g1o('rawLink', false);
    tmp0_serialDesc.g1o('isFavourite', false);
    this.a5q_1 = tmp0_serialDesc;
  }
  protoOf($serializer_7).b5q = function (encoder, value) {
    var tmp0_desc = this.a5q_1;
    var tmp1_output = encoder.x1g(tmp0_desc);
    tmp1_output.h1i(tmp0_desc, 0, value.c5q_1);
    tmp1_output.g1i(tmp0_desc, 1, value.d5q_1);
    tmp1_output.l1i(tmp0_desc, 2, value.e5q_1);
    tmp1_output.d1i(tmp0_desc, 3, value.f5q_1);
    tmp1_output.y1g(tmp0_desc);
  };
  protoOf($serializer_7).u1d = function (encoder, value) {
    return this.b5q(encoder, value instanceof TlgPost ? value : THROW_CCE());
  };
  protoOf($serializer_7).v1d = function (decoder) {
    var tmp0_desc = this.a5q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_local3 = false;
    var tmp8_input = decoder.x1g(tmp0_desc);
    if (tmp8_input.m1h()) {
      tmp4_local0 = tmp8_input.d1h(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.c1h(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.h1h(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.z1g(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.n1h(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.d1h(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.c1h(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.h1h(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.z1g(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.y1g(tmp0_desc);
    return TlgPost_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_7).t1d = function () {
    return this.a5q_1;
  };
  protoOf($serializer_7).z1o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_7;
  function $serializer_getInstance_7() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function TlgPost_init_$Init$(seen0, id, reposts, rawLink, isFavourite, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_7().a5q_1);
    }
    $this.c5q_1 = id;
    $this.d5q_1 = reposts;
    $this.e5q_1 = rawLink;
    $this.f5q_1 = isFavourite;
    return $this;
  }
  function TlgPost_init_$Create$(seen0, id, reposts, rawLink, isFavourite, serializationConstructorMarker) {
    return TlgPost_init_$Init$(seen0, id, reposts, rawLink, isFavourite, serializationConstructorMarker, objectCreate(protoOf(TlgPost)));
  }
  function TlgPost(id, reposts, rawLink, isFavourite) {
    this.c5q_1 = id;
    this.d5q_1 = reposts;
    this.e5q_1 = rawLink;
    this.f5q_1 = isFavourite;
  }
  protoOf(TlgPost).g5q = function () {
    return replace(this.e5q_1, 'https://t.me/', '');
  };
  protoOf(TlgPost).h5q = function () {
    var tmp;
    if (!this.c5q_1.equals(new Long(-1, -1))) {
      // Inline function 'kotlin.text.isNotBlank' call
      var this_0 = this.g5q();
      tmp = !isBlank(this_0);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(TlgPost).toString = function () {
    return 'TlgPost(id=' + this.c5q_1.toString() + ', reposts=' + this.d5q_1 + ', rawLink=' + this.e5q_1 + ', isFavourite=' + this.f5q_1 + ')';
  };
  protoOf(TlgPost).hashCode = function () {
    var result = this.c5q_1.hashCode();
    result = imul(result, 31) + this.d5q_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.e5q_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f5q_1) | 0;
    return result;
  };
  protoOf(TlgPost).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TlgPost))
      return false;
    var tmp0_other_with_cast = other instanceof TlgPost ? other : THROW_CCE();
    if (!this.c5q_1.equals(tmp0_other_with_cast.c5q_1))
      return false;
    if (!(this.d5q_1 === tmp0_other_with_cast.d5q_1))
      return false;
    if (!(this.e5q_1 === tmp0_other_with_cast.e5q_1))
      return false;
    if (!(this.f5q_1 === tmp0_other_with_cast.f5q_1))
      return false;
    return true;
  };
  function TlgFeedRepository() {
  }
  function toTlgPost_0(_this__u8e3s4, $this) {
    var tmp0_elvis_lhs = _this__u8e3s4.i5l_1;
    var tmp = tmp0_elvis_lhs == null ? new Long(-1, -1) : tmp0_elvis_lhs;
    // Inline function 'kotlin.text.orEmpty' call
    var tmp26_safe_receiver = _this__u8e3s4.r5l_1;
    var tmp0_elvis_lhs_0 = tmp26_safe_receiver == null ? null : tmp26_safe_receiver.g5m_1;
    var tmp_0 = tmp0_elvis_lhs_0 == null ? '' : tmp0_elvis_lhs_0;
    var tmp1_elvis_lhs = _this__u8e3s4.q5l_1;
    return new TlgPost(tmp, 0, tmp_0, tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs);
  }
  function $getTlgLinksCOROUTINE$9(_this__u8e3s4, subjectId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.r5q_1 = _this__u8e3s4;
    this.s5q_1 = subjectId;
  }
  protoOf($getTlgLinksCOROUTINE$9).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 7;
            var tmp_0 = this;
            tmp_0.t5q_1 = this.r5q_1;
            this.k8_1 = 6;
            var tmp_1 = this;
            tmp_1.v5q_1 = Companion_instance;
            this.w5q_1 = Unit_instance;
            this.j8_1 = 1;
            continue $sm;
          case 1:
            var tmp_2 = this;
            tmp_2.x5q_1 = this.t5q_1;
            this.y5q_1 = this.x5q_1.a5r_1;
            this.z5q_1 = FeedSource_TELEGRAM_getInstance_0();
            this.j8_1 = 2;
            suspendResult = this.y5q_1.b5r(this.s5q_1, 50, VOID, VOID, this.z5q_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            this.j8_1 = 3;
            continue $sm;
          case 2:
            var unboxed = suspendResult.ch_1;
            suspendResult = new Result(unboxed);
            this.j8_1 = 3;
            continue $sm;
          case 3:
            var this_0 = suspendResult.ch_1;
            throwOnFailure(this_0);
            var tmp_3 = _Result___get_value__impl__bjfvqg(this_0);
            var ARGUMENT = (tmp_3 == null ? true : !(tmp_3 == null)) ? tmp_3 : THROW_CCE();
            var tmp0_elvis_lhs = ARGUMENT.d5l_1;
            var WHEN_RESULT;
            if (tmp0_elvis_lhs == null) {
              this.w5q_1 = emptyList();
              this.j8_1 = 5;
              continue $sm;
            } else {
              WHEN_RESULT = tmp0_elvis_lhs;
              this.j8_1 = 4;
              continue $sm;
            }

          case 4:
            var data = WHEN_RESULT;
            var destination = ArrayList_init_$Create$();
            var tmp0_iterator = data.g();
            while (tmp0_iterator.h()) {
              var element = tmp0_iterator.i();
              if (!(element.r5l_1 == null)) {
                destination.e(element);
              }
            }

            var tlgPosts = destination;
            var tmp_4 = this;
            var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tlgPosts, 10));
            var tmp0_iterator_0 = tlgPosts.g();
            while (tmp0_iterator_0.h()) {
              var item = tmp0_iterator_0.i();
              destination_0.e(toTlgPost_0(item, this.x5q_1));
            }

            var destination_1 = ArrayList_init_$Create$();
            var tmp0_iterator_1 = destination_0.g();
            while (tmp0_iterator_1.h()) {
              var element_0 = tmp0_iterator_1.i();
              if (element_0.h5q()) {
                destination_1.e(element_0);
              }
            }

            tmp_4.w5q_1 = destination_1;
            if (false) {
              this.j8_1 = 1;
              continue $sm;
            }

            this.j8_1 = 5;
            continue $sm;
          case 5:
            var value = this.w5q_1;
            this.u5q_1 = _Result___init__impl__xyqfz8(value);
            this.k8_1 = 7;
            this.j8_1 = 8;
            continue $sm;
          case 6:
            this.k8_1 = 7;
            var tmp_5 = this.m8_1;
            if (tmp_5 instanceof Error) {
              var e = this.m8_1;
              var tmp_6 = this;
              tmp_6.u5q_1 = _Result___init__impl__xyqfz8(createFailure(e));
              this.j8_1 = 8;
              continue $sm;
            } else {
              throw this.m8_1;
            }

          case 7:
            throw this.m8_1;
          case 8:
            this.k8_1 = 7;
            return new Result(this.u5q_1);
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.k8_1 === 7) {
          throw e_0;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e_0;
        }
      }
     while (true);
  };
  function TlgFeedRepositoryImpl(monitorApi) {
    this.a5r_1 = monitorApi;
  }
  protoOf(TlgFeedRepositoryImpl).i5q = function (subjectId, $completion) {
    var tmp = new $getTlgLinksCOROUTINE$9(this, subjectId, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    var tmp_0 = tmp.r8();
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      return tmp_0;
    return tmp_0;
  };
  function get_monitorFeedModule() {
    _init_properties_MonitorFeedModule_kt__h2if66();
    return monitorFeedModule;
  }
  var monitorFeedModule;
  function monitorFeedModule$lambda($this$module) {
    _init_properties_MonitorFeedModule_kt__h2if66();
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition = monitorFeedModule$lambda$lambda;
    var scopeQualifier = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind = Kind_Singleton_getInstance();
    var secondaryTypes = emptyList();
    var def = new BeanDefinition(scopeQualifier, getKClass(TlgFeedRepository), null, definition, kind, secondaryTypes);
    var factory = new SingleInstanceFactory(def);
    $this$module.g2h(factory);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory);
    }
    new KoinDefinition($this$module, factory);
    return Unit_instance;
  }
  function monitorFeedModule$lambda$lambda($this$single, it) {
    _init_properties_MonitorFeedModule_kt__h2if66();
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$single.g2i(getKClass(MonitorApi), null, null);
    return new TlgFeedRepositoryImpl(tmp$ret$0);
  }
  var properties_initialized_MonitorFeedModule_kt_bq4oq4;
  function _init_properties_MonitorFeedModule_kt__h2if66() {
    if (!properties_initialized_MonitorFeedModule_kt_bq4oq4) {
      properties_initialized_MonitorFeedModule_kt_bq4oq4 = true;
      monitorFeedModule = module_0(VOID, monitorFeedModule$lambda);
    }
  }
  function _get_$cachedSerializer__te6jhj_0($this) {
    return $this.e5l_1.v();
  }
  function FeedSource$Companion$_anonymous__6g0ydm() {
    var tmp = values_0();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = ['telegram', 'website'];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = [null, null];
    return createAnnotatedEnumSerializer('com.mentions.shared.feature.feed.network.FeedSource', tmp, tmp_0, tmp$ret$5, null);
  }
  var FeedSource_TELEGRAM_instance;
  var FeedSource_WEB_SITE_instance;
  function values_0() {
    return [FeedSource_TELEGRAM_getInstance(), FeedSource_WEB_SITE_getInstance()];
  }
  function Companion_10() {
    Companion_instance_12 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e5l_1 = lazy(tmp_0, FeedSource$Companion$_anonymous__6g0ydm);
  }
  protoOf(Companion_10).n59 = function () {
    return _get_$cachedSerializer__te6jhj_0(this);
  };
  protoOf(Companion_10).k1p = function (typeParamsSerializers) {
    return this.n59();
  };
  var Companion_instance_12;
  function Companion_getInstance_14() {
    FeedSource_initEntries();
    if (Companion_instance_12 == null)
      new Companion_10();
    return Companion_instance_12;
  }
  var FeedSource_entriesInitialized;
  function FeedSource_initEntries() {
    if (FeedSource_entriesInitialized)
      return Unit_instance;
    FeedSource_entriesInitialized = true;
    FeedSource_TELEGRAM_instance = new FeedSource('TELEGRAM', 0, 'telegram');
    FeedSource_WEB_SITE_instance = new FeedSource('WEB_SITE', 1, 'website');
    Companion_getInstance_14();
  }
  function FeedSource(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.e5r_1 = value;
  }
  function FeedSource_TELEGRAM_getInstance() {
    FeedSource_initEntries();
    return FeedSource_TELEGRAM_instance;
  }
  function FeedSource_WEB_SITE_getInstance() {
    FeedSource_initEntries();
    return FeedSource_WEB_SITE_instance;
  }
  function get_feedbackModule() {
    _init_properties_FeedbackModule_kt__yf1r67();
    return feedbackModule;
  }
  var feedbackModule;
  function feedbackModule$lambda($this$module) {
    _init_properties_FeedbackModule_kt__yf1r67();
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition = feedbackModule$lambda$lambda;
    var scopeQualifier = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind = Kind_Singleton_getInstance();
    var secondaryTypes = emptyList();
    var def = new BeanDefinition(scopeQualifier, getKClass(FeedbackApi), null, definition, kind, secondaryTypes);
    var factory = new SingleInstanceFactory(def);
    $this$module.g2h(factory);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory);
    }
    new KoinDefinition($this$module, factory);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_0 = feedbackModule$lambda$lambda_0;
    var scopeQualifier_0 = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_0 = Kind_Singleton_getInstance();
    var secondaryTypes_0 = emptyList();
    var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(FeedbackManager), null, definition_0, kind_0, secondaryTypes_0);
    var factory_0 = new SingleInstanceFactory(def_0);
    $this$module.g2h(factory_0);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory_0);
    }
    new KoinDefinition($this$module, factory_0);
    return Unit_instance;
  }
  function feedbackModule$lambda$lambda($this$single, it) {
    _init_properties_FeedbackModule_kt__yf1r67();
    // Inline function 'org.koin.core.scope.Scope.get' call
    var qualifier = named('SECURE_CLIENT');
    var tmp$ret$0 = $this$single.g2i(getKClass(HttpClient), qualifier, null);
    return new FeedbackApiImpl(tmp$ret$0);
  }
  function feedbackModule$lambda$lambda_0($this$single, it) {
    _init_properties_FeedbackModule_kt__yf1r67();
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$single.g2i(getKClass(FeedbackApi), null, null);
    return new FeedbackManagerImpl(tmp$ret$0);
  }
  var properties_initialized_FeedbackModule_kt_t464xf;
  function _init_properties_FeedbackModule_kt__yf1r67() {
    if (!properties_initialized_FeedbackModule_kt_t464xf) {
      properties_initialized_FeedbackModule_kt_t464xf = true;
      feedbackModule = module_0(VOID, feedbackModule$lambda);
    }
  }
  function FeedbackManager() {
  }
  function FeedbackManagerImpl(api) {
    this.f5r_1 = api;
  }
  function FeedbackApi() {
  }
  function Companion_11() {
    Companion_instance_13 = this;
    this.g5r_1 = SharedModule_instance.p5i() + '/feedback';
  }
  var Companion_instance_13;
  function Companion_getInstance_15() {
    if (Companion_instance_13 == null)
      new Companion_11();
    return Companion_instance_13;
  }
  function FeedbackApiImpl(secureClient) {
    Companion_getInstance_15();
    this.h5r_1 = secureClient;
  }
  function get_monitorModule() {
    _init_properties_MonitorModule_kt__hnse0k();
    return monitorModule;
  }
  var monitorModule;
  function monitorModule$lambda($this$module) {
    _init_properties_MonitorModule_kt__hnse0k();
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition = monitorModule$lambda$lambda;
    var scopeQualifier = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind = Kind_Singleton_getInstance();
    var secondaryTypes = emptyList();
    var def = new BeanDefinition(scopeQualifier, getKClass(MonitorApi), null, definition, kind, secondaryTypes);
    var factory = new SingleInstanceFactory(def);
    $this$module.g2h(factory);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory);
    }
    new KoinDefinition($this$module, factory);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_0 = monitorModule$lambda$lambda_0;
    var scopeQualifier_0 = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_0 = Kind_Singleton_getInstance();
    var secondaryTypes_0 = emptyList();
    var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(FavoritesApi), null, definition_0, kind_0, secondaryTypes_0);
    var factory_0 = new SingleInstanceFactory(def_0);
    $this$module.g2h(factory_0);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory_0);
    }
    new KoinDefinition($this$module, factory_0);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_1 = monitorModule$lambda$lambda_1;
    var scopeQualifier_1 = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_1 = Kind_Singleton_getInstance();
    var secondaryTypes_1 = emptyList();
    var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(NutcallSearchApi), null, definition_1, kind_1, secondaryTypes_1);
    var factory_1 = new SingleInstanceFactory(def_1);
    $this$module.g2h(factory_1);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory_1);
    }
    new KoinDefinition($this$module, factory_1);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_2 = monitorModule$lambda$lambda_2;
    var scopeQualifier_2 = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_2 = Kind_Singleton_getInstance();
    var secondaryTypes_2 = emptyList();
    var def_2 = new BeanDefinition(scopeQualifier_2, getKClass(MonitorRepository), null, definition_2, kind_2, secondaryTypes_2);
    var factory_2 = new SingleInstanceFactory(def_2);
    $this$module.g2h(factory_2);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory_2);
    }
    new KoinDefinition($this$module, factory_2);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_3 = monitorModule$lambda$lambda_3;
    var scopeQualifier_3 = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_3 = Kind_Singleton_getInstance();
    var secondaryTypes_3 = emptyList();
    var def_3 = new BeanDefinition(scopeQualifier_3, getKClass(AddNewSubjectUseCase), null, definition_3, kind_3, secondaryTypes_3);
    var factory_3 = new SingleInstanceFactory(def_3);
    $this$module.g2h(factory_3);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory_3);
    }
    new KoinDefinition($this$module, factory_3);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_4 = monitorModule$lambda$lambda_4;
    var scopeQualifier_4 = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_4 = Kind_Singleton_getInstance();
    var secondaryTypes_4 = emptyList();
    var def_4 = new BeanDefinition(scopeQualifier_4, getKClass(RemoveSubjectUseCase), null, definition_4, kind_4, secondaryTypes_4);
    var factory_4 = new SingleInstanceFactory(def_4);
    $this$module.g2h(factory_4);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory_4);
    }
    new KoinDefinition($this$module, factory_4);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_5 = monitorModule$lambda$lambda_5;
    var scopeQualifier_5 = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_5 = Kind_Singleton_getInstance();
    var secondaryTypes_5 = emptyList();
    var def_5 = new BeanDefinition(scopeQualifier_5, getKClass(SubscribeToSubjectsUseCase), null, definition_5, kind_5, secondaryTypes_5);
    var factory_5 = new SingleInstanceFactory(def_5);
    $this$module.g2h(factory_5);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory_5);
    }
    new KoinDefinition($this$module, factory_5);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_6 = monitorModule$lambda$lambda_6;
    var scopeQualifier_6 = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_6 = Kind_Singleton_getInstance();
    var secondaryTypes_6 = emptyList();
    var def_6 = new BeanDefinition(scopeQualifier_6, getKClass(SubscribeToActiveSubjectUseCase), null, definition_6, kind_6, secondaryTypes_6);
    var factory_6 = new SingleInstanceFactory(def_6);
    $this$module.g2h(factory_6);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory_6);
    }
    new KoinDefinition($this$module, factory_6);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_7 = monitorModule$lambda$lambda_7;
    var scopeQualifier_7 = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_7 = Kind_Singleton_getInstance();
    var secondaryTypes_7 = emptyList();
    var def_7 = new BeanDefinition(scopeQualifier_7, getKClass(ChangeActiveSubjectUseCase), null, definition_7, kind_7, secondaryTypes_7);
    var factory_7 = new SingleInstanceFactory(def_7);
    $this$module.g2h(factory_7);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory_7);
    }
    new KoinDefinition($this$module, factory_7);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_8 = monitorModule$lambda$lambda_8;
    var scopeQualifier_8 = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_8 = Kind_Singleton_getInstance();
    var secondaryTypes_8 = emptyList();
    var def_8 = new BeanDefinition(scopeQualifier_8, getKClass(UpdateSubjectsUseCase), null, definition_8, kind_8, secondaryTypes_8);
    var factory_8 = new SingleInstanceFactory(def_8);
    $this$module.g2h(factory_8);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory_8);
    }
    new KoinDefinition($this$module, factory_8);
    return Unit_instance;
  }
  function monitorModule$lambda$lambda($this$single, it) {
    _init_properties_MonitorModule_kt__hnse0k();
    // Inline function 'org.koin.core.scope.Scope.get' call
    var qualifier = named('SECURE_CLIENT');
    var tmp$ret$0 = $this$single.g2i(getKClass(HttpClient), qualifier, null);
    return new MonitorApiImpl(tmp$ret$0);
  }
  function monitorModule$lambda$lambda_0($this$single, it) {
    _init_properties_MonitorModule_kt__hnse0k();
    // Inline function 'org.koin.core.scope.Scope.get' call
    var qualifier = named('SECURE_CLIENT');
    var tmp$ret$0 = $this$single.g2i(getKClass(HttpClient), qualifier, null);
    return new FavoritesApiImpl(tmp$ret$0);
  }
  function monitorModule$lambda$lambda_1($this$single, it) {
    _init_properties_MonitorModule_kt__hnse0k();
    // Inline function 'org.koin.core.scope.Scope.get' call
    var qualifier = named('NUTCALL_CLIENT');
    var tmp$ret$0 = $this$single.g2i(getKClass(HttpClient), qualifier, null);
    return new NutcallSearchApiImpl(tmp$ret$0);
  }
  function monitorModule$lambda$lambda_2($this$single, it) {
    _init_properties_MonitorModule_kt__hnse0k();
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$single.g2i(getKClass(NutcallSearchApi), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$single.g2i(getKClass(MonitorApi), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_1 = $this$single.g2i(getKClass(FavoritesApi), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$3 = $this$single.g2i(getKClass(MonitoringStorage), null, null);
    return new MonitorRepositoryImpl(tmp, tmp_0, tmp_1, tmp$ret$3);
  }
  function monitorModule$lambda$lambda_3($this$single, it) {
    _init_properties_MonitorModule_kt__hnse0k();
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$single.g2i(getKClass(MonitorRepository), null, null);
    return new AddNewSubjectUseCase(tmp$ret$0);
  }
  function monitorModule$lambda$lambda_4($this$single, it) {
    _init_properties_MonitorModule_kt__hnse0k();
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$single.g2i(getKClass(MonitorRepository), null, null);
    return new RemoveSubjectUseCase(tmp$ret$0);
  }
  function monitorModule$lambda$lambda_5($this$single, it) {
    _init_properties_MonitorModule_kt__hnse0k();
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$single.g2i(getKClass(MonitorRepository), null, null);
    return new SubscribeToSubjectsUseCase(tmp$ret$0);
  }
  function monitorModule$lambda$lambda_6($this$single, it) {
    _init_properties_MonitorModule_kt__hnse0k();
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$single.g2i(getKClass(MonitoringStorage), null, null);
    return new SubscribeToActiveSubjectUseCase(tmp$ret$0);
  }
  function monitorModule$lambda$lambda_7($this$single, it) {
    _init_properties_MonitorModule_kt__hnse0k();
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$single.g2i(getKClass(MonitoringStorage), null, null);
    return new ChangeActiveSubjectUseCase(tmp$ret$0);
  }
  function monitorModule$lambda$lambda_8($this$single, it) {
    _init_properties_MonitorModule_kt__hnse0k();
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$single.g2i(getKClass(MonitorRepository), null, null);
    return new UpdateSubjectsUseCase(tmp$ret$0);
  }
  var properties_initialized_MonitorModule_kt_y1dlqu;
  function _init_properties_MonitorModule_kt__hnse0k() {
    if (!properties_initialized_MonitorModule_kt_y1dlqu) {
      properties_initialized_MonitorModule_kt_y1dlqu = true;
      monitorModule = module_0(VOID, monitorModule$lambda);
    }
  }
  function MonitorRepository() {
  }
  function getSubjects($this, $completion) {
    var tmp = new $getSubjectsCOROUTINE$19($this, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    var tmp_0 = tmp.r8();
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      return tmp_0;
    return tmp_0;
  }
  function MonitorRepositoryImpl$subjectState$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(MonitorRepositoryImpl$subjectState$slambda).f5s = function (subs, err, $completion) {
    var tmp = this.g5s(subs, err, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(MonitorRepositoryImpl$subjectState$slambda).xg = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE();
    return this.f5s(tmp, (p2 == null ? true : p2 instanceof Error) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(MonitorRepositoryImpl$subjectState$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        if (tmp === 0) {
          this.k8_1 = 1;
          return new SubjectsState(this.d5s_1, this.e5s_1);
        } else if (tmp === 1) {
          throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(MonitorRepositoryImpl$subjectState$slambda).g5s = function (subs, err, completion) {
    var i = new MonitorRepositoryImpl$subjectState$slambda(completion);
    i.d5s_1 = subs;
    i.e5s_1 = err;
    return i;
  };
  function MonitorRepositoryImpl$subjectState$slambda_0(resultContinuation) {
    var i = new MonitorRepositoryImpl$subjectState$slambda(resultContinuation);
    var l = function (subs, err, $completion) {
      return i.f5s(subs, err, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function MonitorRepositoryImpl$slambda(this$0, resultContinuation) {
    this.p5s_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(MonitorRepositoryImpl$slambda).l17 = function ($this$launch, $completion) {
    var tmp = this.m17($this$launch, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(MonitorRepositoryImpl$slambda).m9 = function (p1, $completion) {
    return this.l17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(MonitorRepositoryImpl$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 2;
            this.j8_1 = 1;
            suspendResult = this.p5s_1.z5s(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 2) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(MonitorRepositoryImpl$slambda).m17 = function ($this$launch, completion) {
    var i = new MonitorRepositoryImpl$slambda(this.p5s_1, completion);
    i.q5s_1 = $this$launch;
    return i;
  };
  function MonitorRepositoryImpl$slambda_0(this$0, resultContinuation) {
    var i = new MonitorRepositoryImpl$slambda(this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.l17($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $updateCOROUTINE$12(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i5t_1 = _this__u8e3s4;
  }
  protoOf($updateCOROUTINE$12).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 8;
            this.j8_1 = 1;
            suspendResult = getSubjects(this.i5t_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            this.j8_1 = 2;
            continue $sm;
          case 1:
            this.j5t_1 = suspendResult.ch_1;
            suspendResult = new Result(this.j5t_1);
            this.j8_1 = 2;
            continue $sm;
          case 2:
            this.k5t_1 = suspendResult.ch_1;
            if (_Result___get_isSuccess__impl__sndoy8(this.k5t_1)) {
              var tmp_0 = this;
              var tmp_1 = _Result___get_value__impl__bjfvqg(this.k5t_1);
              tmp_0.l5t_1 = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
              this.m5t_1 = this.i5t_1.u5s_1.n5t();
              var tmp_2;
              if (this.m5t_1 == null) {
                tmp_2 = !this.l5t_1.o();
              } else {
                tmp_2 = false;
              }
              if (tmp_2) {
                this.j8_1 = 3;
                var tmp0_elvis_lhs = first(this.l5t_1).g5k();
                var tmp_3;
                if (tmp0_elvis_lhs == null) {
                  throw IllegalStateException_init_$Create$("Subject wo id can't be observed");
                } else {
                  tmp_3 = tmp0_elvis_lhs;
                }
                suspendResult = this.i5t_1.u5s_1.p5t(tmp_3, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.j8_1 = 4;
                continue $sm;
              }
            } else {
              this.j8_1 = 7;
              continue $sm;
            }

          case 3:
            this.j8_1 = 4;
            continue $sm;
          case 4:
            var tmp_4;
            var this_0 = this.l5t_1;
            var destination = ArrayList_init_$Create$();
            var tmp0_iterator = this_0.g();
            while (tmp0_iterator.h()) {
              var element = tmp0_iterator.i();
              var tmp0_safe_receiver = element.g5k();
              if (tmp0_safe_receiver == null)
                null;
              else {
                destination.e(tmp0_safe_receiver);
              }
            }

            if (!contains(toSet(destination), this.m5t_1)) {
              tmp_4 = !this.l5t_1.o();
            } else {
              tmp_4 = false;
            }

            if (tmp_4) {
              this.j8_1 = 5;
              var tmp1_elvis_lhs = first(this.l5t_1).g5k();
              var tmp_5;
              if (tmp1_elvis_lhs == null) {
                throw IllegalStateException_init_$Create$("Subject wo id can't be observed");
              } else {
                tmp_5 = tmp1_elvis_lhs;
              }
              suspendResult = this.i5t_1.u5s_1.p5t(tmp_5, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.j8_1 = 6;
              continue $sm;
            }

          case 5:
            this.j8_1 = 6;
            continue $sm;
          case 6:
            this.i5t_1.w5s_1.l15(null);
            this.i5t_1.v5s_1.l15(this.l5t_1);
            this.j8_1 = 7;
            continue $sm;
          case 7:
            var this_1 = this.k5t_1;
            var tmp0_safe_receiver_0 = Result__exceptionOrNull_impl_p6xea9(this_1);
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              l$ret$1: do {
                var this_2 = this.i5t_1.v5s_1;
                while (true) {
                  var prevValue = this_2.v();
                  var nextValue = emptyList();
                  if (this_2.m15(prevValue, nextValue)) {
                    break l$ret$1;
                  }
                }
              }
               while (false);
              this.i5t_1.w5s_1.l15(tmp0_safe_receiver_0);
            }

            return Unit_instance;
          case 8:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 8) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function $getSubjectsCOROUTINE$19(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.q5r_1 = _this__u8e3s4;
  }
  protoOf($getSubjectsCOROUTINE$19).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 4;
            var tmp_0 = this;
            tmp_0.r5r_1 = this.q5r_1;
            this.k8_1 = 3;
            var tmp_1 = this;
            tmp_1.t5r_1 = Companion_instance;
            var tmp_2 = this;
            tmp_2.u5r_1 = this.r5r_1;
            this.j8_1 = 1;
            suspendResult = this.u5r_1.s5s_1.q5t(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            this.j8_1 = 2;
            continue $sm;
          case 1:
            var unboxed = suspendResult.ch_1;
            suspendResult = new Result(unboxed);
            this.j8_1 = 2;
            continue $sm;
          case 2:
            var this_0 = suspendResult.ch_1;
            var tmp_3;
            if (_Result___get_isFailure__impl__jpiriv(this_0)) {
              tmp_3 = null;
            } else {
              var tmp_4 = _Result___get_value__impl__bjfvqg(this_0);
              tmp_3 = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : THROW_CCE();
            }

            var tmp0_elvis_lhs = tmp_3;
            var request = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(request, 10));
            var tmp0_iterator = request.g();
            while (tmp0_iterator.h()) {
              var item = tmp0_iterator.i();
              var tmp_5;
              if (!(item.t5t_1 == null)) {
                var tmp_6 = orNotId(item.r5t_1);
                var tmp0_elvis_lhs_0 = item.t5t_1.i5u_1;
                var tmp_7 = tmp0_elvis_lhs_0 == null ? '' : tmp0_elvis_lhs_0;
                var tmp0_elvis_lhs_1 = item.t5t_1.j5u_1;
                var tmp_8 = tmp0_elvis_lhs_1 == null ? emptyList() : tmp0_elvis_lhs_1;
                var tmp0_elvis_lhs_2 = item.y5t_1;
                tmp_5 = new KeyWord(tmp_6, tmp_7, tmp_8, (tmp0_elvis_lhs_2 == null ? 0 : tmp0_elvis_lhs_2) > 0);
              } else if (!(item.u5t_1 == null)) {
                var tmp_9 = orNotId(item.r5t_1);
                var tmp_10 = orNotId(item.u5t_1.e5u_1);
                var tmp0_elvis_lhs_3 = item.u5t_1.f5u_1;
                var tmp_11 = tmp0_elvis_lhs_3 == null ? '' : tmp0_elvis_lhs_3;
                var tmp0_elvis_lhs_4 = item.u5t_1.h5u_1;
                var tmp_12 = tmp0_elvis_lhs_4 == null ? '' : tmp0_elvis_lhs_4;
                var tmp0_elvis_lhs_5 = item.u5t_1.g5u_1;
                var tmp_13 = tmp0_elvis_lhs_5 == null ? '' : tmp0_elvis_lhs_5;
                var tmp1_elvis_lhs = item.y5t_1;
                tmp_5 = new NutcallPerson(tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) > 0);
              } else if (!(item.v5t_1 == null)) {
                var tmp_14 = orNotId(item.r5t_1);
                var tmp_15 = orNotId(item.v5t_1.z5t_1);
                var tmp0_elvis_lhs_6 = item.v5t_1.c5u_1;
                var tmp_16 = tmp0_elvis_lhs_6 == null ? '' : tmp0_elvis_lhs_6;
                var tmp0_elvis_lhs_7 = item.v5t_1.d5u_1;
                var tmp_17 = tmp0_elvis_lhs_7 == null ? '' : tmp0_elvis_lhs_7;
                var tmp0_elvis_lhs_8 = item.v5t_1.a5u_1;
                var tmp_18 = tmp0_elvis_lhs_8 == null ? '' : tmp0_elvis_lhs_8;
                var tmp2_elvis_lhs = item.y5t_1;
                tmp_5 = new NutcallCompany(tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) > 0);
              } else {
                tmp_5 = Unknown_getInstance();
              }
              destination.e(tmp_5);
            }

            this.s5r_1 = _Result___init__impl__xyqfz8(destination);
            this.k8_1 = 4;
            this.j8_1 = 5;
            continue $sm;
          case 3:
            this.k8_1 = 4;
            var tmp_19 = this.m8_1;
            if (tmp_19 instanceof Error) {
              var e = this.m8_1;
              var tmp_20 = this;
              tmp_20.s5r_1 = _Result___init__impl__xyqfz8(createFailure(e));
              this.j8_1 = 5;
              continue $sm;
            } else {
              throw this.m8_1;
            }

          case 4:
            throw this.m8_1;
          case 5:
            this.k8_1 = 4;
            return new Result(this.s5r_1);
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.k8_1 === 4) {
          throw e_0;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e_0;
        }
      }
     while (true);
  };
  function MonitorRepositoryImpl(searchApi, monitorApi, favApi, storage) {
    this.r5s_1 = searchApi;
    this.s5s_1 = monitorApi;
    this.t5s_1 = favApi;
    this.u5s_1 = storage;
    this.v5s_1 = MutableStateFlow(emptyList());
    this.w5s_1 = MutableStateFlow(null);
    var tmp = this;
    tmp.x5s_1 = combine(this.v5s_1, this.w5s_1, MonitorRepositoryImpl$subjectState$slambda_0(null));
    this.y5s_1 = CoroutineScope_0(Dispatchers_getInstance().nv_1.le(Job()));
    launch(this.y5s_1, VOID, VOID, MonitorRepositoryImpl$slambda_0(this, null));
  }
  protoOf(MonitorRepositoryImpl).z5s = function ($completion) {
    var tmp = new $updateCOROUTINE$12(this, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  function KeyWord(id, word, synonyms, hasUnread) {
    MonitorSubject.call(this, id);
    this.l5u_1 = id;
    this.m5u_1 = word;
    this.n5u_1 = synonyms;
    this.o5u_1 = hasUnread;
  }
  protoOf(KeyWord).g5k = function () {
    return this.l5u_1;
  };
  protoOf(KeyWord).toString = function () {
    return 'KeyWord(id=' + toString_0(this.l5u_1) + ', word=' + this.m5u_1 + ', synonyms=' + toString(this.n5u_1) + ', hasUnread=' + this.o5u_1 + ')';
  };
  protoOf(KeyWord).hashCode = function () {
    var result = this.l5u_1 == null ? 0 : this.l5u_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.m5u_1) | 0;
    result = imul(result, 31) + hashCode(this.n5u_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.o5u_1) | 0;
    return result;
  };
  protoOf(KeyWord).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KeyWord))
      return false;
    var tmp0_other_with_cast = other instanceof KeyWord ? other : THROW_CCE();
    if (!equals(this.l5u_1, tmp0_other_with_cast.l5u_1))
      return false;
    if (!(this.m5u_1 === tmp0_other_with_cast.m5u_1))
      return false;
    if (!equals(this.n5u_1, tmp0_other_with_cast.n5u_1))
      return false;
    if (!(this.o5u_1 === tmp0_other_with_cast.o5u_1))
      return false;
    return true;
  };
  function NutcallPerson(id, nutcallId, name, additionInfo, imageUrl, hasUnread) {
    MonitorSubject.call(this, id);
    this.q5u_1 = id;
    this.r5u_1 = nutcallId;
    this.s5u_1 = name;
    this.t5u_1 = additionInfo;
    this.u5u_1 = imageUrl;
    this.v5u_1 = hasUnread;
  }
  protoOf(NutcallPerson).g5k = function () {
    return this.q5u_1;
  };
  protoOf(NutcallPerson).toString = function () {
    return 'NutcallPerson(id=' + this.q5u_1.toString() + ', nutcallId=' + this.r5u_1.toString() + ', name=' + this.s5u_1 + ', additionInfo=' + this.t5u_1 + ', imageUrl=' + this.u5u_1 + ', hasUnread=' + this.v5u_1 + ')';
  };
  protoOf(NutcallPerson).hashCode = function () {
    var result = this.q5u_1.hashCode();
    result = imul(result, 31) + this.r5u_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.s5u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t5u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u5u_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.v5u_1) | 0;
    return result;
  };
  protoOf(NutcallPerson).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NutcallPerson))
      return false;
    var tmp0_other_with_cast = other instanceof NutcallPerson ? other : THROW_CCE();
    if (!this.q5u_1.equals(tmp0_other_with_cast.q5u_1))
      return false;
    if (!this.r5u_1.equals(tmp0_other_with_cast.r5u_1))
      return false;
    if (!(this.s5u_1 === tmp0_other_with_cast.s5u_1))
      return false;
    if (!(this.t5u_1 === tmp0_other_with_cast.t5u_1))
      return false;
    if (!(this.u5u_1 === tmp0_other_with_cast.u5u_1))
      return false;
    if (!(this.v5u_1 === tmp0_other_with_cast.v5u_1))
      return false;
    return true;
  };
  function NutcallCompany(id, nutcallId, name, companyType, imageUrl, hasUnread) {
    MonitorSubject.call(this, id);
    this.x5u_1 = id;
    this.y5u_1 = nutcallId;
    this.z5u_1 = name;
    this.a5v_1 = companyType;
    this.b5v_1 = imageUrl;
    this.c5v_1 = hasUnread;
  }
  protoOf(NutcallCompany).g5k = function () {
    return this.x5u_1;
  };
  protoOf(NutcallCompany).toString = function () {
    return 'NutcallCompany(id=' + this.x5u_1.toString() + ', nutcallId=' + this.y5u_1.toString() + ', name=' + this.z5u_1 + ', companyType=' + this.a5v_1 + ', imageUrl=' + this.b5v_1 + ', hasUnread=' + this.c5v_1 + ')';
  };
  protoOf(NutcallCompany).hashCode = function () {
    var result = this.x5u_1.hashCode();
    result = imul(result, 31) + this.y5u_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.z5u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a5v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b5v_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.c5v_1) | 0;
    return result;
  };
  protoOf(NutcallCompany).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NutcallCompany))
      return false;
    var tmp0_other_with_cast = other instanceof NutcallCompany ? other : THROW_CCE();
    if (!this.x5u_1.equals(tmp0_other_with_cast.x5u_1))
      return false;
    if (!this.y5u_1.equals(tmp0_other_with_cast.y5u_1))
      return false;
    if (!(this.z5u_1 === tmp0_other_with_cast.z5u_1))
      return false;
    if (!(this.a5v_1 === tmp0_other_with_cast.a5v_1))
      return false;
    if (!(this.b5v_1 === tmp0_other_with_cast.b5v_1))
      return false;
    if (!(this.c5v_1 === tmp0_other_with_cast.c5v_1))
      return false;
    return true;
  };
  function Unknown() {
    Unknown_instance = this;
    MonitorSubject.call(this, new Long(-1, -1));
  }
  protoOf(Unknown).toString = function () {
    return 'Unknown';
  };
  protoOf(Unknown).hashCode = function () {
    return -1800374715;
  };
  protoOf(Unknown).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Unknown))
      return false;
    other instanceof Unknown || THROW_CCE();
    return true;
  };
  var Unknown_instance;
  function Unknown_getInstance() {
    if (Unknown_instance == null)
      new Unknown();
    return Unknown_instance;
  }
  function Companion_12() {
  }
  var Companion_instance_14;
  function Companion_getInstance_16() {
    return Companion_instance_14;
  }
  function MonitorSubject(id) {
    this.o5t_1 = id;
  }
  protoOf(MonitorSubject).g5k = function () {
    return this.o5t_1;
  };
  function SubjectsState(subjects, loadErrors) {
    this.d5v_1 = subjects;
    this.e5v_1 = loadErrors;
  }
  protoOf(SubjectsState).toString = function () {
    return 'SubjectsState(subjects=' + toString(this.d5v_1) + ', loadErrors=' + toString_0(this.e5v_1) + ')';
  };
  protoOf(SubjectsState).hashCode = function () {
    var result = hashCode(this.d5v_1);
    result = imul(result, 31) + (this.e5v_1 == null ? 0 : hashCode(this.e5v_1)) | 0;
    return result;
  };
  protoOf(SubjectsState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SubjectsState))
      return false;
    var tmp0_other_with_cast = other instanceof SubjectsState ? other : THROW_CCE();
    if (!equals(this.d5v_1, tmp0_other_with_cast.d5v_1))
      return false;
    if (!equals(this.e5v_1, tmp0_other_with_cast.e5v_1))
      return false;
    return true;
  };
  function AddNewSubjectUseCase(repository) {
    NoResult_0.call(this);
    this.g5v_1 = repository;
  }
  function ChangeActiveSubjectUseCase(storage) {
    NoResult_0.call(this);
    this.i5v_1 = storage;
  }
  function RemoveSubjectUseCase(repository) {
    NoResult_0.call(this);
    this.k5v_1 = repository;
  }
  function SubscribeToActiveSubjectUseCase(monitoringStorage) {
    this.l5v_1 = monitoringStorage;
  }
  function SubscribeToSubjectsUseCase(repository) {
    this.m5v_1 = repository;
  }
  protoOf(SubscribeToSubjectsUseCase).toString = function () {
    return 'SubscribeToSubjectsUseCase(repository=' + toString(this.m5v_1) + ')';
  };
  protoOf(SubscribeToSubjectsUseCase).hashCode = function () {
    return hashCode(this.m5v_1);
  };
  protoOf(SubscribeToSubjectsUseCase).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SubscribeToSubjectsUseCase))
      return false;
    var tmp0_other_with_cast = other instanceof SubscribeToSubjectsUseCase ? other : THROW_CCE();
    if (!equals(this.m5v_1, tmp0_other_with_cast.m5v_1))
      return false;
    return true;
  };
  function UpdateSubjectsUseCase(repository) {
    NoResult.call(this);
    this.o5v_1 = repository;
  }
  protoOf(UpdateSubjectsUseCase).toString = function () {
    return 'UpdateSubjectsUseCase(repository=' + toString(this.o5v_1) + ')';
  };
  protoOf(UpdateSubjectsUseCase).hashCode = function () {
    return hashCode(this.o5v_1);
  };
  protoOf(UpdateSubjectsUseCase).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateSubjectsUseCase))
      return false;
    var tmp0_other_with_cast = other instanceof UpdateSubjectsUseCase ? other : THROW_CCE();
    if (!equals(this.o5v_1, tmp0_other_with_cast.o5v_1))
      return false;
    return true;
  };
  function MonitorApi() {
  }
  function Companion_13() {
    Companion_instance_15 = this;
    this.q5v_1 = SharedModule_instance.p5i() + '/monitor';
    this.r5v_1 = SharedModule_instance.p5i() + '/monitor/subjects';
    this.s5v_1 = SharedModule_instance.p5i() + '/monitor/subjects/{id}/mark-as-read';
    this.t5v_1 = SharedModule_instance.p5i() + '/monitor/options';
    this.u5v_1 = SharedModule_instance.p5i() + '/monitor/feed';
    this.v5v_1 = SharedModule_instance.p5i() + '/monitor/feed/unread';
    this.w5v_1 = SharedModule_instance.p5i() + '/monitor/feed/mark-as-read';
  }
  var Companion_instance_15;
  function Companion_getInstance_17() {
    if (Companion_instance_15 == null)
      new Companion_13();
    return Companion_instance_15;
  }
  function MonitorApiImpl$getMonitorFeed$lambda($limit, $fromId, $noRead, $subjectId, $source) {
    return function ($this$url, it) {
      $this$url.z3l_1.x38('limit', '' + $limit);
      if ($fromId == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        $this$url.z3l_1.x38('from_id', toString_0($fromId));
      }
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      $this$url.z3l_1.x38('noread', '' + $noRead);
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      $this$url.z3l_1.x38('subjects[]', $subjectId.toString());
      $this$url.z3l_1.x38('source', $source.z5v_1);
      return Unit_instance;
    };
  }
  function $getMonitorSubjectsCOROUTINE$24(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i5w_1 = _this__u8e3s4;
  }
  protoOf($getMonitorSubjectsCOROUTINE$24).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 4;
            var tmp_0 = this;
            tmp_0.j5w_1 = this.i5w_1;
            this.k8_1 = 3;
            var tmp_1 = this;
            tmp_1.l5w_1 = Companion_instance;
            var tmp_2 = this;
            tmp_2.m5w_1 = this.j5w_1;
            var tmp_3 = this;
            tmp_3.n5w_1 = this.m5w_1.v5w_1;
            var tmp_4 = this;
            tmp_4.o5w_1 = Companion_getInstance_17().r5v_1;
            var tmp_5 = this;
            tmp_5.p5w_1 = this.n5w_1;
            var tmp_6 = this;
            tmp_6.q5w_1 = this.p5w_1;
            var tmp_7 = this;
            var this_0 = new HttpRequestBuilder();
            url(this_0, this.o5w_1);
            tmp_7.r5w_1 = this_0;
            this.r5w_1.b3u_1 = Companion_getInstance_1().q3i_1;
            var tmp_8 = this;
            tmp_8.s5w_1 = this.q5w_1;
            var tmp_9 = this;
            tmp_9.t5w_1 = this.r5w_1;
            this.j8_1 = 1;
            suspendResult = (new HttpStatement(this.t5w_1, this.s5w_1)).j4n(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.u5w_1 = suspendResult;
            this.j8_1 = 2;
            var tmp_10 = this.u5w_1.h3x();
            var tmp_11 = JsType_instance;
            var tmp_12 = getKClass(KtList);
            var tmp_13;
            try {
              tmp_13 = createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(SubjectsDto), arrayOf([]), false))]), false);
            } catch ($p) {
              var tmp_14;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_14 = null;
              } else {
                throw $p;
              }
              tmp_13 = tmp_14;
            }

            suspendResult = tmp_10.l3w(typeInfoImpl(tmp_11, tmp_12, tmp_13), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0_elvis_lhs = (!(suspendResult == null) ? isInterface(suspendResult, KtList) : false) ? suspendResult : null;
            var tmp_15;
            if (tmp0_elvis_lhs == null) {
              throw new ApiError(-1, 'Empty body');
            } else {
              tmp_15 = tmp0_elvis_lhs;
            }

            var value = tmp_15;
            this.k5w_1 = _Result___init__impl__xyqfz8(value);
            this.k8_1 = 4;
            this.j8_1 = 5;
            continue $sm;
          case 3:
            this.k8_1 = 4;
            var tmp_16 = this.m8_1;
            if (tmp_16 instanceof Error) {
              var e = this.m8_1;
              var tmp_17 = this;
              tmp_17.k5w_1 = _Result___init__impl__xyqfz8(createFailure(e));
              this.j8_1 = 5;
              continue $sm;
            } else {
              throw this.m8_1;
            }

          case 4:
            throw this.m8_1;
          case 5:
            this.k8_1 = 4;
            return new Result(this.k5w_1);
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.k8_1 === 4) {
          throw e_0;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e_0;
        }
      }
     while (true);
  };
  function $getMonitorFeedCOROUTINE$31(_this__u8e3s4, subjectId, limit, fromId, noRead, source, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.e5x_1 = _this__u8e3s4;
    this.f5x_1 = subjectId;
    this.g5x_1 = limit;
    this.h5x_1 = fromId;
    this.i5x_1 = noRead;
    this.j5x_1 = source;
  }
  protoOf($getMonitorFeedCOROUTINE$31).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 4;
            var tmp_0 = this;
            tmp_0.k5x_1 = this.e5x_1;
            this.k8_1 = 3;
            var tmp_1 = this;
            tmp_1.m5x_1 = Companion_instance;
            var tmp_2 = this;
            tmp_2.n5x_1 = this.k5x_1;
            var tmp_3 = this;
            tmp_3.o5x_1 = this.n5x_1.v5w_1;
            var tmp_4 = this;
            tmp_4.p5x_1 = Companion_getInstance_17().u5v_1;
            var tmp_5 = this;
            tmp_5.q5x_1 = this.o5x_1;
            var tmp_6 = this;
            tmp_6.r5x_1 = this.q5x_1;
            var tmp_7 = this;
            var this_0 = new HttpRequestBuilder();
            url(this_0, this.p5x_1);
            this_0.d4j(MonitorApiImpl$getMonitorFeed$lambda(this.g5x_1, this.h5x_1, this.i5x_1, this.f5x_1, this.j5x_1));
            tmp_7.s5x_1 = this_0;
            this.s5x_1.b3u_1 = Companion_getInstance_1().q3i_1;
            var tmp_8 = this;
            tmp_8.t5x_1 = this.r5x_1;
            var tmp_9 = this;
            tmp_9.u5x_1 = this.s5x_1;
            this.j8_1 = 1;
            suspendResult = (new HttpStatement(this.u5x_1, this.t5x_1)).j4n(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.v5x_1 = suspendResult;
            this.j8_1 = 2;
            var tmp_10 = this.v5x_1.h3x();
            var tmp_11 = JsType_instance;
            var tmp_12 = getKClass(MentionFeedResponse);
            var tmp_13;
            try {
              tmp_13 = createKType(getKClass(MentionFeedResponse), arrayOf([]), false);
            } catch ($p) {
              var tmp_14;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_14 = null;
              } else {
                throw $p;
              }
              tmp_13 = tmp_14;
            }

            suspendResult = tmp_10.l3w(typeInfoImpl(tmp_11, tmp_12, tmp_13), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0_elvis_lhs = suspendResult instanceof MentionFeedResponse ? suspendResult : null;
            var tmp_15;
            if (tmp0_elvis_lhs == null) {
              throw new ApiError(-1, 'Empty body');
            } else {
              tmp_15 = tmp0_elvis_lhs;
            }

            var value = tmp_15;
            this.l5x_1 = _Result___init__impl__xyqfz8(value);
            this.k8_1 = 4;
            this.j8_1 = 5;
            continue $sm;
          case 3:
            this.k8_1 = 4;
            var tmp_16 = this.m8_1;
            if (tmp_16 instanceof Error) {
              var e = this.m8_1;
              var tmp_17 = this;
              tmp_17.l5x_1 = _Result___init__impl__xyqfz8(createFailure(e));
              this.j8_1 = 5;
              continue $sm;
            } else {
              throw this.m8_1;
            }

          case 4:
            throw this.m8_1;
          case 5:
            this.k8_1 = 4;
            return new Result(this.l5x_1);
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.k8_1 === 4) {
          throw e_0;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e_0;
        }
      }
     while (true);
  };
  function MonitorApiImpl(secureClient) {
    Companion_getInstance_17();
    this.v5w_1 = secureClient;
  }
  protoOf(MonitorApiImpl).q5t = function ($completion) {
    var tmp = new $getMonitorSubjectsCOROUTINE$24(this, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    var tmp_0 = tmp.r8();
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      return tmp_0;
    return tmp_0;
  };
  protoOf(MonitorApiImpl).p5v = function (subjectId, limit, fromId, noRead, source, $completion) {
    var tmp = new $getMonitorFeedCOROUTINE$31(this, subjectId, limit, fromId, noRead, source, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    var tmp_0 = tmp.r8();
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      return tmp_0;
    return tmp_0;
  };
  function NutcallSearchApi() {
  }
  function Companion_14() {
    this.w5x_1 = 'https://api.nutcall.com/search';
  }
  var Companion_instance_16;
  function Companion_getInstance_18() {
    return Companion_instance_16;
  }
  function NutcallSearchApiImpl(nutcallClient) {
    this.x5x_1 = nutcallClient;
  }
  function _get_$cachedSerializer__te6jhj_1($this) {
    return $this.y5x_1.v();
  }
  function FeedSource$Companion$_anonymous__6g0ydm_0() {
    var tmp = values_1();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = ['telegram', 'website'];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = [null, null];
    return createAnnotatedEnumSerializer('com.mentions.shared.feature.monitor.network.data.FeedSource', tmp, tmp_0, tmp$ret$5, null);
  }
  var FeedSource_TELEGRAM_instance_0;
  var FeedSource_WEB_SITE_instance_0;
  function values_1() {
    return [FeedSource_TELEGRAM_getInstance_0(), FeedSource_WEB_SITE_getInstance_0()];
  }
  function Companion_15() {
    Companion_instance_17 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y5x_1 = lazy(tmp_0, FeedSource$Companion$_anonymous__6g0ydm_0);
  }
  protoOf(Companion_15).n59 = function () {
    return _get_$cachedSerializer__te6jhj_1(this);
  };
  protoOf(Companion_15).k1p = function (typeParamsSerializers) {
    return this.n59();
  };
  var Companion_instance_17;
  function Companion_getInstance_19() {
    FeedSource_initEntries_0();
    if (Companion_instance_17 == null)
      new Companion_15();
    return Companion_instance_17;
  }
  var FeedSource_entriesInitialized_0;
  function FeedSource_initEntries_0() {
    if (FeedSource_entriesInitialized_0)
      return Unit_instance;
    FeedSource_entriesInitialized_0 = true;
    FeedSource_TELEGRAM_instance_0 = new FeedSource_0('TELEGRAM', 0, 'telegram');
    FeedSource_WEB_SITE_instance_0 = new FeedSource_0('WEB_SITE', 1, 'website');
    Companion_getInstance_19();
  }
  function FeedSource_0(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.z5v_1 = value;
  }
  function Companion_16() {
  }
  var Companion_instance_18;
  function Companion_getInstance_20() {
    return Companion_instance_18;
  }
  function $serializer_8() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.mentions.shared.feature.monitor.network.data.SubjectsDto', this, 8);
    tmp0_serialDesc.g1o('id', true);
    tmp0_serialDesc.g1o('type', true);
    tmp0_serialDesc.g1o('phrase', true);
    tmp0_serialDesc.g1o('nutcall_person', true);
    tmp0_serialDesc.g1o('nutcall_company', true);
    tmp0_serialDesc.g1o('is_push', false);
    tmp0_serialDesc.g1o('hide_forwards', true);
    tmp0_serialDesc.g1o('user_unread_count', true);
    this.z5x_1 = tmp0_serialDesc;
  }
  protoOf($serializer_8).a5y = function (encoder, value) {
    var tmp0_desc = this.z5x_1;
    var tmp1_output = encoder.x1g(tmp0_desc);
    if (tmp1_output.t1i(tmp0_desc, 0) ? true : !(value.r5t_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 0, LongSerializer_getInstance(), value.r5t_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 1) ? true : !(value.s5t_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 1, StringSerializer_getInstance(), value.s5t_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 2) ? true : !(value.t5t_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 2, $serializer_getInstance_9(), value.t5t_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 3) ? true : !(value.u5t_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 3, $serializer_getInstance_10(), value.u5t_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 4) ? true : !(value.v5t_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 4, $serializer_getInstance_11(), value.v5t_1);
    }
    tmp1_output.p1i(tmp0_desc, 5, BooleanSerializer_getInstance(), value.w5t_1);
    if (tmp1_output.t1i(tmp0_desc, 6) ? true : !(value.x5t_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 6, BooleanSerializer_getInstance(), value.x5t_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 7) ? true : !(value.y5t_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 7, IntSerializer_getInstance(), value.y5t_1);
    }
    tmp1_output.y1g(tmp0_desc);
  };
  protoOf($serializer_8).u1d = function (encoder, value) {
    return this.a5y(encoder, value instanceof SubjectsDto ? value : THROW_CCE());
  };
  protoOf($serializer_8).v1d = function (decoder) {
    var tmp0_desc = this.z5x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_input = decoder.x1g(tmp0_desc);
    if (tmp12_input.m1h()) {
      tmp4_local0 = tmp12_input.l1h(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.l1h(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.l1h(tmp0_desc, 2, $serializer_getInstance_9(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.l1h(tmp0_desc, 3, $serializer_getInstance_10(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.l1h(tmp0_desc, 4, $serializer_getInstance_11(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.l1h(tmp0_desc, 5, BooleanSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.l1h(tmp0_desc, 6, BooleanSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.l1h(tmp0_desc, 7, IntSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.n1h(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.l1h(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.l1h(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.l1h(tmp0_desc, 2, $serializer_getInstance_9(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.l1h(tmp0_desc, 3, $serializer_getInstance_10(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.l1h(tmp0_desc, 4, $serializer_getInstance_11(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.l1h(tmp0_desc, 5, BooleanSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.l1h(tmp0_desc, 6, BooleanSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.l1h(tmp0_desc, 7, IntSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp12_input.y1g(tmp0_desc);
    return SubjectsDto_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  };
  protoOf($serializer_8).t1d = function () {
    return this.z5x_1;
  };
  protoOf($serializer_8).z1o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_9()), get_nullable($serializer_getInstance_10()), get_nullable($serializer_getInstance_11()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(IntSerializer_getInstance())];
  };
  var $serializer_instance_8;
  function $serializer_getInstance_8() {
    if ($serializer_instance_8 == null)
      new $serializer_8();
    return $serializer_instance_8;
  }
  function SubjectsDto_init_$Init$(seen0, id, type, phrase, nutcallPerson, nutcallCompany, isPush, hideForwards, userUnreadCount, serializationConstructorMarker, $this) {
    if (!(32 === (32 & seen0))) {
      throwMissingFieldException(seen0, 32, $serializer_getInstance_8().z5x_1);
    }
    if (0 === (seen0 & 1))
      $this.r5t_1 = null;
    else
      $this.r5t_1 = id;
    if (0 === (seen0 & 2))
      $this.s5t_1 = null;
    else
      $this.s5t_1 = type;
    if (0 === (seen0 & 4))
      $this.t5t_1 = null;
    else
      $this.t5t_1 = phrase;
    if (0 === (seen0 & 8))
      $this.u5t_1 = null;
    else
      $this.u5t_1 = nutcallPerson;
    if (0 === (seen0 & 16))
      $this.v5t_1 = null;
    else
      $this.v5t_1 = nutcallCompany;
    $this.w5t_1 = isPush;
    if (0 === (seen0 & 64))
      $this.x5t_1 = null;
    else
      $this.x5t_1 = hideForwards;
    if (0 === (seen0 & 128))
      $this.y5t_1 = null;
    else
      $this.y5t_1 = userUnreadCount;
    return $this;
  }
  function SubjectsDto_init_$Create$(seen0, id, type, phrase, nutcallPerson, nutcallCompany, isPush, hideForwards, userUnreadCount, serializationConstructorMarker) {
    return SubjectsDto_init_$Init$(seen0, id, type, phrase, nutcallPerson, nutcallCompany, isPush, hideForwards, userUnreadCount, serializationConstructorMarker, objectCreate(protoOf(SubjectsDto)));
  }
  function SubjectsDto(id, type, phrase, nutcallPerson, nutcallCompany, isPush, hideForwards, userUnreadCount) {
    id = id === VOID ? null : id;
    type = type === VOID ? null : type;
    phrase = phrase === VOID ? null : phrase;
    nutcallPerson = nutcallPerson === VOID ? null : nutcallPerson;
    nutcallCompany = nutcallCompany === VOID ? null : nutcallCompany;
    hideForwards = hideForwards === VOID ? null : hideForwards;
    userUnreadCount = userUnreadCount === VOID ? null : userUnreadCount;
    this.r5t_1 = id;
    this.s5t_1 = type;
    this.t5t_1 = phrase;
    this.u5t_1 = nutcallPerson;
    this.v5t_1 = nutcallCompany;
    this.w5t_1 = isPush;
    this.x5t_1 = hideForwards;
    this.y5t_1 = userUnreadCount;
  }
  protoOf(SubjectsDto).toString = function () {
    return 'SubjectsDto(id=' + toString_0(this.r5t_1) + ', type=' + this.s5t_1 + ', phrase=' + toString_0(this.t5t_1) + ', nutcallPerson=' + toString_0(this.u5t_1) + ', nutcallCompany=' + toString_0(this.v5t_1) + ', isPush=' + this.w5t_1 + ', hideForwards=' + this.x5t_1 + ', userUnreadCount=' + this.y5t_1 + ')';
  };
  protoOf(SubjectsDto).hashCode = function () {
    var result = this.r5t_1 == null ? 0 : this.r5t_1.hashCode();
    result = imul(result, 31) + (this.s5t_1 == null ? 0 : getStringHashCode(this.s5t_1)) | 0;
    result = imul(result, 31) + (this.t5t_1 == null ? 0 : hashCode(this.t5t_1)) | 0;
    result = imul(result, 31) + (this.u5t_1 == null ? 0 : this.u5t_1.hashCode()) | 0;
    result = imul(result, 31) + (this.v5t_1 == null ? 0 : this.v5t_1.hashCode()) | 0;
    result = imul(result, 31) + (this.w5t_1 == null ? 0 : getBooleanHashCode(this.w5t_1)) | 0;
    result = imul(result, 31) + (this.x5t_1 == null ? 0 : getBooleanHashCode(this.x5t_1)) | 0;
    result = imul(result, 31) + (this.y5t_1 == null ? 0 : this.y5t_1) | 0;
    return result;
  };
  protoOf(SubjectsDto).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SubjectsDto))
      return false;
    var tmp0_other_with_cast = other instanceof SubjectsDto ? other : THROW_CCE();
    if (!equals(this.r5t_1, tmp0_other_with_cast.r5t_1))
      return false;
    if (!(this.s5t_1 == tmp0_other_with_cast.s5t_1))
      return false;
    if (!equals(this.t5t_1, tmp0_other_with_cast.t5t_1))
      return false;
    if (!equals(this.u5t_1, tmp0_other_with_cast.u5t_1))
      return false;
    if (!equals(this.v5t_1, tmp0_other_with_cast.v5t_1))
      return false;
    if (!(this.w5t_1 == tmp0_other_with_cast.w5t_1))
      return false;
    if (!(this.x5t_1 == tmp0_other_with_cast.x5t_1))
      return false;
    if (!(this.y5t_1 == tmp0_other_with_cast.y5t_1))
      return false;
    return true;
  };
  function Companion_17() {
    Companion_instance_19 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b5y_1 = [null, new ArrayListSerializer(StringSerializer_getInstance())];
  }
  var Companion_instance_19;
  function Companion_getInstance_21() {
    if (Companion_instance_19 == null)
      new Companion_17();
    return Companion_instance_19;
  }
  function $serializer_9() {
    $serializer_instance_9 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.mentions.shared.feature.monitor.network.data.PhraseDto', this, 2);
    tmp0_serialDesc.g1o('keyword', true);
    tmp0_serialDesc.g1o('synonyms', true);
    this.c5y_1 = tmp0_serialDesc;
  }
  protoOf($serializer_9).d5y = function (encoder, value) {
    var tmp0_desc = this.c5y_1;
    var tmp1_output = encoder.x1g(tmp0_desc);
    var tmp2_cached = Companion_getInstance_21().b5y_1;
    if (tmp1_output.t1i(tmp0_desc, 0) ? true : !(value.i5u_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 0, StringSerializer_getInstance(), value.i5u_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 1) ? true : !(value.j5u_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 1, tmp2_cached[1], value.j5u_1);
    }
    tmp1_output.y1g(tmp0_desc);
  };
  protoOf($serializer_9).u1d = function (encoder, value) {
    return this.d5y(encoder, value instanceof PhraseDto ? value : THROW_CCE());
  };
  protoOf($serializer_9).v1d = function (decoder) {
    var tmp0_desc = this.c5y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.x1g(tmp0_desc);
    var tmp7_cached = Companion_getInstance_21().b5y_1;
    if (tmp6_input.m1h()) {
      tmp4_local0 = tmp6_input.l1h(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.l1h(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.n1h(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.l1h(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.l1h(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.y1g(tmp0_desc);
    return PhraseDto_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_9).t1d = function () {
    return this.c5y_1;
  };
  protoOf($serializer_9).z1o = function () {
    var tmp0_cached = Companion_getInstance_21().b5y_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[1])];
  };
  var $serializer_instance_9;
  function $serializer_getInstance_9() {
    if ($serializer_instance_9 == null)
      new $serializer_9();
    return $serializer_instance_9;
  }
  function PhraseDto_init_$Init$(seen0, keyword, synonyms, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_9().c5y_1);
    }
    if (0 === (seen0 & 1))
      $this.i5u_1 = null;
    else
      $this.i5u_1 = keyword;
    if (0 === (seen0 & 2))
      $this.j5u_1 = null;
    else
      $this.j5u_1 = synonyms;
    return $this;
  }
  function PhraseDto_init_$Create$(seen0, keyword, synonyms, serializationConstructorMarker) {
    return PhraseDto_init_$Init$(seen0, keyword, synonyms, serializationConstructorMarker, objectCreate(protoOf(PhraseDto)));
  }
  function PhraseDto(keyword, synonyms) {
    Companion_getInstance_21();
    keyword = keyword === VOID ? null : keyword;
    synonyms = synonyms === VOID ? null : synonyms;
    this.i5u_1 = keyword;
    this.j5u_1 = synonyms;
  }
  function Companion_18() {
  }
  var Companion_instance_20;
  function Companion_getInstance_22() {
    return Companion_instance_20;
  }
  function $serializer_10() {
    $serializer_instance_10 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.mentions.shared.feature.monitor.network.data.NutcallPersonDto', this, 4);
    tmp0_serialDesc.g1o('id', true);
    tmp0_serialDesc.g1o('name', true);
    tmp0_serialDesc.g1o('photo_180', true);
    tmp0_serialDesc.g1o('work', true);
    this.e5y_1 = tmp0_serialDesc;
  }
  protoOf($serializer_10).f5y = function (encoder, value) {
    var tmp0_desc = this.e5y_1;
    var tmp1_output = encoder.x1g(tmp0_desc);
    if (tmp1_output.t1i(tmp0_desc, 0) ? true : !(value.e5u_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 0, LongSerializer_getInstance(), value.e5u_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 1) ? true : !(value.f5u_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 1, StringSerializer_getInstance(), value.f5u_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 2) ? true : !(value.g5u_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 2, StringSerializer_getInstance(), value.g5u_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 3) ? true : !(value.h5u_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 3, StringSerializer_getInstance(), value.h5u_1);
    }
    tmp1_output.y1g(tmp0_desc);
  };
  protoOf($serializer_10).u1d = function (encoder, value) {
    return this.f5y(encoder, value instanceof NutcallPersonDto ? value : THROW_CCE());
  };
  protoOf($serializer_10).v1d = function (decoder) {
    var tmp0_desc = this.e5y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.x1g(tmp0_desc);
    if (tmp8_input.m1h()) {
      tmp4_local0 = tmp8_input.l1h(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.l1h(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.l1h(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.l1h(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.n1h(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.l1h(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.l1h(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.l1h(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.l1h(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.y1g(tmp0_desc);
    return NutcallPersonDto_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_10).t1d = function () {
    return this.e5y_1;
  };
  protoOf($serializer_10).z1o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_10;
  function $serializer_getInstance_10() {
    if ($serializer_instance_10 == null)
      new $serializer_10();
    return $serializer_instance_10;
  }
  function NutcallPersonDto_init_$Init$(seen0, id, name, photo180, work, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_10().e5y_1);
    }
    if (0 === (seen0 & 1))
      $this.e5u_1 = null;
    else
      $this.e5u_1 = id;
    if (0 === (seen0 & 2))
      $this.f5u_1 = null;
    else
      $this.f5u_1 = name;
    if (0 === (seen0 & 4))
      $this.g5u_1 = null;
    else
      $this.g5u_1 = photo180;
    if (0 === (seen0 & 8))
      $this.h5u_1 = null;
    else
      $this.h5u_1 = work;
    return $this;
  }
  function NutcallPersonDto_init_$Create$(seen0, id, name, photo180, work, serializationConstructorMarker) {
    return NutcallPersonDto_init_$Init$(seen0, id, name, photo180, work, serializationConstructorMarker, objectCreate(protoOf(NutcallPersonDto)));
  }
  function NutcallPersonDto(id, name, photo180, work) {
    id = id === VOID ? null : id;
    name = name === VOID ? null : name;
    photo180 = photo180 === VOID ? null : photo180;
    work = work === VOID ? null : work;
    this.e5u_1 = id;
    this.f5u_1 = name;
    this.g5u_1 = photo180;
    this.h5u_1 = work;
  }
  protoOf(NutcallPersonDto).toString = function () {
    return 'NutcallPersonDto(id=' + toString_0(this.e5u_1) + ', name=' + this.f5u_1 + ', photo180=' + this.g5u_1 + ', work=' + this.h5u_1 + ')';
  };
  protoOf(NutcallPersonDto).hashCode = function () {
    var result = this.e5u_1 == null ? 0 : this.e5u_1.hashCode();
    result = imul(result, 31) + (this.f5u_1 == null ? 0 : getStringHashCode(this.f5u_1)) | 0;
    result = imul(result, 31) + (this.g5u_1 == null ? 0 : getStringHashCode(this.g5u_1)) | 0;
    result = imul(result, 31) + (this.h5u_1 == null ? 0 : getStringHashCode(this.h5u_1)) | 0;
    return result;
  };
  protoOf(NutcallPersonDto).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NutcallPersonDto))
      return false;
    var tmp0_other_with_cast = other instanceof NutcallPersonDto ? other : THROW_CCE();
    if (!equals(this.e5u_1, tmp0_other_with_cast.e5u_1))
      return false;
    if (!(this.f5u_1 == tmp0_other_with_cast.f5u_1))
      return false;
    if (!(this.g5u_1 == tmp0_other_with_cast.g5u_1))
      return false;
    if (!(this.h5u_1 == tmp0_other_with_cast.h5u_1))
      return false;
    return true;
  };
  function Companion_19() {
  }
  var Companion_instance_21;
  function Companion_getInstance_23() {
    return Companion_instance_21;
  }
  function $serializer_11() {
    $serializer_instance_11 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.mentions.shared.feature.monitor.network.data.NutcallCompanyDto', this, 5);
    tmp0_serialDesc.g1o('id', true);
    tmp0_serialDesc.g1o('logo_thumb_url', true);
    tmp0_serialDesc.g1o('logo_url', true);
    tmp0_serialDesc.g1o('name', true);
    tmp0_serialDesc.g1o('type', true);
    this.g5y_1 = tmp0_serialDesc;
  }
  protoOf($serializer_11).h5y = function (encoder, value) {
    var tmp0_desc = this.g5y_1;
    var tmp1_output = encoder.x1g(tmp0_desc);
    if (tmp1_output.t1i(tmp0_desc, 0) ? true : !(value.z5t_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 0, LongSerializer_getInstance(), value.z5t_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 1) ? true : !(value.a5u_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 1, StringSerializer_getInstance(), value.a5u_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 2) ? true : !(value.b5u_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 2, StringSerializer_getInstance(), value.b5u_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 3) ? true : !(value.c5u_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 3, StringSerializer_getInstance(), value.c5u_1);
    }
    if (tmp1_output.t1i(tmp0_desc, 4) ? true : !(value.d5u_1 == null)) {
      tmp1_output.p1i(tmp0_desc, 4, StringSerializer_getInstance(), value.d5u_1);
    }
    tmp1_output.y1g(tmp0_desc);
  };
  protoOf($serializer_11).u1d = function (encoder, value) {
    return this.h5y(encoder, value instanceof NutcallCompanyDto ? value : THROW_CCE());
  };
  protoOf($serializer_11).v1d = function (decoder) {
    var tmp0_desc = this.g5y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.x1g(tmp0_desc);
    if (tmp9_input.m1h()) {
      tmp4_local0 = tmp9_input.l1h(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.l1h(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.l1h(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.l1h(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.l1h(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.n1h(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.l1h(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.l1h(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.l1h(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.l1h(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.l1h(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.y1g(tmp0_desc);
    return NutcallCompanyDto_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_11).t1d = function () {
    return this.g5y_1;
  };
  protoOf($serializer_11).z1o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_11;
  function $serializer_getInstance_11() {
    if ($serializer_instance_11 == null)
      new $serializer_11();
    return $serializer_instance_11;
  }
  function NutcallCompanyDto_init_$Init$(seen0, id, logoThumbUrl, logoUrl, name, type, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_11().g5y_1);
    }
    if (0 === (seen0 & 1))
      $this.z5t_1 = null;
    else
      $this.z5t_1 = id;
    if (0 === (seen0 & 2))
      $this.a5u_1 = null;
    else
      $this.a5u_1 = logoThumbUrl;
    if (0 === (seen0 & 4))
      $this.b5u_1 = null;
    else
      $this.b5u_1 = logoUrl;
    if (0 === (seen0 & 8))
      $this.c5u_1 = null;
    else
      $this.c5u_1 = name;
    if (0 === (seen0 & 16))
      $this.d5u_1 = null;
    else
      $this.d5u_1 = type;
    return $this;
  }
  function NutcallCompanyDto_init_$Create$(seen0, id, logoThumbUrl, logoUrl, name, type, serializationConstructorMarker) {
    return NutcallCompanyDto_init_$Init$(seen0, id, logoThumbUrl, logoUrl, name, type, serializationConstructorMarker, objectCreate(protoOf(NutcallCompanyDto)));
  }
  function NutcallCompanyDto(id, logoThumbUrl, logoUrl, name, type) {
    id = id === VOID ? null : id;
    logoThumbUrl = logoThumbUrl === VOID ? null : logoThumbUrl;
    logoUrl = logoUrl === VOID ? null : logoUrl;
    name = name === VOID ? null : name;
    type = type === VOID ? null : type;
    this.z5t_1 = id;
    this.a5u_1 = logoThumbUrl;
    this.b5u_1 = logoUrl;
    this.c5u_1 = name;
    this.d5u_1 = type;
  }
  protoOf(NutcallCompanyDto).toString = function () {
    return 'NutcallCompanyDto(id=' + toString_0(this.z5t_1) + ', logoThumbUrl=' + this.a5u_1 + ', logoUrl=' + this.b5u_1 + ', name=' + this.c5u_1 + ', type=' + this.d5u_1 + ')';
  };
  protoOf(NutcallCompanyDto).hashCode = function () {
    var result = this.z5t_1 == null ? 0 : this.z5t_1.hashCode();
    result = imul(result, 31) + (this.a5u_1 == null ? 0 : getStringHashCode(this.a5u_1)) | 0;
    result = imul(result, 31) + (this.b5u_1 == null ? 0 : getStringHashCode(this.b5u_1)) | 0;
    result = imul(result, 31) + (this.c5u_1 == null ? 0 : getStringHashCode(this.c5u_1)) | 0;
    result = imul(result, 31) + (this.d5u_1 == null ? 0 : getStringHashCode(this.d5u_1)) | 0;
    return result;
  };
  protoOf(NutcallCompanyDto).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NutcallCompanyDto))
      return false;
    var tmp0_other_with_cast = other instanceof NutcallCompanyDto ? other : THROW_CCE();
    if (!equals(this.z5t_1, tmp0_other_with_cast.z5t_1))
      return false;
    if (!(this.a5u_1 == tmp0_other_with_cast.a5u_1))
      return false;
    if (!(this.b5u_1 == tmp0_other_with_cast.b5u_1))
      return false;
    if (!(this.c5u_1 == tmp0_other_with_cast.c5u_1))
      return false;
    if (!(this.d5u_1 == tmp0_other_with_cast.d5u_1))
      return false;
    return true;
  };
  function FeedSource_TELEGRAM_getInstance_0() {
    FeedSource_initEntries_0();
    return FeedSource_TELEGRAM_instance_0;
  }
  function FeedSource_WEB_SITE_getInstance_0() {
    FeedSource_initEntries_0();
    return FeedSource_WEB_SITE_instance_0;
  }
  function UserRepository() {
  }
  function get_authModule() {
    _init_properties_AuthModule_kt__7gs0z0();
    return authModule;
  }
  var authModule;
  function authModule$lambda($this$module) {
    _init_properties_AuthModule_kt__7gs0z0();
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition = authModule$lambda$lambda;
    var scopeQualifier = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind = Kind_Singleton_getInstance();
    var secondaryTypes = emptyList();
    var def = new BeanDefinition(scopeQualifier, getKClass(AuthApi), null, definition, kind, secondaryTypes);
    var factory = new SingleInstanceFactory(def);
    $this$module.g2h(factory);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory);
    }
    new KoinDefinition($this$module, factory);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_0 = authModule$lambda$lambda_0;
    var scopeQualifier_0 = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_0 = Kind_Singleton_getInstance();
    var secondaryTypes_0 = emptyList();
    var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(DeleteUserUseCase), null, definition_0, kind_0, secondaryTypes_0);
    var factory_0 = new SingleInstanceFactory(def_0);
    $this$module.g2h(factory_0);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory_0);
    }
    new KoinDefinition($this$module, factory_0);
    return Unit_instance;
  }
  function authModule$lambda$lambda($this$single, it) {
    _init_properties_AuthModule_kt__7gs0z0();
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$single.g2i(getKClass(HttpClient), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var qualifier = named('SECURE_CLIENT');
    var tmp$ret$1 = $this$single.g2i(getKClass(HttpClient), qualifier, null);
    return new AuthApiImpl(tmp, tmp$ret$1);
  }
  function authModule$lambda$lambda_0($this$single, it) {
    _init_properties_AuthModule_kt__7gs0z0();
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$single.g2i(getKClass(UserRepository), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$1 = $this$single.g2i(getKClass(AuthManager), null, null);
    return new DeleteUserUseCase(tmp, tmp$ret$1);
  }
  var properties_initialized_AuthModule_kt_q3onyi;
  function _init_properties_AuthModule_kt__7gs0z0() {
    if (!properties_initialized_AuthModule_kt_q3onyi) {
      properties_initialized_AuthModule_kt_q3onyi = true;
      authModule = module_0(VOID, authModule$lambda);
    }
  }
  function AuthManager() {
  }
  function DeleteUserUseCase(userRepository, authManager) {
    NoResult.call(this);
    this.j5y_1 = userRepository;
    this.k5y_1 = authManager;
  }
  function AuthApi() {
  }
  function Companion_20() {
    Companion_instance_22 = this;
    this.l5y_1 = SharedModule_instance.p5i() + '/auth/refresh-token';
    this.m5y_1 = SharedModule_instance.p5i() + '/auth/phone';
    this.n5y_1 = SharedModule_instance.p5i() + '/auth/phone/confirm';
    this.o5y_1 = SharedModule_instance.p5i() + '/auth/logout';
  }
  var Companion_instance_22;
  function Companion_getInstance_24() {
    if (Companion_instance_22 == null)
      new Companion_20();
    return Companion_instance_22;
  }
  function AuthApiImpl(client, secureClient) {
    Companion_getInstance_24();
    this.p5y_1 = client;
    this.q5y_1 = secureClient;
  }
  function Companion_21() {
  }
  var Companion_instance_23;
  function Companion_getInstance_25() {
    return Companion_instance_23;
  }
  function $serializer_12() {
    $serializer_instance_12 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.mentions.shared.network.ApiError', this, 2);
    tmp0_serialDesc.g1o('error_code', false);
    tmp0_serialDesc.g1o('message', false);
    this.r5y_1 = tmp0_serialDesc;
  }
  protoOf($serializer_12).s5y = function (encoder, value) {
    var tmp0_desc = this.r5y_1;
    var tmp1_output = encoder.x1g(tmp0_desc);
    tmp1_output.g1i(tmp0_desc, 0, value.t5y_1);
    tmp1_output.p1i(tmp0_desc, 1, StringSerializer_getInstance(), value.u5y_1);
    tmp1_output.y1g(tmp0_desc);
  };
  protoOf($serializer_12).u1d = function (encoder, value) {
    return this.s5y(encoder, value instanceof ApiError ? value : THROW_CCE());
  };
  protoOf($serializer_12).v1d = function (decoder) {
    var tmp0_desc = this.r5y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.x1g(tmp0_desc);
    if (tmp6_input.m1h()) {
      tmp4_local0 = tmp6_input.c1h(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.l1h(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.n1h(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.c1h(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.l1h(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.y1g(tmp0_desc);
    return ApiError_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_12).t1d = function () {
    return this.r5y_1;
  };
  protoOf($serializer_12).z1o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_12;
  function $serializer_getInstance_12() {
    if ($serializer_instance_12 == null)
      new $serializer_12();
    return $serializer_instance_12;
  }
  function ApiError_init_$Init$(seen0, errorCode, errorMessage, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_12().r5y_1);
    }
    extendThrowable($this);
    $this.t5y_1 = errorCode;
    $this.u5y_1 = errorMessage;
    return $this;
  }
  function ApiError_init_$Create$(seen0, errorCode, errorMessage, serializationConstructorMarker) {
    var tmp = ApiError_init_$Init$(seen0, errorCode, errorMessage, serializationConstructorMarker, objectCreate(protoOf(ApiError)));
    captureStack(tmp, ApiError_init_$Create$);
    return tmp;
  }
  function ApiError(errorCode, errorMessage) {
    extendThrowable(this, errorMessage);
    captureStack(this, ApiError);
    this.t5y_1 = errorCode;
    this.u5y_1 = errorMessage;
  }
  protoOf(ApiError).toString = function () {
    return 'ApiError(errorCode=' + this.t5y_1 + ', errorMessage=' + this.u5y_1 + ')';
  };
  protoOf(ApiError).hashCode = function () {
    var result = this.t5y_1;
    result = imul(result, 31) + (this.u5y_1 == null ? 0 : getStringHashCode(this.u5y_1)) | 0;
    return result;
  };
  protoOf(ApiError).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ApiError))
      return false;
    var tmp0_other_with_cast = other instanceof ApiError ? other : THROW_CCE();
    if (!(this.t5y_1 === tmp0_other_with_cast.t5y_1))
      return false;
    if (!(this.u5y_1 == tmp0_other_with_cast.u5y_1))
      return false;
    return true;
  };
  function validate(_this__u8e3s4) {
    _this__u8e3s4.e49(validate$slambda_0(null));
  }
  function validate$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(validate$slambda).i5z = function (cause, _unused_var__etf5q3, $completion) {
    var tmp = this.j5z(cause, _unused_var__etf5q3, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(validate$slambda).xg = function (p1, p2, $completion) {
    var tmp = p1 instanceof Error ? p1 : THROW_CCE();
    return this.i5z(tmp, (!(p2 == null) ? isInterface(p2, HttpRequest) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(validate$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 3;
            var tmp_0 = this;
            var tmp_1 = this.d5z_1;
            var tmp0_elvis_lhs = tmp_1 instanceof ResponseException ? tmp_1 : null;
            var tmp_2;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_2 = tmp0_elvis_lhs;
            }

            tmp_0.f5z_1 = tmp_2;
            this.k8_1 = 2;
            var tmp_3 = this;
            tmp_3.h5z_1 = this.f5z_1.z42_1;
            this.j8_1 = 1;
            var tmp_4 = this.h5z_1.h3x();
            var tmp_5 = JsType_instance;
            var tmp_6 = getKClass(ApiError);
            var tmp_7;
            try {
              tmp_7 = createKType(getKClass(ApiError), arrayOf([]), false);
            } catch ($p) {
              var tmp_8;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_8 = null;
              } else {
                throw $p;
              }
              tmp_7 = tmp_8;
            }

            suspendResult = tmp_4.l3w(typeInfoImpl(tmp_5, tmp_6, tmp_7), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs_0 = suspendResult instanceof ApiError ? suspendResult : null;
            var tmp_9 = this;
            var tmp_10;
            if (tmp0_elvis_lhs_0 == null) {
              throw new ApiError(-1, 'Empty body');
            } else {
              tmp_10 = tmp0_elvis_lhs_0;
            }

            tmp_9.g5z_1 = tmp_10;
            this.k8_1 = 3;
            this.j8_1 = 4;
            continue $sm;
          case 2:
            this.k8_1 = 3;
            var tmp_11 = this.m8_1;
            if (tmp_11 instanceof Exception) {
              var e = this.m8_1;
              var tmp_12 = this;
              tmp_12.g5z_1 = null;
              this.j8_1 = 4;
              continue $sm;
            } else {
              throw this.m8_1;
            }

          case 3:
            throw this.m8_1;
          case 4:
            this.k8_1 = 3;
            var errBody = this.g5z_1;
            if (!(errBody == null)) {
              throw errBody;
            } else {
              throw new ApiError(this.f5z_1.z42_1.u3n().k3l_1, 'Api call failed with ' + this.f5z_1.z42_1.u3n().toString() + ' cause = ' + this.d5z_1.toString());
            }

        }
      } catch ($p) {
        var e_0 = $p;
        if (this.k8_1 === 3) {
          throw e_0;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(validate$slambda).j5z = function (cause, _unused_var__etf5q3, completion) {
    var i = new validate$slambda(completion);
    i.d5z_1 = cause;
    i.e5z_1 = _unused_var__etf5q3;
    return i;
  };
  function validate$slambda_0(resultContinuation) {
    var i = new validate$slambda(resultContinuation);
    var l = function (cause, _unused_var__etf5q3, $completion) {
      return i.i5z(cause, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function MonitoringStorage() {
  }
  var WebApp_TLG_FEED_instance;
  var WebApp_TLG_FAV_FEED_instance;
  function values_2() {
    return [WebApp_TLG_FEED_getInstance(), WebApp_TLG_FAV_FEED_getInstance()];
  }
  function get_entries() {
    if ($ENTRIES == null)
      $ENTRIES = enumEntries(values_2());
    return $ENTRIES;
  }
  var WebApp_entriesInitialized;
  function WebApp_initEntries() {
    if (WebApp_entriesInitialized)
      return Unit_instance;
    WebApp_entriesInitialized = true;
    WebApp_TLG_FEED_instance = new WebApp('TLG_FEED', 0, 'tlg_feed');
    WebApp_TLG_FAV_FEED_instance = new WebApp('TLG_FAV_FEED', 1, 'tlg_fav_feed');
  }
  var $ENTRIES;
  function WebApp(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.m5z_1 = value;
  }
  function WebApp_TLG_FEED_getInstance() {
    WebApp_initEntries();
    return WebApp_TLG_FEED_instance;
  }
  function WebApp_TLG_FAV_FEED_getInstance() {
    WebApp_initEntries();
    return WebApp_TLG_FAV_FEED_instance;
  }
  function main() {
    initKoin();
    var tmp = document;
    tmp.addEventListener('DOMContentLoaded', main$lambda);
  }
  function MentionWebApp$renterPost$lambda($post) {
    return function (it) {
      showAddition($post.c5q_1.toString());
      return Unit_instance;
    };
  }
  function MentionWebApp() {
  }
  protoOf(MentionWebApp).o5z = function (post, body) {
    // Inline function 'kotlinx.html.js.div' call
    var this_0 = get_create(document);
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_1 = new DIV(attributesMapOf('class', 'widget'), this_0);
    if (!(this_1.n2i() === this_0)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_1.n2i().k2n(this_1);
    // Inline function 'kotlinx.html.visitAndFinalize.<anonymous>' call
    // Inline function 'kotlinx.html.js.div.<anonymous>' call
    this_1.n2i().m2n(this_1);
    var tmp = this_0.n2n();
    var container = tmp instanceof HTMLDivElement ? tmp : THROW_CCE();
    // Inline function 'kotlinx.html.js.script' call
    var this_2 = get_create(document);
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_3 = new SCRIPT(attributesMapOf_0(['type', null, 'src', null, 'crossorigin', null == null ? null : enumEncode(null)]), this_2);
    if (!(this_3.n2i() === this_2)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_3.n2i().k2n(this_3);
    // Inline function 'kotlinx.html.visitAndFinalize.<anonymous>' call
    // Inline function 'MentionWebApp.renterPost.<anonymous>' call
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.contracts.contract' call
    var $this$with = this_3.p2i();
    // Inline function 'kotlin.collections.set' call
    var value = 'https://telegram.org/js/telegram-widget.js?22';
    $this$with.b2('src', value);
    // Inline function 'kotlin.collections.set' call
    var key = 'data-telegram-post';
    var value_0 = post.g5q();
    $this$with.b2(key, value_0);
    var key_0 = 'data-width';
    $this$with.b2(key_0, '100%');
    this_3.n2i().m2n(this_3);
    var tmp_0 = this_2.n2n();
    var tlgPost = tmp_0 instanceof HTMLScriptElement ? tmp_0 : THROW_CCE();
    // Inline function 'kotlinx.html.js.button' call
    var this_4 = get_create(document);
    // Inline function 'kotlinx.html.visitAndFinalize' call
    var tmp_1 = null == null ? null : enumEncode(null);
    var tmp_2 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_5 = new BUTTON(attributesMapOf_0(['formenctype', tmp_1, 'formmethod', tmp_2, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', null]), this_4);
    if (!(this_5.n2i() === this_4)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_5.n2i().k2n(this_5);
    // Inline function 'kotlinx.html.visitAndFinalize.<anonymous>' call
    // Inline function 'MentionWebApp.renterPost.<anonymous>' call
    set_classes(this_5, setOf('button--small'));
    set_onClickFunction(this_5, MentionWebApp$renterPost$lambda(post));
    this_5.n2i().m2n(this_5);
    var tmp_3 = this_4.n2n();
    var moreBtn = tmp_3 instanceof HTMLButtonElement ? tmp_3 : THROW_CCE();
    var tmp6_$receiver = get_create(document);
    // Inline function 'kotlinx.html.js.a' call
    var href = post.e5q_1;
    var classes = 'button--big';
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_6 = new A(attributesMapOf_0(['href', href, 'target', null, 'class', classes]), tmp6_$receiver);
    if (!(this_6.n2i() === tmp6_$receiver)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_6.n2i().k2n(this_6);
    // Inline function 'kotlinx.html.visitAndFinalize.<anonymous>' call
    // Inline function 'MentionWebApp.renterPost.<anonymous>' call
    this_6.r2i('\u0421\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A');
    this_6.n2i().m2n(this_6);
    var tmp_4 = tmp6_$receiver.n2n();
    var showSourceBtn = tmp_4 instanceof HTMLAnchorElement ? tmp_4 : THROW_CCE();
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlinx.html.js.div' call
    var this_7 = get_create(document);
    var classes_0 = 'widget__buttons';
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_8 = new DIV(attributesMapOf('class', classes_0), this_7);
    if (!(this_8.n2i() === this_7)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_8.n2i().k2n(this_8);
    // Inline function 'kotlinx.html.visitAndFinalize.<anonymous>' call
    // Inline function 'kotlinx.html.js.div.<anonymous>' call
    this_8.n2i().m2n(this_8);
    var tmp_5 = this_7.n2n();
    var this_9 = tmp_5 instanceof HTMLDivElement ? tmp_5 : THROW_CCE();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'MentionWebApp.renterPost.<anonymous>' call
    this_9.append(showSourceBtn, moreBtn);
    var buttonsBlock = this_9;
    container.append(tlgPost, buttonsBlock);
    body.append(container);
  };
  function TlgFeedApplication$start$slambda$slambda(this$0, $posts, resultContinuation) {
    this.x5z_1 = this$0;
    this.y5z_1 = $posts;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TlgFeedApplication$start$slambda$slambda).l17 = function ($this$launch, $completion) {
    var tmp = this.m17($this$launch, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(TlgFeedApplication$start$slambda$slambda).m9 = function (p1, $completion) {
    return this.l17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TlgFeedApplication$start$slambda$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        if (tmp === 0) {
          this.k8_1 = 1;
          var this_0 = _get_kJson__fo4af6(this.x5z_1);
          var value = this.y5z_1;
          var this_1 = this_0.o1e();
          var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(TlgPost), arrayOf([]), false))]), false));
          var data = this_0.m1e(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), value);
          sendData(data);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(TlgFeedApplication$start$slambda$slambda).m17 = function ($this$launch, completion) {
    var i = new TlgFeedApplication$start$slambda$slambda(this.x5z_1, this.y5z_1, completion);
    i.z5z_1 = $this$launch;
    return i;
  };
  function TlgFeedApplication$start$slambda$slambda_0(this$0, $posts, resultContinuation) {
    var i = new TlgFeedApplication$start$slambda$slambda(this$0, $posts, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.l17($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function TlgFeedApplication$start$slambda$lambda($err) {
    return function () {
      return 'Tlg feed request fetch failed: ' + $err.message;
    };
  }
  function _get_kJson__fo4af6($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.b60_1;
    kJson$factory();
    return this_0.v();
  }
  function _get_tlgFeedRepository__ks8h0m($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.c60_1;
    tlgFeedRepository$factory();
    return this_0.v();
  }
  function _get_body__d4fd9l($this) {
    return ensureNotNull(document.body);
  }
  function TlgFeedApplication$kJson$delegate$lambda($this, $qualifier, $parameters) {
    return function () {
      // Inline function 'org.koin.core.component.get' call
      var this_0 = $this;
      var qualifier = $qualifier;
      var parameters = $parameters;
      var tmp;
      if (isInterface(this_0, KoinScopeComponent)) {
        // Inline function 'org.koin.core.scope.Scope.get' call
        tmp = this_0.r2f().g2i(getKClass(Json_0), qualifier, parameters);
      } else {
        // Inline function 'org.koin.core.Koin.get' call
        // Inline function 'org.koin.core.scope.Scope.get' call
        tmp = this_0.p2f().n2e_1.a2f_1.g2i(getKClass(Json_0), qualifier, parameters);
      }
      return tmp;
    };
  }
  function TlgFeedApplication$tlgFeedRepository$delegate$lambda($this, $qualifier, $parameters) {
    return function () {
      // Inline function 'org.koin.core.component.get' call
      var this_0 = $this;
      var qualifier = $qualifier;
      var parameters = $parameters;
      var tmp;
      if (isInterface(this_0, KoinScopeComponent)) {
        // Inline function 'org.koin.core.scope.Scope.get' call
        tmp = this_0.r2f().g2i(getKClass(TlgFeedRepository), qualifier, parameters);
      } else {
        // Inline function 'org.koin.core.Koin.get' call
        // Inline function 'org.koin.core.scope.Scope.get' call
        tmp = this_0.p2f().n2e_1.a2f_1.g2i(getKClass(TlgFeedRepository), qualifier, parameters);
      }
      return tmp;
    };
  }
  function TlgFeedApplication$start$slambda(this$0, resultContinuation) {
    this.l60_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TlgFeedApplication$start$slambda).l17 = function ($this$launch, $completion) {
    var tmp = this.m17($this$launch, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(TlgFeedApplication$start$slambda).m9 = function (p1, $completion) {
    return this.l17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TlgFeedApplication$start$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 3;
            sendLoading(true);
            this.j8_1 = 1;
            suspendResult = _get_tlgFeedRepository__ks8h0m(this.l60_1).i5q(this.l60_1.a60_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            this.j8_1 = 2;
            continue $sm;
          case 1:
            var unboxed = suspendResult.ch_1;
            suspendResult = new Result(unboxed);
            this.j8_1 = 2;
            continue $sm;
          case 2:
            var this_0 = suspendResult.ch_1;
            if (_Result___get_isSuccess__impl__sndoy8(this_0)) {
              var tmp_0 = _Result___get_value__impl__bjfvqg(this_0);
              var posts = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
              launch(this.m60_1, VOID, VOID, TlgFeedApplication$start$slambda$slambda_0(this.l60_1, posts, null));
              var tmp0_iterator = posts.g();
              while (tmp0_iterator.h()) {
                var element = tmp0_iterator.i();
                this.l60_1.o5z(element, _get_body__d4fd9l(this.l60_1));
              }
              sendError(false);
              sendLoading(false);
            }

            var tmp0_safe_receiver = Result__exceptionOrNull_impl_p6xea9(this_0);
            if (tmp0_safe_receiver == null)
              null;
            else {
              sendError(true);
              sendLoading(false);
              var tmp_1 = Napier_getInstance();
              tmp_1.j5i(VOID, VOID, TlgFeedApplication$start$slambda$lambda(tmp0_safe_receiver));
            }

            return Unit_instance;
          case 3:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 3) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(TlgFeedApplication$start$slambda).m17 = function ($this$launch, completion) {
    var i = new TlgFeedApplication$start$slambda(this.l60_1, completion);
    i.m60_1 = $this$launch;
    return i;
  };
  function TlgFeedApplication$start$slambda_0(this$0, resultContinuation) {
    var i = new TlgFeedApplication$start$slambda(this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.l17($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function TlgFeedApplication(id) {
    MentionWebApp.call(this);
    this.a60_1 = id;
    var tmp = this;
    // Inline function 'org.koin.core.component.inject' call
    var mode = KoinPlatformTools_instance.k2i();
    tmp.b60_1 = lazy(mode, TlgFeedApplication$kJson$delegate$lambda(this, null, null));
    var tmp_0 = this;
    // Inline function 'org.koin.core.component.inject' call
    var mode_0 = KoinPlatformTools_instance.k2i();
    tmp_0.c60_1 = lazy(mode_0, TlgFeedApplication$tlgFeedRepository$delegate$lambda(this, null, null));
  }
  protoOf(TlgFeedApplication).pj = function () {
    return Dispatchers_getInstance().nv_1.le(SupervisorJob());
  };
  protoOf(TlgFeedApplication).n5z = function () {
    launch(this, VOID, VOID, TlgFeedApplication$start$slambda_0(this, null));
  };
  function TlgFavApplication$start$slambda$slambda(this$0, $posts, resultContinuation) {
    this.v60_1 = this$0;
    this.w60_1 = $posts;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TlgFavApplication$start$slambda$slambda).l17 = function ($this$launch, $completion) {
    var tmp = this.m17($this$launch, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(TlgFavApplication$start$slambda$slambda).m9 = function (p1, $completion) {
    return this.l17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TlgFavApplication$start$slambda$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        if (tmp === 0) {
          this.k8_1 = 1;
          var this_0 = _get_kJson__fo4af6_0(this.v60_1);
          var value = this.w60_1;
          var this_1 = this_0.o1e();
          var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(TlgPost), arrayOf([]), false))]), false));
          var data = this_0.m1e(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), value);
          sendData(data);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(TlgFavApplication$start$slambda$slambda).m17 = function ($this$launch, completion) {
    var i = new TlgFavApplication$start$slambda$slambda(this.v60_1, this.w60_1, completion);
    i.x60_1 = $this$launch;
    return i;
  };
  function TlgFavApplication$start$slambda$slambda_0(this$0, $posts, resultContinuation) {
    var i = new TlgFavApplication$start$slambda$slambda(this$0, $posts, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.l17($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function TlgFavApplication$start$slambda$lambda($err) {
    return function () {
      return 'Tlg fav feed request fetch failed: ' + $err.message;
    };
  }
  function _get_kJson__fo4af6_0($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.y60_1;
    kJson$factory_0();
    return this_0.v();
  }
  function _get_getFavouriteTlgUseCase__jp9cj4($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.z60_1;
    getFavouriteTlgUseCase$factory();
    return this_0.v();
  }
  function _get_body__d4fd9l_0($this) {
    return ensureNotNull(document.body);
  }
  function TlgFavApplication$kJson$delegate$lambda($this, $qualifier, $parameters) {
    return function () {
      // Inline function 'org.koin.core.component.get' call
      var this_0 = $this;
      var qualifier = $qualifier;
      var parameters = $parameters;
      var tmp;
      if (isInterface(this_0, KoinScopeComponent)) {
        // Inline function 'org.koin.core.scope.Scope.get' call
        tmp = this_0.r2f().g2i(getKClass(Json_0), qualifier, parameters);
      } else {
        // Inline function 'org.koin.core.Koin.get' call
        // Inline function 'org.koin.core.scope.Scope.get' call
        tmp = this_0.p2f().n2e_1.a2f_1.g2i(getKClass(Json_0), qualifier, parameters);
      }
      return tmp;
    };
  }
  function TlgFavApplication$getFavouriteTlgUseCase$delegate$lambda($this, $qualifier, $parameters) {
    return function () {
      // Inline function 'org.koin.core.component.get' call
      var this_0 = $this;
      var qualifier = $qualifier;
      var parameters = $parameters;
      var tmp;
      if (isInterface(this_0, KoinScopeComponent)) {
        // Inline function 'org.koin.core.scope.Scope.get' call
        tmp = this_0.r2f().g2i(getKClass(GetFavouriteTlgUseCase), qualifier, parameters);
      } else {
        // Inline function 'org.koin.core.Koin.get' call
        // Inline function 'org.koin.core.scope.Scope.get' call
        tmp = this_0.p2f().n2e_1.a2f_1.g2i(getKClass(GetFavouriteTlgUseCase), qualifier, parameters);
      }
      return tmp;
    };
  }
  function TlgFavApplication$start$slambda(this$0, resultContinuation) {
    this.i61_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TlgFavApplication$start$slambda).l17 = function ($this$launch, $completion) {
    var tmp = this.m17($this$launch, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(TlgFavApplication$start$slambda).m9 = function (p1, $completion) {
    return this.l17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TlgFavApplication$start$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 3;
            sendLoading(true);
            this.j8_1 = 1;
            suspendResult = _get_getFavouriteTlgUseCase__jp9cj4(this.i61_1).n5j(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            this.j8_1 = 2;
            continue $sm;
          case 1:
            var unboxed = suspendResult.ch_1;
            suspendResult = new Result(unboxed);
            this.j8_1 = 2;
            continue $sm;
          case 2:
            var this_0 = suspendResult.ch_1;
            if (_Result___get_isSuccess__impl__sndoy8(this_0)) {
              var tmp_0 = _Result___get_value__impl__bjfvqg(this_0);
              var posts = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
              launch(this.j61_1, VOID, VOID, TlgFavApplication$start$slambda$slambda_0(this.i61_1, posts, null));
              var tmp0_iterator = posts.g();
              while (tmp0_iterator.h()) {
                var element = tmp0_iterator.i();
                this.i61_1.o5z(element, _get_body__d4fd9l_0(this.i61_1));
              }
              sendError(false);
              sendLoading(false);
            }

            var tmp0_safe_receiver = Result__exceptionOrNull_impl_p6xea9(this_0);
            if (tmp0_safe_receiver == null)
              null;
            else {
              sendError(true);
              sendLoading(false);
              var tmp_1 = Napier_getInstance();
              tmp_1.j5i(VOID, VOID, TlgFavApplication$start$slambda$lambda(tmp0_safe_receiver));
            }

            return Unit_instance;
          case 3:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 3) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(TlgFavApplication$start$slambda).m17 = function ($this$launch, completion) {
    var i = new TlgFavApplication$start$slambda(this.i61_1, completion);
    i.j61_1 = $this$launch;
    return i;
  };
  function TlgFavApplication$start$slambda_0(this$0, resultContinuation) {
    var i = new TlgFavApplication$start$slambda(this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.l17($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function TlgFavApplication() {
    MentionWebApp.call(this);
    var tmp = this;
    // Inline function 'org.koin.core.component.inject' call
    var mode = KoinPlatformTools_instance.k2i();
    tmp.y60_1 = lazy(mode, TlgFavApplication$kJson$delegate$lambda(this, null, null));
    var tmp_0 = this;
    // Inline function 'org.koin.core.component.inject' call
    var mode_0 = KoinPlatformTools_instance.k2i();
    tmp_0.z60_1 = lazy(mode_0, TlgFavApplication$getFavouriteTlgUseCase$delegate$lambda(this, null, null));
  }
  protoOf(TlgFavApplication).pj = function () {
    return Dispatchers_getInstance().nv_1.le(SupervisorJob());
  };
  protoOf(TlgFavApplication).n5z = function () {
    launch(this, VOID, VOID, TlgFavApplication$start$slambda_0(this, null));
  };
  function main$lambda(it) {
    var params = (new QueryParser()).k61(window.location.search);
    var tmp0_safe_receiver = params.y1('app');
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : first(tmp0_safe_receiver);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'main.<anonymous>.<anonymous>' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator = get_entries().g();
        while (tmp0_iterator.h()) {
          var element = tmp0_iterator.i();
          // Inline function 'main.<anonymous>.<anonymous>.<anonymous>' call
          if (element.m5z_1 === tmp1_safe_receiver) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp = tmp$ret$1;
    }
    var tmp0_elvis_lhs = tmp;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$('Invalid app');
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var app = tmp_0;
    var tmp2_safe_receiver = params.y1('id');
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : first(tmp2_safe_receiver);
    var tmp1_elvis_lhs = tmp3_safe_receiver == null ? null : toLong(tmp3_safe_receiver);
    var id = tmp1_elvis_lhs == null ? new Long(-1, -1) : tmp1_elvis_lhs;
    // Inline function 'kotlin.text.orEmpty' call
    var tmp4_safe_receiver = params.y1('acc');
    var tmp0_elvis_lhs_0 = tmp4_safe_receiver == null ? null : first(tmp4_safe_receiver);
    var acc = tmp0_elvis_lhs_0 == null ? '' : tmp0_elvis_lhs_0;
    WebConfiguration_instance.u5i_1 = acc;
    sendLoading(true);
    var tmp_1;
    switch (app.f2_1) {
      case 0:
        tmp_1 = new TlgFeedApplication(id);
        break;
      case 1:
        tmp_1 = new TlgFavApplication();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp_1.n5z();
    return Unit_instance;
  }
  function kJson$factory() {
    return getPropertyCallableRef('kJson', 1, KProperty1, function (receiver) {
      return _get_kJson__fo4af6(receiver);
    }, null);
  }
  function tlgFeedRepository$factory() {
    return getPropertyCallableRef('tlgFeedRepository', 1, KProperty1, function (receiver) {
      return _get_tlgFeedRepository__ks8h0m(receiver);
    }, null);
  }
  function kJson$factory_0() {
    return getPropertyCallableRef('kJson', 1, KProperty1, function (receiver) {
      return _get_kJson__fo4af6_0(receiver);
    }, null);
  }
  function getFavouriteTlgUseCase$factory() {
    return getPropertyCallableRef('getFavouriteTlgUseCase', 1, KProperty1, function (receiver) {
      return _get_getFavouriteTlgUseCase__jp9cj4(receiver);
    }, null);
  }
  function mainWrapper() {
    main();
  }
  function Companion_22() {
    this.l61_1 = '&';
    this.m61_1 = '=';
  }
  var Companion_instance_24;
  function Companion_getInstance_26() {
    return Companion_instance_24;
  }
  function QueryParser() {
  }
  protoOf(QueryParser).k61 = function (queryString) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = queryString.substring(1);
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = split(tmp$ret$1, ['&']);
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.mentions.shared.QueryParser.exec.<anonymous>' call
      var keyAndValueList = split(element, ['=']);
      // Inline function 'kotlin.takeIf' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp;
      // Inline function 'com.mentions.shared.QueryParser.exec.<anonymous>.<anonymous>' call
      if (keyAndValueList.j() === 2) {
        tmp = keyAndValueList;
      } else {
        tmp = null;
      }
      var tmp0_safe_receiver = tmp;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.e(tmp0_safe_receiver);
      }
    }
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_0 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = destination.g();
    while (tmp0_iterator_0.h()) {
      var element_0 = tmp0_iterator_0.i();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.mentions.shared.QueryParser.exec.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var key = element_0.p(0);
      // Inline function 'kotlin.collections.component2' call
      var value = element_0.p(1);
      // Inline function 'kotlin.takeIf' call
      // Inline function 'kotlin.text.trim' call
      var tmp$ret$10 = toString(trim(isCharSequence(value) ? value : THROW_CCE()));
      var this_1 = to(key, tmp$ret$10);
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0;
      // Inline function 'com.mentions.shared.QueryParser.exec.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(value)) {
        tmp_0 = this_1;
      } else {
        tmp_0 = null;
      }
      var tmp0_safe_receiver_0 = tmp_0;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_0.e(tmp0_safe_receiver_0);
      }
    }
    // Inline function 'kotlin.collections.groupByTo' call
    var destination_1 = LinkedHashMap_init_$Create$();
    var tmp0_iterator_1 = destination_0.g();
    while (tmp0_iterator_1.h()) {
      var element_1 = tmp0_iterator_1.i();
      // Inline function 'com.mentions.shared.QueryParser.exec.<anonymous>' call
      var key_0 = element_1.vd();
      var key_1 = key_0;
      // Inline function 'kotlin.collections.getOrPut' call
      var value_0 = destination_1.y1(key_1);
      var tmp_1;
      if (value_0 == null) {
        // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
        var answer = ArrayList_init_$Create$();
        destination_1.b2(key_1, answer);
        tmp_1 = answer;
      } else {
        tmp_1 = value_0;
      }
      var list = tmp_1;
      list.e(element_1);
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList_init_$Create$_0(destination_1.j());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_2 = destination_1.t().g();
    while (tmp0_iterator_2.h()) {
      var item = tmp0_iterator_2.i();
      // Inline function 'com.mentions.shared.QueryParser.exec.<anonymous>' call
      var tmp_2 = item.u();
      // Inline function 'kotlin.collections.map' call
      var this_2 = item.v();
      // Inline function 'kotlin.collections.mapTo' call
      var destination_3 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_2, 10));
      var tmp0_iterator_3 = this_2.g();
      while (tmp0_iterator_3.h()) {
        var item_0 = tmp0_iterator_3.i();
        // Inline function 'com.mentions.shared.QueryParser.exec.<anonymous>.<anonymous>' call
        var tmp$ret$24 = item_0.ud_1;
        destination_3.e(tmp$ret$24);
      }
      var tmp$ret$27 = to(tmp_2, destination_3);
      destination_2.e(tmp$ret$27);
    }
    return toMap(destination_2);
  };
  function get_platformModule() {
    _init_properties_Koin_js_kt__khuv18();
    return platformModule;
  }
  var platformModule;
  function initKoin() {
    _init_properties_Koin_js_kt__khuv18();
    initializeKoin(emptyList());
  }
  function platformModule$lambda($this$module) {
    _init_properties_Koin_js_kt__khuv18();
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition = platformModule$lambda$lambda;
    var scopeQualifier = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind = Kind_Singleton_getInstance();
    var secondaryTypes = emptyList();
    var def = new BeanDefinition(scopeQualifier, getKClass(HttpClient), null, definition, kind, secondaryTypes);
    var factory = new SingleInstanceFactory(def);
    $this$module.g2h(factory);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory);
    }
    new KoinDefinition($this$module, factory);
    // Inline function 'org.koin.core.module.Module.single' call
    var qualifier = named('SECURE_CLIENT');
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_0 = platformModule$lambda$lambda_0;
    var scopeQualifier_0 = Companion_getInstance().c2g_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_0 = Kind_Singleton_getInstance();
    var secondaryTypes_0 = emptyList();
    var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(HttpClient), qualifier, definition_0, kind_0, secondaryTypes_0);
    var factory_0 = new SingleInstanceFactory(def_0);
    $this$module.g2h(factory_0);
    if (false || $this$module.z2g_1) {
      $this$module.i2h(factory_0);
    }
    new KoinDefinition($this$module, factory_0);
    return Unit_instance;
  }
  function platformModule$lambda$lambda($this$single, it) {
    _init_properties_Koin_js_kt__khuv18();
    return provideHttpClient();
  }
  function platformModule$lambda$lambda_0($this$single, it) {
    _init_properties_Koin_js_kt__khuv18();
    return provideHttpClient();
  }
  var properties_initialized_Koin_js_kt_bn3b3y;
  function _init_properties_Koin_js_kt__khuv18() {
    if (!properties_initialized_Koin_js_kt_bn3b3y) {
      properties_initialized_Koin_js_kt_bn3b3y = true;
      platformModule = module_0(VOID, platformModule$lambda);
    }
  }
  function JsKtorLogger() {
    Napier_getInstance().c5i(new DebugAntilog());
  }
  protoOf(JsKtorLogger).l4w = function (message) {
    Napier_getInstance().h5i(message, VOID, 'JsHttpClient');
  };
  function provideHttpClient() {
    return provideJsHttpClient();
  }
  function provideJsHttpClient() {
    var tmp = Js_instance;
    return HttpClient_0(tmp, provideJsHttpClient$lambda);
  }
  function provideJsHttpClient$lambda($this$HttpClient) {
    defaultRequest($this$HttpClient, provideJsHttpClient$lambda$lambda);
    var tmp = Plugin_getInstance();
    $this$HttpClient.h3v(tmp, provideJsHttpClient$lambda$lambda_0);
    HttpResponseValidator($this$HttpClient, provideJsHttpClient$lambda$lambda_1);
    var tmp_0 = Companion_getInstance_2();
    $this$HttpClient.h3v(tmp_0, provideJsHttpClient$lambda$lambda_2);
    return Unit_instance;
  }
  function provideJsHttpClient$lambda$lambda($this$defaultRequest) {
    appendIfNameAbsent($this$defaultRequest.s42_1, 'X-Client', SharedModule_instance.t5i());
    appendIfNameAbsent($this$defaultRequest.s42_1, 'Authorization', 'Bearer ' + WebConfiguration_instance.u5i_1);
    return Unit_instance;
  }
  function provideJsHttpClient$lambda$lambda_0($this$install) {
    json($this$install, Json(VOID, provideJsHttpClient$lambda$lambda$lambda));
    return Unit_instance;
  }
  function provideJsHttpClient$lambda$lambda$lambda($this$Json) {
    $this$Json.h58_1 = true;
    $this$Json.i58_1 = true;
    $this$Json.r58_1 = false;
    return Unit_instance;
  }
  function provideJsHttpClient$lambda$lambda_1($this$HttpResponseValidator) {
    validate($this$HttpResponseValidator);
    return Unit_instance;
  }
  function provideJsHttpClient$lambda$lambda_2($this$install) {
    $this$install.a4y_1 = LogLevel_NONE_getInstance();
    $this$install.b4y(new JsKtorLogger());
    return Unit_instance;
  }
  //region block: post-declaration
  protoOf($serializer).a1p = typeParametersSerializers;
  protoOf($serializer_0).a1p = typeParametersSerializers;
  protoOf($serializer_1).a1p = typeParametersSerializers;
  protoOf($serializer_2).a1p = typeParametersSerializers;
  protoOf($serializer_3).a1p = typeParametersSerializers;
  protoOf($serializer_4).a1p = typeParametersSerializers;
  protoOf($serializer_5).a1p = typeParametersSerializers;
  protoOf($serializer_6).a1p = typeParametersSerializers;
  protoOf($serializer_7).a1p = typeParametersSerializers;
  protoOf(MonitorApiImpl).b5r = getMonitorFeed$default;
  protoOf($serializer_8).a1p = typeParametersSerializers;
  protoOf($serializer_9).a1p = typeParametersSerializers;
  protoOf($serializer_10).a1p = typeParametersSerializers;
  protoOf($serializer_11).a1p = typeParametersSerializers;
  protoOf($serializer_12).a1p = typeParametersSerializers;
  protoOf(TlgFeedApplication).p2f = getKoin;
  protoOf(TlgFavApplication).p2f = getKoin;
  //endregion
  //region block: init
  SharedModule_instance = new SharedModule();
  WebConfiguration_instance = new WebConfiguration();
  Companion_instance_3 = new Companion_1();
  Companion_instance_4 = new Companion_2();
  Companion_instance_5 = new Companion_3();
  Companion_instance_6 = new Companion_4();
  Companion_instance_9 = new Companion_7();
  Companion_instance_11 = new Companion_9();
  Companion_instance_14 = new Companion_12();
  Companion_instance_16 = new Companion_14();
  Companion_instance_18 = new Companion_16();
  Companion_instance_20 = new Companion_18();
  Companion_instance_21 = new Companion_19();
  Companion_instance_23 = new Companion_21();
  Companion_instance_24 = new Companion_22();
  //endregion
  mainWrapper();
  return _;
}));
